// Dutch — the default locale AND the source of truth for translation-key typing.
// Flat, dotted keys. `en.ts` must stay key-for-key in sync.
export const nl = {
  // Navigation
  'nav.beheer': 'Beheer',
  'nav.dashboard': 'Dashboard',
  'nav.users': 'Gebruikers',
  'nav.dataOwners': 'Partijen',

  // Environment badge / banner
  'env.local': 'Lokaal',
  'env.acceptance': 'Acceptatie',
  'env.production': 'Productie',
  'banner.local': 'Ontwikkelomgeving',
  'banner.acc': 'Acceptatieomgeving',
  'banner.note': 'gegevens hier staan los van productie',

  // App shell / user menu
  'nav.world.fuel': 'Brandstof',
  'nav.world.administration': 'Administratie',
  'shell.searchPlaceholder': 'Zoek in het systeem…',
  'shell.home': 'Van Hooft Transport — naar het startscherm',
  'shell.worlds': 'Werelden',
  'shell.modules': 'Modules',
  'shell.start': 'Start',
  'shell.skipToContent': 'Naar de inhoud',
  'shell.notifications': 'Notificaties',
  'shell.userMenu': 'Gebruikersmenu',
  'shortcuts.search': 'Zoeken',
  'shortcuts.world': 'Naar wereld 1 … 9',
  'shortcuts.module': 'Vorige / volgende module',
  'shortcuts.move': 'Bewegen binnen werelden of modules',
  'shortcuts.firstLast': 'Eerste / laatste',
  'shortcuts.close': 'Menu of zoeken sluiten',
  'shortcuts.list': 'Deze lijst',
  'user.profile': 'Profiel',
  'user.preferences': 'Voorkeuren',
  'user.language': 'Taal: Nederlands',
  'user.theme': 'Thema: {{value}}',
  'user.themeLight': 'Licht',
  'user.themeDark': 'Donker',
  'user.themeSystem': 'Systeem',
  'user.shortcuts': 'Sneltoetsen',
  'user.logout': 'Uitloggen',
  'user.releaseNotes': 'Release notes',

  // Beheer › Rechten (docs/auth.md, "Rechten per rol")
  'nav.permissions': 'Rechten',
  'permissions.title': 'Rechten',
  'permissions.subtitle':
    'Wat elke rol mag. Een wijziging telt vanaf de volgende klik, voor iedereen met die rol.',
  'permissions.floor':
    'Beheerder mag altijd alles. Gebruikers aanmaken en rollen uitdelen, portaaltoegang en dit scherm blijven bij Beheerder: wie toegang uitdeelt, is geen recht dat je kunt uitdelen.',
  'permissions.colRight': 'Recht',
  'permissions.adminAlways': 'Beheerder mag altijd alles',
  'permissions.pending_one': '{{count}} wijziging, nog niet opgeslagen',
  'permissions.pending_other': '{{count}} wijzigingen, nog niet opgeslagen',
  'permissions.noPending':
    'Een vinkje zet ook aan wat dat recht nodig heeft; uitzetten haalt weg wat erop steunt.',
  'permissions.saved': 'Rechten opgeslagen',
  'permissions.historyTitle': 'Laatste wijzigingen',
  'permissions.historyEmpty':
    'Nog niets gewijzigd sinds de rechten in VHT staan (12 oktober 2026).',
  'permissions.by': 'door {{name}}',
  'permission.coordination': 'Opdrachten en Instroom bekijken',
  'permission.coordination.hint': 'Dossiers, stations, fasen en de intake van Alfen',
  'permission.coordination_write': 'Opdrachten bijwerken',
  'permission.coordination_write.hint':
    'Status, fasen, documenten, werkzaamheden, leverdatum, KLIC, opnieuw verwerken',
  'permission.groundwork': 'Grondwerkrapporten bekijken',
  'permission.groundwork.hint': 'Wat Russcher via het portaal stuurde',
  'permission.groundwork_resend': 'Grondwerkrapport opnieuw versturen',
  'permission.additional_work_notice': 'Meerwerk vooraankondigen',
  'permission.additional_work_notice.hint':
    'Een brief voor Alfen en de netbeheerder na een schouw, als PDF',
  'permission.additional_work_notice_send': 'Meerwerk mailen naar Alfen Transport',
  'permission.additional_work_notice_send.hint': 'Namens Van Hooft, naar het adres van de omgeving',
  'permission.quotations': 'Offertes',
  'permission.quotations.hint': 'Maken, uitbrengen en versturen; ook de relaties en prospects',
  'permission.quotations_price_request': 'Prijsaanvragen maken',
  'permission.quotations_price_request.hint': 'Aan een collega-transporteur, vanuit een concept',
  'permission.quotations_settings': 'Offertelijsten beheren',
  'permission.quotations_settings.hint':
    'Kraantypes, artikelen en standaardteksten; ze raken ieders offerte',
  'permission.fuel': 'Brandstof bekijken',
  'permission.fuel.hint':
    'Tankingen, voertuigen, eigenaren, standplaatsen, leveranciers, emissiefactoren',
  'permission.fuel_write': 'Brandstof invoeren en wijzigen',
  'permission.staging': 'Klaarzetlijst bekijken',
  'permission.staging.hint': 'Met opmerkingen plaatsen',
  'permission.staging_stage': 'Klaarzetten: afvinken, foto en opruimen',
  'permission.staging_unstage_any': 'Afvinken van een ander terugdraaien',
  'permission.staging_unstage_any.hint': 'Je eigen afvinken terugdraaien kan altijd',
  'permission.staging_sms_numbers': 'Telefoonnummers in het verzendlog van de meldingen zien',
  'permission.staging_sms_numbers.hint': 'Anders gemaskeerd',
  'permission.loading_places_write': 'Laadplaatsen beheren',
  'permission.storage': 'Plattegronden bekijken',
  'permission.storage.hint': 'Met de Excel-export',
  'permission.storage_write': 'Plaatsen, verplaatsen en wijzigen',
  'permission.storage_write.hint': 'Toevoegen of verwijderen stuurt de boekingsmail',
  'permission.storage_admin': 'Plattegronden instellen en typen beheren',
  'permission.storage_dashboard': 'Het dashboard van Opslag bekijken',
  'permission.storage_dashboard.hint':
    'Voorraadverloop, verblijfsduur en datakwaliteit, voor het management',
  'permission.users': 'Gebruikers bekijken',
  'permission.users.hint': 'Wijzigen blijft bij Beheerder',
  'permission.users_notifications': 'Meldingsinstellingen van collega’s beheren',
  'permission.data_owners': 'Partijen bekijken',
  'permission.data_owners_write': 'Partijen beheren',
  'permission.data_owners_write.hint':
    'Naam, actief, externe codes; portaaltoegang blijft bij Beheerder',

  // Release notes (gebruikersmenu) — gegenereerd uit git door scripts/release-notes.mjs
  'releaseNotes.title': 'Release notes',
  'releaseNotes.summary': '{{count}} versies · de laatste is {{version}} van {{date}}',
  'releaseNotes.search': 'Zoek op een woord, onderdeel of versie',
  'releaseNotes.showOther': 'Ook documentatie en onderhoud',
  'releaseNotes.groupNew': 'Nieuw',
  'releaseNotes.groupFixed': 'Opgelost',
  'releaseNotes.groupOther': 'Documentatie en onderhoud',
  'releaseNotes.onlyOther': 'Alleen documentatie en onderhoud in deze versie.',
  'releaseNotes.noMatch': 'Niets gevonden.',
  'releaseNotes.scope.access': 'Rechten',
  'releaseNotes.scope.auth': 'Inloggen',
  'releaseNotes.scope.backoffice': 'Backoffice',
  'releaseNotes.scope.coordination': 'Coördinatie',
  'releaseNotes.scope.fuel': 'Brandstof',
  'releaseNotes.scope.groundwork': 'Grondwerk',
  'releaseNotes.scope.logistics': 'Klaarzetlijst',
  'releaseNotes.scope.map': 'Kaart',
  'releaseNotes.scope.portal': 'Portaal',
  'releaseNotes.scope.quotations': 'Offertes',
  'releaseNotes.scope.storage': 'Opslag',
  'releaseNotes.scope.ui': 'Vormgeving',
  'releaseNotes.scope.users': 'Gebruikers',

  // Login
  'login.title': 'Inloggen',
  'login.lede': 'Welkom terug. Kies hoe je inlogt.',
  'login.sso': 'Inloggen met Microsoft',
  'login.ssoNote': 'Voor medewerkers van Van Hooft — single sign-on.',
  'login.dividerPortal': 'of log in op het portaal',
  'login.email': 'E-mailadres',
  'login.emailPlaceholder': 'naam@bedrijf.nl',
  'login.password': 'Wachtwoord',
  'login.forgot': 'Wachtwoord vergeten?',
  'login.portal': 'Inloggen op het portaal',
  'login.helpRequest': 'Nog geen portaal-account? Neem contact met ons op.',
  'login.brandPayoff': 'Geen uitdaging',
  'login.brandPayoffAccent': 'te groot',
  'login.brandSub':
    'Voorop in innovatie en betrouwbaarheid. Onze krachtige en duurzame vloot staat garant voor schoon en efficiënt transport en hijswerk.',
  'login.footLocation': 'Hoevelaken',
  'login.footFleet': 'Emissieloze vloot',
  'login.footWork': 'Transport & hijswerk',
  'login.mockTitle': 'Ontwikkelmodus',
  'login.mockNote': 'Mock-auth actief. Kies een rol om in te loggen.',
  'login.mockLogin': 'Inloggen (mock)',

  // Common
  'common.search': 'Zoeken',
  'access.deniedTitle': 'Dit scherm is niet voor jouw rol',
  'access.deniedBody':
    'Je hebt toegang tot het platform, maar niet tot dit onderdeel. Klopt dat niet? Vraag een beheerder om de juiste rol.',
  'access.toDashboard': 'Naar het dashboard',
  'common.loading': 'Laden…',
  'common.error': 'Er ging iets mis.',
  'common.retry': 'Opnieuw',
  'common.save': 'Opslaan',
  'common.saving': 'Opslaan…',
  'common.saved': 'Opgeslagen',
  'common.cancel': 'Annuleren',
  'common.create': 'Aanmaken',
  'common.delete': 'Verwijderen',
  'common.close': 'Sluiten',
  'common.clear': 'Wissen',
  'common.active': 'Actief',
  'common.inactive': 'Inactief',
  'common.actions': 'Acties',
  'common.status': 'Status',
  'common.all': 'Alles',
  'common.never': 'Nooit',
  'common.results': '{{count}} resultaten',

  // Dashboard (landing)
  'dashboard.greeting': 'Welkom, {{name}}',
  'dashboard.subtitle': '{{date}}',
  'dashboard.asRole': 'Je werkt als {{roles}}.',
  'dashboard.noRole': 'Er zijn nog geen rollen aan je toegekend. Vraag een beheerder.',
  'dashboard.yourWork': 'Waar jij werkt',
  'dashboard.alsoAvailable': 'Verder beschikbaar',
  'dashboard.noWorkTitle': 'Jouw module wordt nog gebouwd',
  'dashboard.noWorkBody':
    'Het werk waar deze rol voor bestaat — planbord, offertes, coördinatie, brandstofbeheer — is nog niet opengesteld. Wat je nu al kunt inzien staat hieronder.',
  'dashboard.comingSoon': 'Binnenkort',
  'dashboard.previewTitle': 'Wat er aankomt',
  'dashboard.tile.planbord': 'Planbord',
  'dashboard.tile.planbordSub': 'Dagoverzicht van opdrachten, materieel en uitzonderingen',
  'dashboard.tile.offertes': 'Offertes',
  'dashboard.tile.offertesSub': 'Aanvragen en calculatie',
  'dashboard.tile.materieel': 'Materieel',
  'dashboard.tile.materieelSub': 'Kranen, diepladers en de emissieloze vloot',
  'dashboard.tile.chauffeurs': 'Chauffeurs',
  'dashboard.tile.chauffeursSub': 'Inzet en certificeringen',
  'dashboard.tile.co2': 'CO₂ & duurzaamheid',
  'dashboard.tile.co2Sub': 'Rapportage van de emissieloze inzet',

  // Users (Gebruikers)
  'users.title': 'Gebruikers',
  'users.subtitle': 'Beheer interne gebruikers en hun rollen.',
  'users.rolesMeta': 'Alleen beheer deelt rollen uit',
  'users.rolesReadOnly':
    'De rollen van deze gebruiker. Alleen een beheerder kan ze wijzigen — jij beheert het tabblad Meldingen.',
  'users.rolesLead':
    'Klik een rol aan of uit. Naam en e-mail komen uit Microsoft Entra en zijn hier niet te wijzigen.',
  'users.roleNoModule': 'Deze rol kan nog alleen meekijken',
  'users.roleNoModuleHint':
    'Gestippelde rollen zijn gewoon toe te kennen, maar het werk waar ze voor bestaan — planbord, offertes, coördinatie, brandstofbeheer — is nog niet opengesteld.',
  'users.new': 'Nieuwe gebruiker',
  'users.searchPlaceholder': 'Zoek op naam of e-mail…',
  'users.colName': 'Naam',
  'users.colEmail': 'E-mail',
  'users.colRoles': 'Rollen',
  'users.colStatus': 'Status',
  'users.colLastLogin': 'Laatste login',
  'users.empty': 'Nog geen gebruikers',
  'users.emptyHint': 'Voeg de eerste gebruiker toe of laat medewerkers via SSO inloggen.',
  'users.createTitle': 'Nieuwe gebruiker',
  'users.editTitle': 'Gebruiker bewerken',
  'users.fieldName': 'Naam',
  'users.fieldEmail': 'E-mailadres',
  'users.fieldRoles': 'Rollen',
  'users.fieldActive': 'Actief',
  'users.noRoles': 'Geen rollen',

  // Partijen (DataOwners)
  'relations.title': 'Relaties',
  'relations.subtitle': 'Waar een offerte heen gaat: uit TALIS, of een prospect',
  'relations.searchPlaceholder': 'Zoek op naam, code, plaats of contactpersoon',
  'relations.filterSource': 'Bron',
  'relations.source.TALIS': 'TALIS',
  'relations.source.VHT': 'Prospect',
  'relations.includeInactive': 'Ook inactieve',
  'relations.newProspect': 'Nieuwe prospect',
  'relations.editProspect': 'Prospect wijzigen',
  'relations.prospectHint':
    'Een bedrijf dat nog niet in TALIS staat. Een echte relatie maak je aan in Exact; als die via TALIS binnenkomt, koppel je de prospect eraan.',
  'relations.lookalikes': 'Staat deze relatie er al? Gevonden:',
  'relations.colName': 'Naam',
  'relations.colAddress': 'Adres',
  'relations.colContacts': 'Contactpersonen',
  'relations.colSource': 'Bron',
  'relations.noName': '(zonder naam)',
  'relations.empty': 'Nog geen relaties',
  'relations.noMatch': 'Geen relatie gevonden voor “{{q}}”',
  'relations.emptyHint':
    'Relaties komen uit TALIS. Staat een bedrijf er niet bij, maak dan een prospect aan.',
  'relations.page': 'pagina {{page}} van {{pages}}',
  'relations.prevPage': 'Vorige pagina',
  'relations.nextPage': 'Volgende pagina',
  'relations.talis.none':
    'Er zijn nog geen relaties uit TALIS ontvangen. De koppeling via DataBridge volgt; tot dan staan hier alleen testgegevens en prospects.',
  'relations.talis.last_one': 'Laatst bijgewerkt uit TALIS: {{when}} · {{count}} relatie',
  'relations.talis.last_other': 'Laatst bijgewerkt uit TALIS: {{when}} · {{count}} relaties',
  'relations.talis.prospects_one': '{{count}} prospect',
  'relations.talis.prospects_other': '{{count}} prospects',
  'relations.talis.rejected':
    'De laatste levering uit TALIS ({{when}}) is geweigerd. De relaties staan zoals ze daarvoor waren.',
  'relations.backToList': 'Alle relaties',
  'relations.origin': 'Herkomst',
  'relations.fromTalis': 'Uit TALIS, laatst ontvangen {{when}}',
  'relations.fromVht': 'Prospect, aangemaakt door {{who}} op {{when}}',
  'relations.talisReadOnly':
    'Deze relatie komt uit TALIS. Wijzigen gaat via Exact en TALIS; de koppeling neemt het dan over. Contactpersonen kun je hier wel toevoegen.',
  'relations.field.name': 'Naam',
  'relations.field.street': 'Adres',
  'relations.field.postcode': 'Postcode',
  'relations.field.city': 'Plaats',
  'relations.field.country': 'Land',
  'relations.field.phone': 'Telefoon',
  'relations.field.email': 'E-mail',
  'relations.emailInvalid': 'Dit is geen e-mailadres.',
  'relations.contacts.title': 'Contactpersonen',
  'relations.contacts.add': 'Contactpersoon toevoegen',
  'relations.contacts.edit': 'Contactpersoon wijzigen',
  'relations.contacts.fromVht': 'VHT',
  'relations.contacts.empty': 'Nog geen contactpersonen',
  'relations.contacts.emptyHint':
    'Voeg er een toe: een offerte gaat ter attentie van een contactpersoon.',
  'dataOwners.title': 'Partijen',
  'dataOwners.subtitle':
    'Opdrachtgevers en relaties. De code is de debiteurcode van Van Hooft en de vaste sleutel.',
  'dataOwners.new': 'Nieuwe partij',
  'dataOwners.searchPlaceholder': 'Zoek op naam of code…',
  'dataOwners.colCode': 'Code',
  'dataOwners.colName': 'Naam',
  'dataOwners.colExternal': 'Externe codes',
  'dataOwners.colStatus': 'Status',
  'dataOwners.empty': 'Nog geen partijen',
  'dataOwners.emptyHint': 'Voeg de eerste opdrachtgever toe.',
  'dataOwners.createTitle': 'Nieuwe partij',
  'dataOwners.editTitle': 'Partij bewerken',
  'dataOwners.fieldCode': 'Code',
  'dataOwners.fieldCodeHint': '2–20 tekens: hoofdletters, cijfers, - of _',
  'dataOwners.fieldName': 'Naam',
  'dataOwners.fieldActive': 'Actief',

  // Roles
  'role.admin': 'Beheerder',
  'role.planner': 'Planner',
  'role.werkvoorbereider': 'Werkvoorbereider',
  'role.logistiek': 'Logistiek',
  'role.administratie': 'Administratie',

  // Coördinatie-opdrachten
  'nav.coordination': 'Coördinatie',
  'nav.orders': 'Opdrachten',
  'orders.title': 'Opdrachten',
  'orders.subtitle': 'Coördinatie-dossiers — Alfen order-intake en ketenregie.',
  'orders.searchPlaceholder': 'Zoek op nummer, Alfen-order, dossier of netbeheerder…',
  'orders.colNumber': 'Opdracht',
  'orders.colAlfenOrder': 'Alfen-order',
  'orders.colDossier': 'Dossier',
  'orders.colBesteller': 'Netbeheerder',
  'orders.colStations': 'Stations',
  'orders.colStatus': 'Status',
  'orders.colCreated': 'Aangemaakt',
  'orders.empty': 'Nog geen opdrachten',
  'orders.emptyHint': 'Opdrachten verschijnen zodra Alfen ze via de intake aanlevert.',
  'orders.backToList': 'Terug naar opdrachten',
  'orders.copyNumber': 'Klik om te kopiëren',
  'orders.alfenOrder': 'Alfen-order',
  'orders.dossier': 'dossier',
  'orders.station': 'station',
  'orders.stations': 'stations',
  'orders.changeStatus': 'Status wijzigen',
  'orders.currentStatus': 'Huidige status',
  'orders.newStatus': 'Nieuwe status',
  'orders.pickStatus': 'Kies een status…',
  'orders.noTransitions': 'Geen volgende statussen mogelijk vanuit deze staat.',
  'orders.transitionReason': 'Reden (optioneel)',
  'orders.tabOverview': 'Overzicht',
  'orders.tabTimeline': 'Tijdlijn',
  'orders.noStations': 'Nog geen stations in dit dossier.',
  'orders.serviceObject': 'Serviceobject',
  'orders.partCode': 'Artikelcode',
  'orders.location': 'Werklocatie',
  'orders.desiredDate': 'Gewenste leverdatum',
  'orders.prodStatus': 'Productiestatus',
  'orders.timeline': 'Tijdlijn',
  'orders.timelineEmpty': 'Nog geen gebeurtenissen.',
  'orders.timelineOrder': 'Dossierstatus gewijzigd',
  'orders.timelineStep': 'Fase gewijzigd',
  'orders.timelineRetiredStep': '{{step}} · oude keten',
  'orders.parties': 'Partijen',
  'orders.debiteur': 'Debiteur',
  'orders.besteller': 'Netbeheerder',
  'orders.notLinked': 'niet gekoppeld',
  'orders.contact': 'Contact',
  'orders.vendor': 'Uitvoerder',
  'orders.actieVereist': 'Actie vereist',
  'orders.stepNote': 'Notitie',
  'orders.suggest': 'Voorstel',
  'orders.applySuggestion': 'Pas het afgeleide statusvoorstel toe',
  'orders.documentsTitle': 'Documenten',
  'orders.docsRequiredDone': 'vereiste documenten geleverd',
  'orders.addDocument': 'Document toevoegen',
  'orders.editDocument': 'Document bewerken',
  'orders.docType': 'Soort',
  'orders.docFileName': 'Bestandsnaam',
  'orders.docStatus': 'Status',
  'orders.docNoFile': 'zonder bestandsnaam',
  'orders.noDocuments': 'Nog geen documenten',
  // De documentenset (bouwlijst #5, coordination.md §15)
  'docType.CASEMAP': 'Casemap',
  'docType.SITUATIETEKENING': 'Situatietekening',
  'docType.FUNDATIEADVIES': 'Fundatieadvies',
  'docType.FUNDERINGSRAPPORT': 'Funderingsrapport',
  'docType.FUNDERINGSFOTOS': "Funderingsfoto's (PDF)",
  'docType.AARDINGSRAPPORT': 'Aardingsrapport',
  'docType.AARDINGSFOTOS': "Aardingsfoto's (PDF)",
  'docType.OPLEVERDOCUMENT': 'Opleverdocument',
  'docType.WATERTESTRAPPORT': 'Watertestrapport',
  'docType.WAPENINGRAPPORT': 'Wapeningrapport',
  'docType.VRACHTBRIEF': 'Vrachtbrief',
  'docType.BIJLAGE': 'Bijlage',
  'docType.SCHOUWFORMULIER': 'Schouwformulier',
  'docType.OVERIG': 'Overig',
  'docStatus.PENDING': 'In behandeling',
  'docStatus.VERIFIED': 'Geverifieerd',
  'docStatus.REJECTED': 'Afgekeurd',
  'docApproval.PENDING': 'Te accorderen',
  'docApproval.VERIFIED': 'Geaccordeerd',
  'docApproval.REJECTED': 'Afgekeurd',
  'documents.meta': '{{done}} van {{total}} vereist geleverd',
  'documents.group.PARTY': 'Voor de ketenpartijen',
  'documents.group.DELIVERABLE': 'Fase-opleveringen',
  'documents.group.ALFEN': 'Van Alfen',
  'documents.group.OTHER': 'Transport en overig',
  'documents.required': 'Vereist',
  'documents.requiredFor': 'vereist bij {{phase}}',
  'documents.optionalFor': 'welkom bij {{phase}}',
  'documents.neededFor': 'nodig voor {{phases}}',
  'documents.and': 'en',
  'documents.expectedFrom': 'verwacht van {{party}}',
  'documents.fromParty': 'van de uitvoerder, bij gereed melden',
  'documents.fromRide': 'uit de rit, na het lossen — telt na akkoord van VHT',
  'documents.fromVht': 'van VHT naar de partij',
  'documents.casemapRequired': 'vereist door {{party}}',
  'documents.casemapDue': 'uiterlijk {{date}} — {{weeks}} weken vóór de plaatsing',
  'documents.casemapLate': 'de termijn verliep {{date}} — {{weeks}} weken vóór de plaatsing',
  'documents.casemapNoDate': '{{weeks}} weken vóór de plaatsing — die is nog niet bekend',
  'documents.approve': 'Accorderen',
  'documents.reject': 'Afkeuren',
  'documents.approvalHint':
    'Een opleverdocument telt pas als VHT het accordeerde — daarna gaat het naar de besteller.',
  'documents.reviewedBy': '{{verdict}} door {{name}} · {{at}}',
  'documents.reviewedAt': '{{verdict}} · {{at}}',
  'documents.orderTitle': 'Orderbijlagen',
  'documents.orderEmpty': 'Nog geen orderbijlagen',
  'documents.addAttachment': 'Bijlage toevoegen',
  'documents.orderFoot':
    'Orderbijlagen horen bij het dossier, niet bij een station, en gaan met de order mee naar transport. Schouwformulieren zijn een eigen soort.',

  'status.dossier.INTAKE': 'Intake',
  'status.dossier.IN_COORDINATIE': 'In coördinatie',
  'status.dossier.GEREED_VOOR_PLAATSING': 'Gereed voor plaatsing',
  'status.dossier.GEPLAATST': 'Geplaatst',
  'status.dossier.AFGEROND': 'Afgerond',
  'status.dossier.IN_DE_WACHT': 'In de wacht',
  'status.dossier.GEANNULEERD': 'Geannuleerd',

  'status.step.TE_DOEN': 'Te doen',
  'status.step.GEPLAND': 'Gepland',
  'status.step.IN_UITVOERING': 'In uitvoering',
  'status.step.GEREED': 'Gereed',
  'status.step.GEBLOKKEERD': 'Geblokkeerd',
  'status.step.NVT': 'N.v.t.',
  'status.step.GEANNULEERD': 'Geannuleerd',

  // De vier fasen (docs/coordination.md §10) — de enum heet nog ChainStepType.
  'chainStep.SONDEREN': 'Sonderen',
  'chainStep.FUNDEREN': 'Funderen',
  'chainStep.PLAATSEN_STATION': 'Plaatsen',
  'chainStep.AARDING': 'Aarden',
  // De stappen van de oude keten, alleen nog om oude tijdlijnregels te benoemen.
  'retiredChainStep.VOORSCHOUW': 'Voorschouw',
  'retiredChainStep.KLIC_AANVRAAG': 'KLIC aanvragen',
  'retiredChainStep.LOCATIE_UITZETTEN': 'Locatie uitzetten',
  'retiredChainStep.LANDMETER_BEOORDELING': 'Landmeter-beoordeling',
  'retiredChainStep.RIJPLATEN': 'Rijplaten',
  'retiredChainStep.VERKEERSMAATREGELEN': 'Verkeersmaatregelen',
  'retiredChainStep.HEKWERK_PLAATSEN': 'Hekwerk plaatsen',
  'retiredChainStep.GRONDWERK': 'Grondwerk',
  'retiredChainStep.HEKWERK_VERWIJDEREN': 'Hekwerk verwijderen',

  // KLIC (bouwlijst #6, coordination.md §10.4) — meldingen uit Mister KLIC, via DataBridge.
  'klic.title': 'KLIC',
  'klic.meta_one': '{{count}} melding',
  'klic.meta_other': '{{count}} meldingen',
  'klic.link': 'Melding koppelen',
  'klic.linkTitle': 'KLIC-melding koppelen',
  'klic.linkIntro':
    'Meldingen die nog aan geen station hangen. Hieronder staan die waarvan de referentie naar dit dossier wijst. Zoek op meldnummer, referentie of adres voor de rest.',
  'klic.linkSearch': 'Zoek op meldnummer, referentie of adres…',
  'klic.linkNone': 'Geen meldingen zonder station die naar dit dossier wijzen.',
  'klic.linkNoMatch': 'Geen melding zonder station gevonden.',
  'klic.linkAction': 'Koppelen',
  'klic.linkHere': 'Aan dit station koppelen',
  'klic.matchedThisOrder': 'wijst naar dit dossier',
  'klic.unassigned':
    'Wijst naar dit dossier, maar hangt aan geen station. Tot je er een kiest, telt de melding nergens mee.',
  'klic.empty': 'Nog geen KLIC-melding voor dit station.',
  'klic.noNumber': 'zonder meldnummer',
  'klic.today': 'vandaag',
  'klic.digDate': 'graafdatum',
  'klic.digSource.expected': 'verwacht',
  'klic.digSource.due': 'gereed vóór',
  'klic.footDig':
    'De graafdatum komt van de fundering ({{source}}: {{date}}). Verschuift die, dan herrekent dit paneel mee.',
  'klic.footNoDig':
    'Nog geen graafdatum: de fundering is niet van toepassing, al gereed, of heeft nog geen datum.',
  'klic.footSource': 'Meldingen komen uit Mister KLIC, via DataBridge.',
  'klic.why.CLOSES_BEFORE_one':
    'Geldig, maar het venster sluit {{count}} dag vóór de graafdatum van {{date}}.',
  'klic.why.CLOSES_BEFORE_other':
    'Geldig, maar het venster sluit {{count}} dagen vóór de graafdatum van {{date}}.',
  'klic.why.OPENS_AFTER_one': 'Het venster opent pas {{count}} dag na de graafdatum van {{date}}.',
  'klic.why.OPENS_AFTER_other':
    'Het venster opent pas {{count}} dagen na de graafdatum van {{date}}.',
  'klic.why.OPEN_PRECAUTIONS_one':
    'Geldig op de graafdatum van {{date}}, maar {{count}} eis voorzorgsmaatregelen staat nog open. De netbeheerder eist die vóór er gegraven wordt.',
  'klic.why.OPEN_PRECAUTIONS_other':
    'Geldig op de graafdatum van {{date}}, maar {{count}} eisen voorzorgsmaatregelen staan nog open. De netbeheerder eist die vóór er gegraven wordt.',
  'klic.why.FAILED':
    'De melding is mislukt bij Mister KLIC. Er is geen geldige melding voor de graafdatum van {{date}}.',
  'klic.why.NONE': 'Er wordt gegraven op {{date}}, maar er is geen geldige KLIC-melding.',
  'klic.why.COVERED': 'Geldig op de graafdatum van {{date}}.',
  'klic.why.PENDING': 'Aangevraagd. Kan de graafdatum van {{date}} nog dekken.',
  'klic.precautionsMeta_one': '{{count}} voorzorgsmaatregel, {{open}} open',
  'klic.precautionsMeta_other': '{{count}} voorzorgsmaatregelen, {{open}} open',
  'klic.fileStored': 'leveringsbestand ontvangen',
  'klic.fileAwaited': 'leveringsbestand nog niet ontvangen',
  'klic.modalTitle': 'KLIC-melding',
  'klic.download': 'Leveringsbestand (.zip)',
  'klic.fieldViewer': 'Mister KLIC',
  'klic.openViewer': 'Openen in de kaartviewer',
  'klic.openViewerHint':
    'De melding in de kaartviewer van Mister KLIC. Daar moet je ingelogd zijn.',
  'klic.fieldState': 'Stand',
  'klic.fieldType': 'Type melding',
  'klic.fieldReference': 'Eigen referentie',
  'klic.fieldDescription': 'Omschrijving activiteit',
  'klic.fieldLocation': 'Locatie activiteit',
  'klic.fieldProject': 'Project',
  'klic.fieldValidFrom': 'Geldig van',
  'klic.fieldValidUntil': 'Geldig tot en met',
  'klic.fieldCreated': 'Aangemaakt in Mister KLIC',
  'klic.fieldRequested': 'Verzonden naar Kadaster',
  'klic.fieldDelivered': 'Data geleverd op',
  'klic.fieldFile': 'Leveringsbestand',
  'klic.fieldLinked': 'Koppeling',
  'klic.fieldReceived': 'Laatst ontvangen',
  'klic.linkedAuto': 'automatisch, uit de referentie · {{date}}',
  'klic.linkedBy': 'door {{name}} · {{date}}',
  'klic.notLinked': 'nog niet gekoppeld',
  'klic.precautions': 'Voorzorgsmaatregelen (EV)',
  'klic.precautionsNone': 'Geen eisen voorzorgsmaatregelen.',
  'klic.memo': 'Memo van VHT',
  'klic.memoPlaceholder': 'Bijvoorbeeld: fundeerder gebeld over de gasleiding',
  'klic.timelineLinked': 'KLIC-melding {{ref}} gekoppeld',
  'klic.timelineAuto': 'automatisch, uit de referentie',
  'klic.timelineStatus': 'KLIC-melding {{ref}}',
  'klicState.GELDIG': 'Geldig',
  'klicState.VERLOPEN': 'Verlopen',
  'klicState.MISLUKT': 'Mislukt',
  'klicState.GEPLAND': 'Gepland',
  'klicState.AANGEVRAAGD': 'Aangevraagd',
  'klicStatus.PLANNED': 'Gepland',
  'klicStatus.REQUESTED': 'Aangevraagd',
  'klicStatus.ACTIVE': 'Actief',
  'klicStatus.FAILED': 'Mislukt',
  'klicStatus.INACTIVE': 'Inactief',
  'klicType.GRAAFMELDING': 'Graafmelding',
  'klicType.CALAMITEITENMELDING': 'Calamiteitenmelding',
  'klicType.ORIENTATIEVERZOEK': 'Oriëntatieverzoek',
  'klicPrecautionStatus.UNCOMPLETED': 'Open',
  'klicPrecautionStatus.IN_PROGRESS': 'In behandeling',
  'klicPrecautionStatus.COMPLETED': 'Afgehandeld',

  'phases.title': 'Fasen',
  'phases.meta': '{{done}} van {{total}} gereed',
  'phases.colPhase': 'Fase · uitvoerder',
  'phases.colDue': 'Gereed vóór',
  'phases.colExpected': 'Verwacht',
  'phases.colCompleted': 'Gemeld',
  'phases.colDeliverable': 'Oplevering',
  'phases.colStand': 'Stand',
  'phases.details': 'Details',
  'phases.noExecutor': 'Nog geen uitvoerder toegewezen',
  'phases.notOrdered': 'Niet in de Alfen-order',
  'phases.transport': 'Transport VHT · interne overdracht, geen ketenpartij',
  'phases.refShort': 'ref',
  'phases.typeShort': 'type',
  'phases.na': 'n.v.t.',
  'phases.overdue': 'De afspraak is verstreken en de fase is niet gereed',
  'phases.foot':
    'Volgorde is richtlijn, geen blokkade. Elke standwijziging landt als gebeurtenis in de tijdlijn — dit paneel toont alleen waar we staan. Een fase klapt open met een klik.',
  'phases.edit': 'Fase bijwerken',
  'phases.noParty': 'Plaatsen voert transport zelf uit — er is geen ketenpartij om toe te wijzen.',
  // De acht velden per fase (bouwlijst #4, landscape.md §4a)
  'phases.deliverableOf.SONDEREN': 'Fundatieadvies',
  'phases.deliverableOf.FUNDEREN': "Rapport + foto's",
  'phases.deliverableOf.AARDING': 'Aardingsrapport',
  'phases.deliverableOf.PLAATSEN_STATION': 'Opleverdocument',
  'phases.deliverableMissing': '{{label}} ontbreekt',
  'phases.deliverableAwaiting': '{{label}} te accorderen',
  'phases.none': '—',
  'phases.stand': 'Stand',
  'phases.dueDate': 'Gereed vóór',
  'phases.expectedDate': 'Verwacht',
  'phases.expectedPlacement': 'Verwachte plaatsing',
  'phases.expectedPlacementFrom': 'afgeleid uit de {{source}}',
  'phases.expectedPlacementNone':
    'Afgeleid: de rit, dan de bevestigde leverdatum, dan de gewenste. Geen van drieën is bekend.',
  'phases.completedDate': 'Gereed gemeld',
  'phases.partyReference': 'Referentie van de partij',
  'phases.memo': 'Memo VHT',
  'phases.memoHelp': 'Voor de uitvoerder — die ziet deze memo.',
  'phases.memoHelpPlacement': 'De fundeerder en de aarder zien deze memo in hun planning.',
  'phases.partyRemark': 'Opmerking van de partij',
  'phases.accountability': 'Verantwoording afwijking',
  'phases.accountabilityWork': 'Meerwerk in plaats van redencode',
  'phases.reasonCode': 'Redencode',
  'phases.noReason': 'Geen redencode',
  'phases.foundationType': 'Type fundering',
  'phases.noFoundationType': 'Nog niet bekend',
  'phases.additionalWork': 'Meerwerk',
  'phases.workDescription': 'Omschrijving',
  'phases.workAmount': 'Bedrag (€, excl. btw)',
  'phases.workHelp': 'Kan ook ná gereed. Maak de omschrijving leeg om het meerwerk te verwijderen.',
  'phases.workReported': 'doorgegeven {{at}}',
  'phases.deliverable': 'Oplevering',
  'phases.inputs': 'Voor de partij',
  'phases.inputMissing': 'nog niet aanwezig',
  'phases.optional': 'optioneel',
  'phases.notYetDelivered': 'nog niet aangeleverd',
  'phases.missingAfterDone': 'ontbreekt — de fase is gereed, de oplevering nog niet',
  'phases.register': 'Registreren',
  'phases.whyTypeOk':
    'Gereed melden kan: het funderingstype staat op {{type}}. Bij NNTB blokkeert het systeem de melding tot het type bekend is.',
  'phases.whyNntb':
    'Gereed melden kan niet: het funderingstype staat op NNTB. Eerst moet bekend zijn hoe er gefundeerd wordt.',
  'phases.whyNoType': 'Gereed melden vraagt een funderingstype — zand, palen of stabilisatie.',
  'phases.needsCompletedDate': 'Gereed melden vraagt de dag waarop het gereed was.',
  'phases.completedInFuture': 'Die dag ligt nog in de toekomst.',
  'phases.otherReasonNeedsRemark':
    '"Andere reden" vraagt een toelichting in de opmerking van de partij.',
  'phases.amountInvalid': 'Het bedrag is geen geldig bedrag.',
  'phases.workNeedsDescription': 'Een bedrag zonder omschrijving is geen meerwerk.',
  'phases.manualFeedback':
    'De partij meldt nog niet zelf terug. Registreer hier wat zij doorgeeft.',
  'foundationType.ZAND': 'Zandfundatie',
  'foundationType.PALEN': 'Palenfundatie',
  'foundationType.STABIL': 'Stabilisatiefundatie',
  'foundationType.NNTB': 'NNTB · nog nader te bepalen',
  // De tien vertragingsredenen — één lijst (docs/coordination.md §8.7), zoals de portal ze noemt
  'delayReason.DOCUMENTEN_TE_LAAT': 'Benodigde documenten te laat',
  'delayReason.LOCATIE_TE_LAAT_GEWIJZIGD': 'Locatie te laat gewijzigd',
  'delayReason.BOUWPLAATS_ONGESCHIKT': 'Bouwplaats ongeschikt',
  'delayReason.TOELEVERING_TE_LAAT': 'Toelevering te laat',
  'delayReason.VERTRAGING_PRODUCTIE': 'Vertraging tijdens productie',
  'delayReason.VERTRAGING_SONDATIE': 'Vertraging tijdens sondatie',
  'delayReason.VERTRAGING_FUNDATIE': 'Vertraging tijdens fundatie',
  'delayReason.VERTRAGING_TRANSPORT': 'Vertraging tijdens transport',
  'delayReason.VERZOEK_KLANT': 'Verzoek van de klant',
  'delayReason.ANDERE_REDEN': 'Andere reden',

  // Werkzaamheden (docs/coordination.md §10.3, §14.2)
  'workItems.title': 'Werkzaamheden',
  'workItems.meta': '{{setOut}} van {{total}} uitgezet',
  'workItems.metaNotNeeded': '{{count}} niet nodig',
  'workItems.setOut': 'Uitzetten',
  'workItems.setOutTitle': 'Werkzaamheid uitzetten',
  'workItems.notSetOut': 'Nog niet uitgezet',
  'workItems.setOutBy': 'Uitgezet {{date}} door {{name}}',
  'workItems.setOutOn': 'Uitgezet {{date}}',
  'workItems.notNeededBy': 'Niet nodig · besloten door {{name}} op {{date}}',
  'workItems.notNeededOn': 'Niet nodig · besloten op {{date}}',
  'workItems.nvt': 'N.v.t.',
  'workItems.twoLegs': 'één werkzaamheid, twee benen',
  'workItems.plannedOn': 'gepland {{date}}',
  'workItems.doneOn': 'uitgevoerd {{date}}',
  'workItems.daysOpen_one': '{{count}} dag open',
  'workItems.daysOpen_other': '{{count}} dagen open',
  'workItems.foot':
    'Een werkzaamheid bestaat pas als iemand hem uitzet. Gestippeld = nog niet uitgezet; grijs = expliciet niet nodig, met wie dat besloot. De stand komt van transport.',
  'workItems.kind': 'Soort',
  'workItems.note': 'Toelichting',
  'workItems.notePlaceholder': 'Wat er wordt uitgezet — of waarom het niet nodig is',
  'workItems.notNeeded': 'Niet nodig',
  'workItems.setOutAnyway': 'Toch uitzetten',
  'workItems.legStatus': 'Stand',
  'workItems.legDate': 'Datum',
  'workItems.executor': 'Uitvoerder',
  'workItems.executorPlaceholder': 'Eigen ploeg of een derde',
  'workItems.manualFeedback':
    'Transport meldt de stand nog niet vanzelf terug. Registreer hier wat de planning doorgeeft.',
  'workItems.dateRequired': 'Een gepland of uitgevoerd been heeft een datum nodig.',
  'workItems.notNeededBlocked':
    'Niet nodig kan niet meer: transport heeft hem al gepland of uitgevoerd. Annuleer eerst de benen.',
  'workItems.timelineSetOut': '{{kind}} uitgezet',
  'workItems.timelineNotNeeded': '{{kind}} niet nodig',
  'workItems.timelineLeg': '{{kind}} · {{leg}}',
  'workItemKind.VOORSCHOUW': 'Voorschouw',
  'workItemKind.LOCATIE_UITZETTEN': 'Locatie uitzetten',
  'workItemKind.RIJPLATEN': 'Rijplaten',
  'workItemKind.VERKEERSMAATREGELEN': 'Verkeersmaatregelen (TVM)',
  'workItemKind.BOUWHEKKEN': 'Bouwhekken',
  'workItemKind.GRONDWERK': 'Grondwerk',
  'workItemLeg.UITVOEREN': 'Uitvoeren',
  'workItemLeg.PLAATSEN': 'Plaatsen',
  'workItemLeg.OPHALEN': 'Ophalen',
  'workItemLegStatus.NIET_GEPLAND': 'Niet gepland',
  'workItemLegStatus.GEPLAND': 'Gepland',
  'workItemLegStatus.UITGEVOERD': 'Uitgevoerd',
  'workItemLegStatus.GEANNULEERD': 'Geannuleerd',
  'workItemStand.NIET_GEPLAND': 'Niet gepland',
  'workItemStand.GEPLAND': 'Gepland',
  'workItemStand.OP_LOCATIE': 'Op locatie',
  'workItemStand.UITGEVOERD': 'Uitgevoerd',
  'workItemStand.GEANNULEERD': 'Geannuleerd',

  // Instroom (intake queue)
  'nav.intake': 'Instroom',
  'intake.title': 'Instroom',
  'intake.subtitle': 'Order-intake vanuit Alfen — berichten, verwerking en herverwerking.',
  'intake.searchPlaceholder': 'Zoek op bericht-id…',
  'intake.colId': 'Bericht-id',
  'intake.colType': 'Type',
  'intake.colStatus': 'Status',
  'intake.colOrder': 'Opdracht',
  'intake.colReceived': 'Ontvangen',
  'intake.empty': 'Nog geen berichten',
  'intake.emptyHint': 'Berichten verschijnen zodra Alfen orders aanlevert.',
  'intake.status.RECEIVED': 'Ontvangen',
  'intake.status.PROCESSED': 'Verwerkt',
  'intake.status.DUPLICATE': 'Duplicaat',
  'intake.status.FAILED': 'Mislukt',
  'intake.details': 'Details',
  'intake.replay': 'Opnieuw verwerken',
  'intake.detailTitle': 'Intake-bericht',
  'intake.rawPayload': 'Payload',
  'intake.errorLabel': 'Foutmelding',
  'intake.correlationId': 'Correlatie-id',
  'intake.linkedOrder': 'Gekoppelde opdracht',

  // ── Brandstofbeheer (fuel) — Fase A: stamdata ──
  'nav.fuel': 'Brandstofbeheer',
  'nav.fuelEntries': 'Brandstof invoer',
  'nav.fuelVehicles': 'Voertuigen',
  'nav.fuelOwners': 'Eigenaren',
  'nav.fuelHomebases': 'Standplaatsen',
  'nav.fuelSuppliers': 'Leveranciers',
  'nav.fuelEmissionFactors': 'Emissiefactoren',

  'fuel.saved': 'Opgeslagen',
  'fuel.fieldStreet': 'Straat en huisnummer',
  'fuel.fieldPostcode': 'Postcode',
  'fuel.fieldPlace': 'Plaats',
  'fuel.fieldEmail': 'E-mailadres',
  'fuel.fieldPhone': 'Telefoon',

  'fuel.fuelType.DIESEL_B7': 'Diesel B7',
  'fuel.fuelType.HVO100': 'HVO100',
  'fuel.fuelType.BENZINE_E10': 'Benzine E10',
  'fuel.fuelType.ADBLUE': 'AdBlue',
  'fuel.fuelType.ELEKTRA': 'Elektra',

  // Voertuigen
  'fuel.vehicles.title': 'Voertuigen',
  'fuel.vehicles.subtitle': 'Voertuigstamdata voor brandstofregistratie, verbruik en CO₂.',
  'fuel.vehicles.new': 'Nieuw voertuig',
  'fuel.vehicles.searchPlaceholder': 'Kenteken, naam of code…',
  'fuel.vehicles.allFuels': 'Alle brandstoffen',
  'fuel.vehicles.empty': 'Nog geen voertuigen',
  'fuel.vehicles.emptyHint': 'Voeg een voertuig toe of wacht op de TMS-koppeling.',
  'fuel.vehicles.backToList': 'Terug naar voertuigen',
  'fuel.vehicles.colCode': 'VH-code',
  'fuel.vehicles.colPlate': 'Kenteken',
  'fuel.vehicles.colName': 'Naam',
  'fuel.vehicles.colCategory': 'Categorie',
  'fuel.vehicles.colOwner': 'Eigendom',
  'fuel.vehicles.colFuel': 'Brandstof',
  'fuel.vehicles.colInUse': 'In gebruik',
  'fuel.vehicles.colRdw': 'RDW',
  'fuel.vehicles.rdwChecked': 'Opgehaald',
  'fuel.vehicles.rdwUnchecked': 'Niet opgehaald',
  'fuel.vehicles.createTitle': 'Nieuw voertuig',
  'fuel.vehicles.fieldPlate': 'Kenteken',
  'fuel.vehicles.fieldPlateHint': 'Streepjes mogen — het kenteken wordt genormaliseerd.',
  'fuel.vehicles.fieldName': 'Naam',
  'fuel.vehicles.fieldCode': 'VH-code',
  'fuel.vehicles.fieldCodeHint': 'Materieelcode uit TALIS, indien bekend.',
  'fuel.vehicles.fieldGroup': 'Groep',
  'fuel.vehicles.fieldOwner': 'Eigenaar',
  'fuel.vehicles.noOwner': 'Geen eigenaar',
  'fuel.vehicles.fieldHomebase': 'Standplaats',
  'fuel.vehicles.noHomebase': 'Geen standplaats',
  'fuel.vehicles.chooseHomebase': 'Kies een standplaats…',
  'fuel.vehicles.tab.algemeen': 'Algemeen',
  'fuel.vehicles.tab.adblue': 'AdBlue',
  'fuel.vehicles.tab.broncodes': 'Broncodes',
  'fuel.vehicles.tab.homebase': 'Standplaats',
  'fuel.vehicles.tab.rdw': 'RDW',
  'fuel.vehicles.fieldFuels': 'Brandstoffen',
  'fuel.vehicles.fieldFuelsHint': 'Welke brandstoffen dit voertuig tankt — stuurt de invoerkeuze.',
  'fuel.vehicles.fieldTankVolume': 'Max. tankvolume',
  'fuel.vehicles.fieldNorm': 'Normverbruik',
  'fuel.vehicles.fieldNormHint': 'Referentie voor de verbruikscontrole bij invoer.',
  'fuel.vehicles.fieldTolerance': 'Tolerantie',
  'fuel.vehicles.fieldToleranceHint': 'Afwijking op de norm voordat er gewaarschuwd wordt.',
  'fuel.vehicles.fieldInUseFrom': 'In gebruik vanaf',
  'fuel.vehicles.fieldInUseTo': 'Einde gebruik',
  'fuel.vehicles.adBlueExplainer':
    'AdBlue is een reductiemiddel, geen brandstof: de uitstoot tijdens gebruik (TTW) is nul. De km-stand van een AdBlue-tanking wordt standaard overgenomen van de dieseltanking op dezelfde dag.',
  'fuel.vehicles.fieldTanksAdBlue': 'Dit voertuig tankt AdBlue',
  'fuel.vehicles.fieldAdBlueNorm': 'AdBlue-norm',
  'fuel.vehicles.fieldAdBlueNormHint': 'Verwacht AdBlue-verbruik als percentage van de diesel.',
  'fuel.vehicles.sourceTitle': 'Herkomst en broncodes',
  'fuel.vehicles.sourceExplainer':
    'Deze velden komen uit het bronsysteem en worden hier niet bewerkt. VHT leest ze; per strangler-stap wordt VHT de schrijver.',
  'fuel.vehicles.fieldSource': 'Bron',
  'fuel.vehicles.fieldExternalRef': 'Bron-referentie',
  'fuel.vehicles.fieldGroupCode': 'Groepscode',
  'fuel.vehicles.fieldTypeTalis': 'Type (TALIS)',
  'fuel.vehicles.fieldFuelTalis': 'Brandstof (TALIS)',
  'fuel.vehicles.fieldSnapshot': 'Bron-snapshot',
  'fuel.vehicles.snapshotPresent': 'Aanwezig',
  'fuel.vehicles.snapshotAbsent': 'Nog geen snapshot',
  'fuel.vehicles.fieldCreated': 'Aangemaakt',
  'fuel.vehicles.fieldUpdated': 'Laatst gewijzigd',
  'fuel.vehicles.move': 'Verplaatsen',
  'fuel.vehicles.moveTitle': 'Voertuig verplaatsen',
  'fuel.vehicles.fieldMoveFrom': 'Verplaatsing per',
  'fuel.vehicles.fieldMoveFromHint': 'De huidige toewijzing wordt op deze datum afgesloten.',
  'fuel.vehicles.noAssignments': 'Nog geen standplaatshistorie',
  'fuel.vehicles.noAssignmentsHint': 'Wijs het voertuig toe aan een standplaats.',
  'fuel.vehicles.rdwTitle': 'RDW-gegevens',
  'fuel.vehicles.rdwFetch': 'Ophalen bij RDW',
  'fuel.vehicles.rdwFetching': 'Bezig met ophalen…',
  'fuel.vehicles.rdwCheckedAt': 'Laatst opgehaald {{at}}',
  'fuel.vehicles.rdwNeverChecked': 'Nog niet opgehaald',
  'fuel.vehicles.rdwNotFound': 'Het RDW-register kent kenteken {{plate}} niet.',
  'fuel.vehicles.rdwNoChanges': 'Opgehaald — de gegevens waren al actueel.',
  'fuel.vehicles.rdwUpdated': 'Opgehaald — {{count}} veld(en) bijgewerkt.',
  'fuel.vehicles.rdwExplainer':
    'Deze gegevens komen uit het open register van de RDW en worden op kenteken opgehaald. Waar de RDW niets weet, blijft de bestaande waarde staan.',
  'fuel.vehicles.fieldBrand': 'Merk',
  'fuel.vehicles.fieldModel': 'Handelsbenaming',
  'fuel.vehicles.fieldCategory': 'Voertuigcategorie',
  'fuel.vehicles.fieldEuronorm': 'Euronorm',
  'fuel.vehicles.fieldEmptyMass': 'Massa leeg',
  'fuel.vehicles.fieldMaxMass': 'Toegestane max. massa',
  'fuel.vehicles.fieldPayload': 'Laadvermogen',
  'fuel.vehicles.fieldFirstAdmission': 'Eerste toelating',
  'fuel.vehicles.fieldFuelRdw': 'Brandstof (RDW)',

  // Eigenaren
  'fuel.owners.title': 'Eigenaren',
  'fuel.owners.new': 'Nieuwe eigenaar',
  'fuel.owners.searchPlaceholder': 'Naam, plaats of KvK…',
  'fuel.owners.empty': 'Nog geen eigenaren',
  'fuel.owners.emptyHint': 'Voeg de eerste eigenaar toe.',
  'fuel.owners.colName': 'Naam',
  'fuel.owners.colType': 'Type',
  'fuel.owners.colKvk': 'KvK',
  'fuel.owners.colPlace': 'Plaats',
  'fuel.owners.colVehicles': 'Voertuigen',
  'fuel.owners.createTitle': 'Nieuwe eigenaar',
  'fuel.owners.editTitle': 'Eigenaar bewerken',
  'fuel.owners.fieldName': 'Bedrijfsnaam',
  'fuel.owners.fieldType': 'Type eigenaar',
  'fuel.owners.fieldTypeHint': 'Bijvoorbeeld eigen bezit, lease of charter.',
  'fuel.owners.fieldKvk': 'KvK-nummer',
  'fuel.owners.fieldContact': 'Contactpersoon',

  // Standplaatsen
  'fuel.homebases.title': 'Standplaatsen',
  'fuel.homebases.editThis': 'Standplaats bewerken',
  'fuel.homebases.new': 'Nieuwe standplaats',
  'fuel.homebases.searchPlaceholder': 'Naam of plaats…',
  'fuel.homebases.empty': 'Nog geen standplaatsen',
  'fuel.homebases.emptyHint': 'Voeg de eerste standplaats toe.',
  'fuel.homebases.colName': 'Naam',
  'fuel.homebases.colType': 'Type',
  'fuel.homebases.colAddress': 'Adres',
  'fuel.homebases.colCoords': 'Coördinaten',
  'fuel.homebases.colVehiclesNow': 'Voertuigen nu',
  'fuel.homebases.coordsMissing': 'Ontbreekt',
  'fuel.homebases.coordsMissingHint': 'Coördinaten zijn nodig voor de CO₂-context.',
  'fuel.homebases.coordsHelp': 'Decimale graden (WGS84), bijvoorbeeld 52,164 en 5,452.',
  'fuel.homebases.createTitle': 'Nieuwe standplaats',
  'fuel.homebases.editTitle': 'Standplaats bewerken',
  'fuel.homebases.fieldName': 'Naam',
  'fuel.homebases.fieldType': 'Type',
  'fuel.homebases.fieldTypeHint': 'Bijvoorbeeld vestiging, depot of thuisadres.',
  'fuel.homebases.fieldLat': 'Breedtegraad',
  'fuel.homebases.fieldLon': 'Lengtegraad',
  'fuel.homebases.assignmentsFor': 'Toewijzingen — {{name}}',
  'fuel.homebases.colVehicle': 'Voertuig',
  'fuel.homebases.colFrom': 'Van',
  'fuel.homebases.colTo': 'Tot',
  'fuel.homebases.current': 'Actueel',
  'fuel.homebases.past': 'Historie',
  'fuel.homebases.mapTitle': 'Kaart',
  'fuel.homebases.mapHint': 'Klik een marker om de standplaats te selecteren.',
  'fuel.homebases.mapNoPoints':
    'Nog geen standplaats met coördinaten — vul ze in of haal ze op via het adres.',
  'fuel.homebases.mapUnavailable':
    'De kaart is niet ingesteld voor deze omgeving. Zonder HERE-sleutel blijft de rest van het scherm gewoon werken.',
  'fuel.homebases.geocode': 'Coördinaten zoeken',
  'fuel.homebases.geocodeBusy': 'Zoeken…',
  'fuel.homebases.geocodeNeedsAddress': 'Vul eerst een adres, postcode of plaats in.',
  'fuel.homebases.geocodeNoResult':
    'Geen adres gevonden. Controleer de spelling of vul de coördinaten handmatig in.',
  'fuel.homebases.geocodeExact': 'Exact',
  'fuel.homebases.geocodeApprox': 'Bij benadering',
  'fuel.homebases.noAssignments': 'Geen toewijzingen',
  'fuel.homebases.noAssignmentsHint': 'Er staan nog geen voertuigen op deze standplaats.',

  // Leveranciers
  'fuel.suppliers.title': 'Leveranciers',
  'fuel.suppliers.subtitle': 'Tankleveranciers — keuzelijst bij de brandstofinvoer.',
  'fuel.suppliers.new': 'Nieuwe leverancier',
  'fuel.suppliers.searchPlaceholder': 'Naam of plaats…',
  'fuel.suppliers.empty': 'Nog geen leveranciers',
  'fuel.suppliers.emptyHint': 'Voeg de eerste leverancier toe.',
  'fuel.suppliers.colName': 'Naam',
  'fuel.suppliers.colType': 'Type',
  'fuel.suppliers.createTitle': 'Nieuwe leverancier',
  'fuel.suppliers.editTitle': 'Leverancier bewerken',
  'fuel.suppliers.fieldName': 'Naam',
  'fuel.suppliers.fieldType': 'Type',
  'fuel.suppliers.fieldTypeHint': 'Bijvoorbeeld tankstation, eigen tank of pas.',

  // Emissiefactoren
  'fuel.emissionFactors.title': 'Emissiefactoren',
  'fuel.emissionFactors.searchPlaceholder': 'Omschrijving of code…',
  'fuel.emissionFactors.allCategories': 'Alle categorieën',
  'fuel.emissionFactors.operationalOnly': 'Alleen operationele brandstoffen',
  'fuel.emissionFactors.empty': 'Geen emissiefactoren',
  'fuel.emissionFactors.emptyHint': 'Draai de seed om de factorencatalogus te vullen.',
  'fuel.emissionFactors.colDescription': 'Omschrijving',
  'fuel.emissionFactors.colCode': 'Code',
  'fuel.emissionFactors.colCategory': 'Categorie',
  'fuel.emissionFactors.colYear': 'Jaar',
  'fuel.emissionFactors.colTtw': 'TTW',
  'fuel.emissionFactors.colWtt': 'WTT',
  'fuel.emissionFactors.colWtw': 'WTW',
  'fuel.emissionFactors.colUnit': 'Eenheid',
  'fuel.emissionFactors.colValid': 'Geldig',
  'fuel.emissionFactors.colSource': 'Bron',
  'fuel.emissionFactors.editTitle': 'Emissiefactor corrigeren',
  'fuel.emissionFactors.wtwMismatch': 'WTW moet gelijk zijn aan TTW + WTT ({{sum}}).',
  'fuel.emissionFactors.sourceNote': 'Bron: COFRET · emissiefactoren.nl — jaarlijks bijgewerkt.',

  // Brandstof invoer (Fase B)
  'fuel.entries.title': 'Brandstof invoer',
  'fuel.entries.subtitle': 'Tankingen registreren met verplichte km-stand-controle.',
  'fuel.entries.new': 'Nieuwe tanking',
  'fuel.entries.bulk': 'Bulk invoeren',
  'fuel.entries.searchVehicle': 'Zoek een voertuig…',
  'fuel.entries.allVehicles': 'Alle voertuigen',
  'fuel.entries.empty': 'Nog geen tankingen',
  'fuel.entries.emptyHint': 'Registreer de eerste tanking, of voer een reeks in bulk in.',
  'fuel.entries.colDate': 'Datum',
  'fuel.entries.colVehicle': 'Voertuig',
  'fuel.entries.colFuel': 'Brandstof',
  'fuel.entries.colAmount': 'Aantal',
  'fuel.entries.colPrevKm': 'Vorige stand',
  'fuel.entries.colKm': 'Km-stand',
  'fuel.entries.colDelta': 'Δ km',
  'fuel.entries.colL100': 'L/100',
  'fuel.entries.colSupplier': 'Leverancier',
  'fuel.entries.createTitle': 'Nieuwe tanking',
  'fuel.entries.chooseVehicle': 'Kies een voertuig…',
  'fuel.entries.noSupplier': 'Geen leverancier',
  'fuel.entries.note': 'Notitie',
  'fuel.entries.kmRequired': 'Verplicht — een tanking zonder km-stand bestaat niet.',
  'fuel.entries.adBlueKmHint': 'Overgenomen van de dieseltanking van dezelfde dag; aanpasbaar.',
  'fuel.entries.saveAnyway': 'Toch opslaan',
  'fuel.entries.confirmOverride': 'Bevestig en sla op',
  'fuel.entries.overrideWarning':
    'Deze registratie is in strijd met de reeks van dit voertuig. Opslaan legt dat vast op de regel en in het audit-log.',
  'fuel.entries.override': 'Doorgezet',
  'fuel.entries.overrideHint': 'Opgeslagen na beoordeling door de beheerder, ondanks een blokkade.',
  'fuel.entries.bulkTitle': 'Bulk invoeren',
  'fuel.entries.bulkHint':
    'Vul meerdere regels in; de controle draait aan het einde van de batch, niet per regel. Alles wordt in één keer opgeslagen — of niets.',
  'fuel.entries.addRow': 'Regel toevoegen',
  'fuel.entries.bulkSave': '{{count}} regels opslaan',
  'fuel.entries.bulkOverride': '{{count}} toch doorzetten',
  'fuel.entries.rowLabel': 'Regel {{n}}',

  'fuel.unit.LITER': 'L',
  'fuel.unit.KWH': 'kWh',
  'fuel.unit.KG': 'kg',
  'fuel.unit.NM3': 'Nm³',

  'fuel.finding.KM_NOT_INCREASING':
    'Km-stand {{kmStand}} is lager dan de vorige registratie ({{previousKm}} op {{previousDate}}). De teller kan niet teruglopen.',
  'fuel.finding.KM_BELOW_PREVIOUS':
    'Km-stand {{kmStand}} ligt onder de eerdere registratie van {{previousKm}} ({{previousDate}}).',
  'fuel.finding.KM_ABOVE_NEXT':
    'Km-stand {{kmStand}} ligt boven de latere registratie van {{nextKm}} ({{nextDate}}).',
  'fuel.finding.KM_DUPLICATE':
    'Zelfde km-stand ({{kmStand}}) als de registratie van {{previousDate}} — is er tussendoor gereden?',
  'fuel.finding.CONSUMPTION_ABOVE_NORM':
    'Verbruik {{l100}} L/100 km ligt boven de norm van {{norm}} + {{tolerantiePct}}% (over {{deltaKm}} km).',
  'fuel.finding.CONSUMPTION_IMPLAUSIBLE':
    'Verbruik {{l100}} L/100 km is onwaarschijnlijk: {{aantal}} over {{deltaKm}} km. Controleer de km-stand.',

  // ── Klaarzetlijst logistiek (docs/logistics.md) ──
  'nav.logistics': 'Logistiek',
  'nav.staging': 'Klaarzetlijst',

  'staging.title': 'Klaarzetten',
  'staging.titleFor': 'Klaarzetten voor {{date}}',
  'staging.subtitle': 'Materialen klaarzetten per laadplaats.',
  'staging.lastImport': 'Laatste export {{at}}',
  'staging.pickDay': 'Kies een dag',
  'staging.chooseDate': 'Datum kiezen',
  'staging.stockNever': 'nog geen voorraadinfo',
  'staging.stockAt': 'bijgewerkt {{at}}',
  'staging.stockStale': 'bijgewerkt {{at}} — verouderd',
  'staging.pastReadOnly':
    'Dit is een dag in het verleden. Afvinken kan niet meer; opmerkingen plaatsen mag wel.',
  'staging.noExport': 'Er is nog geen export voor deze dag ontvangen.',
  'staging.noExportHint':
    'De basislijst komt om 15:30 binnen uit TALIS, twee werkdagen vóór de laaddag.',
  'staging.noMatches': 'Geen regels die aan de filters voldoen.',
  'staging.clearFilters': 'Filters wissen',

  'staging.tileTodo': 'Te doen',
  'staging.tileStaged': 'Klaargezet',
  'staging.tileNew': 'Nieuw na basisexport',
  'staging.tileRemoved': 'Vervallen',
  'staging.tileInStock': 'Op voorraad in WMS',
  'staging.toClear': 'nog {{count}} op te ruimen',
  'staging.notInStockCount': '{{count}} nog niet binnen',
  'staging.bookedOutCount': '{{count}} uitgeboekt',

  'staging.updateLog': 'Updatelog ({{count}})',
  'staging.baseList': 'Basislijst',
  'staging.updateN': 'Update {{n}}',
  'staging.linesCount': '{{count}} regels',

  'staging.filterProgress': 'Filter op voortgang',
  'staging.filterFoundation': 'Filter op status fundering',
  'staging.filter.all': 'Alles',
  'staging.filter.todo': 'Nog te doen',
  'staging.filter.staged': 'Klaargezet',
  'staging.filter.mutations': 'Mutaties',
  'staging.filter.notin': 'Nog niet binnen',
  'staging.foundation.requested': 'Aangevraagd',
  'staging.foundation.inProgress': 'In behandeling',
  'staging.foundation.onHold': 'On hold',
  'staging.foundation.done': 'Gereed',
  'staging.foundationAll': 'Fundering: alle',
  // Productiestatus van Alfen (TBL_STATUS, 11–91) — features/logistics/productionStatus.ts
  'staging.production.11': 'Geen calculatie aanwezig',
  'staging.production.15': 'Gereed voor engineering',
  'staging.production.21': 'Calculatie niet akkoord',
  'staging.production.22': 'Calculatie niet akkoord, wel uren/materiaal',
  'staging.production.31': 'Calculatie akkoord',
  'staging.production.41': 'Gereed voor plannen',
  'staging.production.45': 'Planning gereed',
  'staging.production.51': 'Order nog picken',
  'staging.production.52': 'Picklijst geprint',
  'staging.production.53': 'Picking afgerond',
  'staging.production.54': 'Gepickt – on hold',
  'staging.production.61': 'In productie',
  'staging.production.62': 'Klaar voor keuring',
  'staging.production.63': 'Buiten zonder keuring',
  'staging.production.64': 'Gemuvt zonder keuring',
  'staging.production.71': 'Uit productie',
  'staging.production.72': 'Verkoopregel gemuvt',
  'staging.production.81': 'Nacalculatie',
  'staging.production.90': 'Controle vóór historie',
  'staging.production.91': 'In historie',
  'staging.searchPlaceholder': 'Zoek op partij, serienummer, omschrijving…',

  'staging.unnamedPlace': 'Laadplaats {{code}}',
  'staging.stagedOf': '{{staged}} van {{total}} klaargezet',
  'staging.badgeNew': 'nieuw',
  'staging.badgeRemoved': 'vervallen',

  'staging.colParty': 'Partij identiteit',
  'staging.colSerial': 'Serienummer',
  'staging.colDebtor': 'Debiteur',
  'staging.colOrderer': 'Besteller',
  'staging.colOrderNr': 'Ordernr',
  'staging.colProduction': 'Status productie',
  'staging.colFoundation': 'Status fundering',
  'staging.colFoundationDate': 'Fund. datum',
  'staging.colFoundationExpected': 'Fund. verwacht',
  'staging.colStaged': 'Klaargezet',
  'staging.colPhoto': 'Foto',
  'staging.colComments': 'Opmerkingen',
  'staging.colLocation': 'Laadplaats',

  'staging.newSince': 'Nieuw sinds {{at}}',
  'staging.removedAt': 'Vervallen {{at}}',
  'staging.wasStagedClearIt': 'was al klaargezet → opruimen',
  'staging.doNotStage': 'niet klaarzetten',
  'staging.stageIt': 'Klaarzetten',
  'staging.staged': 'Klaargezet',
  'staging.clearAway': 'Opruimen',
  'staging.clearedBy': 'Opgeruimd door {{who}}',
  'staging.undo': 'Vinkje terugdraaien',
  'staging.undoConfirm': 'Ja, terugdraaien',
  'staging.inStock': 'Op voorraad in WMS',
  'staging.notInStock': 'nog niet binnen',
  'staging.notInStockHint': 'Niet gevonden in WMS — moet nog binnenkomen',
  'staging.bookedOut': 'uitgeboekt',
  'staging.bookedOutHint': 'Stond op voorraad (laatst gezien {{at}}) en is uit het WMS uitgeboekt',
  'staging.noPhoto': 'geen foto',
  'staging.openPhoto': 'Foto groot bekijken',
  'staging.photoOf': 'Foto van {{party}}',

  'staging.comments': 'Opm.',
  'staging.noComments': 'Nog geen opmerkingen.',
  'staging.commentPlaceholder': 'Opmerking plaatsen…',
  'staging.commentAdd': 'Plaatsen',

  'staging.photoTitle': "Foto's bij klaarzetten",
  'staging.photoRequiredHint':
    'Minstens één foto is verplicht, hooguit {{max}}. Maak ze met de camera of kies bestanden; daarna kun je bevestigen.',
  'staging.photoChoose': 'Foto maken of kiezen',
  'staging.photoAdd': 'Nog een foto',
  'staging.photoRemove': 'Foto weghalen',
  'staging.photoSaved': 'Al opgeslagen',
  'staging.photoCount': "{{count}} van {{max}} foto's",
  'staging.photoMaxReached': "Hooguit {{max}} foto's per regel — de rest is niet toegevoegd.",
  'staging.photoPreviewAlt': 'Gekozen foto',
  'staging.photoReadFailed': 'De foto kon niet worden gelezen. Probeer een andere.',
  'staging.confirmStaged': 'Bevestig klaargezet',
  'staging.confirming': 'Bezig…',
  'staging.uploadingPhoto': 'Foto {{at}} van {{of}} uploaden…',

  // ── Laadplaatsen-beheer (docs/logistics.md §3.1) ──
  'nav.loadingPlaces': 'Laadplaatsen',

  'loadingPlaces.title': 'Laadplaatsen',
  'loadingPlaces.subtitle':
    'De laadplaatsen waarvoor wordt klaargezet. Code, naam en adres komen uit TALIS; de korte naam maken we zelf.',
  'loadingPlaces.new': 'Laadplaats toevoegen',
  'loadingPlaces.empty': 'Nog geen laadplaatsen',
  'loadingPlaces.emptyHint': 'De tien codes van de opdrachtgever horen hier te staan.',

  'loadingPlaces.colCode': 'Code',
  'loadingPlaces.colName': 'Naam uit TALIS',
  'loadingPlaces.colAddress': 'Adres uit TALIS',
  'loadingPlaces.colShortName': 'Korte naam',
  'loadingPlaces.colOrder': 'Volgorde',
  'loadingPlaces.noNameYet': 'nog geen export ontvangen',
  'loadingPlaces.noShort': 'nog niet ingevuld',

  'loadingPlaces.missingShort_one': 'Nog {{count}} laadplaats zonder korte naam',
  'loadingPlaces.missingShort_other': 'Nog {{count}} laadplaatsen zonder korte naam',
  'loadingPlaces.missingShortHint':
    'Zonder korte naam valt een SMS over twee laadplaatsen terug op “(2 locaties)” — dan mist de ontvanger juist waar het hem om gaat.',

  'loadingPlaces.createTitle': 'Laadplaats toevoegen',
  'loadingPlaces.editTitle': 'Laadplaats bewerken',
  'loadingPlaces.fieldCode': 'Code',
  'loadingPlaces.fieldCodeHelp':
    'De TALIS laad/losplaats-code, niet het interne id. Later niet meer te wijzigen.',
  'loadingPlaces.fieldName': 'Naam uit TALIS',
  'loadingPlaces.fieldAddress': 'Adres uit TALIS',
  'loadingPlaces.nameFromExport':
    'Naam en adres komen met elke export mee en worden bij iedere intake ververst; hier valt niets in te vullen.',
  'loadingPlaces.fieldShortName': 'Korte naam',
  'loadingPlaces.fieldShortNamePlaceholder': 'de Wieken',
  'loadingPlaces.fieldShortNameHelp':
    'Zo heet deze laadplaats in een SMS. Houd het kort — een melding heeft 160 tekens voor alles samen.',
  'loadingPlaces.fieldOrder': 'Volgorde',
  'loadingPlaces.fieldOrderHelp': 'Bepaalt de plek in lijsten en keuzevelden. Laag staat boven.',

  'loadingPlaces.previewTitle': 'Zo leest een melding',
  'loadingPlaces.previewChars': '{{length}} van {{max}} tekens',
  'loadingPlaces.previewShortened': 'ingekort om binnen één bericht te blijven',
  'loadingPlaces.previewFallback.name': 'nu nog met de naam uit TALIS',
  'loadingPlaces.previewFallback.code': 'nu nog met de code, want TALIS gaf nog geen naam',

  // ── Voorkeuren + meldingsinstellingen (docs/logistics.md §12.4) ──
  'preferences.title': 'Voorkeuren',
  'preferences.subtitle': 'Je persoonlijke instellingen. Ze gelden alleen voor jou.',

  'users.backToList': 'Terug naar gebruikers',
  'users.tab.gegevens': 'Gegevens',
  'users.tab.meldingen': 'Meldingen',

  'notifications.title': 'Meldingen',
  'notifications.lead':
    'Krijg bericht zodra er een nieuwe klaarzetlijst of een wijziging binnenkomt, zodat je er niet zelf naar hoeft te blijven kijken.',
  'notifications.editingFor': 'Je past de instellingen van {{name}} aan, niet die van jezelf.',

  'notifications.channelTitle': 'Kanaal',
  'notifications.channelMeta': 'WhatsApp · SMS',
  'notifications.enabled': 'Stuur mij een melding bij wijzigingen',
  'notifications.enabledHint': 'Via WhatsApp, of per SMS als dat niet lukt.',
  'notifications.mobile': 'Mobiel nummer',
  'notifications.mobileHelp':
    'Nederlands 06-nummer, voor WhatsApp en SMS. Verplicht zodra meldingen aan staan.',

  'notifications.eventsTitle': 'Waarover',
  'notifications.eventsMeta': 'Vier gebeurtenissen',
  'notifications.event.onBaseList': 'De lijst voor de volgende dag is er',
  'notifications.event.onLinesAdded': 'Nieuwe regels in een update',
  'notifications.event.onLinesRemoved': 'Vervallen regels in een update',
  'notifications.event.onNotInStock': 'Regels die niet in het WMS gevonden zijn',
  'notifications.eventHint.onBaseList':
    'Dagnieuws — deze melding negeert je keuze van laadplaatsen.',
  'notifications.eventHint.onLinesAdded': 'Er is materiaal bijgekomen dat klaargezet moet worden.',
  'notifications.eventHint.onLinesRemoved': 'Materiaal is van de lijst gehaald.',
  'notifications.eventHint.onNotInStock':
    'Op basis van de laatste voorraadmomentopname; die kan tot een kwartier oud zijn.',

  'notifications.placesTitle': 'Voor welke laadplaatsen',
  'notifications.placesMeta': 'Laadplaatsen',
  'notifications.placesAll': 'Alle laadplaatsen',
  'notifications.placesCount': '{{count}} gekozen',
  'notifications.placesLead':
    'Kies je niets, dan gelden je meldingen voor álle laadplaatsen. Wil je niets ontvangen, zet dan de meldingen hierboven uit.',
  'notifications.placesEmpty': 'Er zijn nog geen laadplaatsen bekend.',

  'notifications.quietTitle': 'Stille uren',
  'notifications.quietMeta': 'Lokale tijd',
  'notifications.quietLead':
    'Tussen deze tijden gaat je telefoon niet over. De periode mag over middernacht heen lopen. Gemiste meldingen worden niet nagestuurd — ze staan in het updatelog.',
  'notifications.quietFrom': 'Van',
  'notifications.quietTo': 'Tot',

  'notifications.error.invalid_mobile': 'Dit is geen Nederlands 06-nummer.',
  'notifications.error.required': 'Vul een mobiel nummer in, of zet de meldingen uit.',
  'notifications.error.invalid_time': 'Gebruik een tijd als 19:00.',
  'notifications.error.unknown_loading_place': 'Een van de gekozen laadplaatsen bestaat niet meer.',
  // Verzendlog in het updatelog (docs/logistics.md §12.5)
  'staging.sms.title': 'Melding',
  'staging.sms.chars': '{{count}} tekens',
  'staging.sms.shortened': 'ingekort om binnen één bericht te blijven',
  'staging.sms.status.PENDING': 'wacht op het bundelvenster',
  'staging.sms.status.SENDING': 'wordt verstuurd',
  'staging.sms.status.SENT': 'verstuurd',
  'staging.sms.status.DRY_RUN': 'niet verstuurd — proefstand staat aan',
  'staging.sms.status.NO_RECIPIENTS': 'geen ontvangers',
  'staging.sms.status.NOT_CONFIGURED': 'niet verstuurd — Spryng is niet geconfigureerd',
  'staging.sms.status.FAILED': 'mislukt',
  'staging.sms.rstatus.SENT': 'verzonden',
  'staging.sms.rstatus.DELIVERED': 'afgeleverd',
  'staging.sms.rstatus.READ': 'gelezen',
  'staging.sms.rstatus.SENDING': 'wordt verstuurd',
  'staging.sms.rstatus.FAILED': 'mislukt',
  'staging.sms.rstatus.NOT_CONFIGURED': 'niet verstuurd',
  'staging.sms.rstatus.DRY_RUN': 'proefstand',
  'staging.sms.rstatus.SKIPPED': 'overgeslagen',
  'staging.sms.skip.sms_disabled': 'meldingen staan uit',
  'staging.sms.skip.no_mobile': 'geen nummer',
  'staging.sms.skip.event_not_wanted': 'deze gebeurtenis niet aangevinkt',
  'staging.sms.skip.place_not_wanted': 'andere laadplaats gekozen',
  'staging.sms.skip.quiet_hours': 'stille uren',
  'staging.sms.skip.not_allowlisted': 'nummer staat niet op de toegestane lijst',
  // Alleen bij een terugval: de WhatsApp ging meer dan 30 minuten eerder (§12.10, regel 4).
  'staging.sms.skip.fallback_expired': 'te laat voor een SMS',
  'staging.sms.skip.unknown': 'onbekend',
  'staging.sms.channel.WHATSAPP': 'WhatsApp',
  'staging.sms.channel.SMS': 'SMS',
  // Een terugval gaat alleen na een mislukking, dus de eerste helft is altijd "mislukt" (§12.10).
  'staging.sms.fallback': '{{from}} mislukt → {{to}} {{status}}',

  // De leverdatum (docs/coordination.md §8, bouwlijst #7)
  'deliveryState.NIEUW': 'Nieuw',
  'deliveryState.IN_BEHANDELING': 'In behandeling',
  'deliveryState.BEVESTIGD': 'Bevestigd',
  'deliveryState.AFGEWEZEN': 'Afgewezen',
  'placementSource.TRIP': 'rit',
  'placementSource.CONFIRMED': 'bevestigde leverdatum',
  'placementSource.DESIRED': 'gewenste leverdatum',
  'delivery.title': 'Leverdatum',
  'delivery.meta': 'onderhandeling met Alfen',
  'delivery.propose': 'Voorstel doen',
  'delivery.newProposal': 'Nieuw voorstel',
  'delivery.reasonShort': 'reden',
  'delivery.placeholder': 'plaatshouder',
  'delivery.placeholderHelp':
    '31 december is in de bron een plaatshouder, geen dag. VHT telt hem als nog niet bekend.',
  'delivery.desired': 'Gewenst',
  'delivery.byCustomer': 'besteller',
  'delivery.proposalVht': 'Voorstel VHT',
  'delivery.proposalAlfen': 'Voorstel Alfen',
  'delivery.viaPortal': 'via het portaal',
  'delivery.waiting_one': 'wacht — {{count}} dag open',
  'delivery.waiting_other': 'wacht — {{count}} dagen open',
  'delivery.confirmed': 'Bevestigd',
  'delivery.notYet': 'nog niet',
  'delivery.critical':
    'Kritiek: de productie is klaar op {{date}}, minder dan een week vóór de bevestigde leverdatum.',
  'delivery.alfenHolds': 'Bij Alfen',
  'delivery.isah': 'Isah',
  'delivery.alfenNotYet': 'nog niet bevestigd',
  'delivery.differs': 'wijkt af',
  'delivery.calc.confirmed': 'bevestigd',
  'delivery.calc.vht': 'voorstel VHT',
  'delivery.calc.alfen': 'voorstel Alfen',
  'delivery.calc.location': 'locatie',
  'delivery.calc.production': 'productie',
  'delivery.derivedState': 'Afgeleide stand',
  'delivery.ruleOf': 'regel {{rule}} van 6',
  'delivery.rule.1': 'bevestigd, en geen voorstel wijkt af',
  'delivery.rule.2': 'de voorstellen van VHT en Alfen zijn gelijk',
  'delivery.rule.3': 'op locatie VHT en uit productie — geen handshake nodig',
  'delivery.rule.4': 'voorstel VHT gevuld',
  'delivery.rule.5': 'alleen Alfen noemt een datum',
  'delivery.rule.6': 'nog niemand noemde een datum',
  'delivery.derivedHelp':
    'Deze stand wordt steeds opnieuw berekend uit de datums hierboven. Hij is nergens opgeslagen en dus niet met de hand te zetten.',
  'delivery.thresholds': 'Drempels van de productiestatus',
  'delivery.threshold.41': 'Verzoek naar netbeheerder mag uit',
  'delivery.threshold.64': 'Alfen kan een bevestigde datum niet meer afwijzen',
  'delivery.threshold.71': 'Op locatie VHT ⇒ bevestigd zonder handshake',
  'delivery.thresholdNow': 'Nu — {{what}}',
  'delivery.can.new': 'Nog geen voorstel. Alfen antwoordt op een voorstel van VHT.',
  'delivery.can.inProgress':
    'Alfen kan bevestigen of afwijzen met een eigen datum. Dat antwoord komt via het Alfen-portaal, dat nog gebouwd wordt.',
  'delivery.can.rejected':
    'Alfen wees het voorstel af met een eigen datum. Doe een nieuw voorstel — dezelfde datum als die van Alfen bevestigt hem.',
  'delivery.can.noHandshake':
    'Bevestigd zonder handshake: het station staat op locatie VHT en is uit productie.',
  'delivery.can.confirmedOpen':
    'Alfen kan de bevestigde datum nog afwijzen, tot de productiestatus 64 bereikt.',
  'delivery.can.confirmedLocked':
    'De datum ligt vast: Alfen kan hem niet meer afwijzen, de productiestatus staat op {{prod}}.',
  'delivery.placementFrom': 'Verwachte plaatsing {{date}}, uit de {{source}}.',
  'delivery.placementOnHold': 'Geen verwachte plaatsing: het dossier staat in de wacht.',
  'delivery.placementNone': 'Nog geen verwachte plaatsing.',
  'delivery.placementSkipped': '31 december telt als nog niet bekend.',
  'delivery.casemapDue': 'Casemap van {{party}} uiterlijk {{date}} ({{weeks}} weken ervóór).',
  'delivery.casemapLate':
    'Casemap van {{party}} ontbreekt — de termijn verliep {{date}} ({{weeks}} weken ervóór).',
  'delivery.casemapNoDate': 'Casemap van {{party}}: {{weeks}} weken vóór de plaatsing.',
  'delivery.casemapDelivered': 'Casemap van {{party}} is er.',
  'delivery.proposeHelp': 'Gewenst door de besteller: {{date}}.',
  'delivery.proposalDate': 'Voorgestelde leverdatum',
  'delivery.takeAlfen': 'De datum van Alfen overnemen — {{date}}',
  'delivery.remark': 'Opmerking VHT',
  'delivery.needsDate': 'Een voorstel vraagt een datum.',
  'delivery.otherNeedsRemark': '"Andere reden" vraagt een toelichting in de opmerking.',
  'delivery.withdraw': 'Voorstel intrekken',
  'delivery.timelineProposed': 'Leverdatum voorgesteld: {{date}}',
  'delivery.timelineWithdrawn': 'Voorstel leverdatum ingetrokken',
  'delivery.timelineAlfenConfirmed': 'Alfen bevestigde de leverdatum: {{date}}',
  'delivery.timelineAlfenRejected': 'Alfen wees af en stelde {{date}} voor',

  // Portaal — externe toegang (docs/portal.md). Wachtwoord + authenticator-app.
  'login.portalNote':
    'Voor partners van Van Hooft: met je wachtwoord én de code uit je authenticator-app. Wachtwoord vergeten of telefoon kwijt? Bel ons.',
  'login.portalUnavailable': 'Inloggen op het portaal is op dit moment niet mogelijk.',
  'nav.groundwork': 'Grondwerkrapporten',
  'nav.additionalWork': 'Meerwerk',
  'nav.relations': 'Relaties',
  'partyKind.OPDRACHTGEVER': 'Opdrachtgever',
  'partyKind.NETBEHEERDER': 'Netbeheerder',
  'partyKind.KETENPARTIJ': 'Ketenpartij',
  'portalModule.GROUNDWORK_REPORT': 'Grondwerk-fotorapport',
  'portalModuleHint.GROUNDWORK_REPORT':
    "Foto's van grondwerk aanleveren; de PDF gaat per mail naar Alfen Transport.",
  'portalModule.DELIVERY_PLANNING': 'Planningsoverzicht',
  'portalModuleHint.DELIVERY_PLANNING':
    'De leverdatums die Van Hooft voorstelt bevestigen of afwijzen. Alleen een opdrachtgever antwoordt.',
  'portalAccess.invited': 'Uitgenodigd',
  'portalAccess.invitation_expired': 'Uitnodiging verlopen',
  'portalAccess.active': 'Actief',
  'portalAccess.locked': 'Geblokkeerd',
  'portalAccess.inactive': 'Inactief',

  'portal.brand': 'Portaal',
  // Het portaal op de namen van Alfen (design_handoff_alfen).
  'portal.alfen.product': 'Logistics',
  'portal.alfen.loginTitle': 'Inloggen',
  'portal.alfen.loginLede':
    'Met je e-mailadres en wachtwoord. Daarna vraagt het portaal de code uit je authenticator-app.',
  'portal.alfen.help':
    'Nog geen account, wachtwoord vergeten of telefoon kwijt? Bel Van Hooft Transport.',
  'portal.alfen.operatedBy': 'Uitgevoerd door Van Hooft Transport',
  'portal.nav.label': 'Portaal',
  'portal.nav.groundwork': 'Grondwerk',
  'portal.nav.account': 'Mijn account',
  // De schil op de namen van Alfen (bouwlijst stap 3); de talen in hun eigen woorden.
  'portal.shell.vhtGroup': 'Van Hooft Transport',
  'portal.shell.contactPlanning': 'Contact met de planning',
  'portal.shell.menu': 'Menu',
  'portal.shell.closeMenu': 'Menu sluiten',
  'portal.shell.language': 'Taal',
  'portal.shell.dutch': 'Nederlands',
  'portal.shell.english': 'English',
  'portal.busy': 'Bezig…',
  'portal.back': 'Terug',
  'portal.copy': 'Kopiëren',
  'portal.copied': 'Gekopieerd',
  'portal.toLogin': 'Naar inloggen',
  'portal.help': 'Hulp nodig? Bel Van Hooft Transport.',
  'portal.code.lede':
    'Wachtwoord klopt. Open je authenticator-app en vul de code in voor {{email}}.',
  'portal.code.label': 'Code uit de app',
  'portal.code.confirm': 'Inloggen',
  'portal.code.link': 'Bevestigen',
  'portal.recovery.use': 'Telefoon kwijt? Gebruik een herstelcode',
  'portal.recovery.lede':
    'Vul een van je herstelcodes in. Daarna koppel je eerst een nieuwe telefoon; de code is dan opgebruikt.',
  'portal.recovery.label': 'Herstelcode',
  'portal.recovery.submit': 'Inloggen met herstelcode',
  'portal.recovery.backToCode': 'Toch de code uit de app',
  'portal.app.step1':
    'Installeer een authenticator-app op je telefoon, bijvoorbeeld Microsoft Authenticator of Google Authenticator.',
  'portal.app.step2':
    'Kies in de app "account toevoegen" en scan de QR-code (of tik op de knop op je telefoon).',
  'portal.app.step3': 'Vul hieronder de zescijferige code in die de app laat zien.',
  'portal.app.qrLabel': 'QR-code om de authenticator-app te koppelen',
  'portal.app.openOnPhone': 'Openen in de authenticator-app',
  'portal.app.manualKey': 'Lukt scannen niet? Typ deze sleutel over',
  'portal.codes.title': 'Herstelcodes',
  'portal.codes.onceTitle': 'Bewaar deze codes nu.',
  'portal.codes.onceBody':
    'Ze worden maar één keer getoond. Met een herstelcode kom je binnen als je telefoon kwijt is; elke code werkt één keer.',
  'portal.codes.download': 'Downloaden',
  'portal.codes.print': 'Afdrukken',
  'portal.codes.kept': 'Ik heb de herstelcodes bewaard',
  'portal.codes.fileHeader': 'Herstelcodes — portaal Van Hooft Transport',
  'portal.codes.fileFoot':
    'Elke code werkt één keer. Bewaar dit bestand op een veilige plek, niet op dezelfde telefoon als je authenticator-app.',
  'portal.password.current': 'Huidig wachtwoord',
  'portal.password.new': 'Nieuw wachtwoord',
  'portal.password.repeat': 'Nogmaals',
  'portal.password.show': 'Wachtwoord tonen',
  'portal.password.hide': 'Wachtwoord verbergen',
  'portal.password.ruleLength': 'Minstens {{min}} tekens',
  'portal.password.ruleNotEmail': 'Niet je e-mailadres',
  'portal.password.ruleSame': 'Twee keer hetzelfde',
  'portal.password.rule.too_short': 'Het wachtwoord is te kort.',
  'portal.password.rule.too_long': 'Het wachtwoord is te lang (maximaal 128 tekens).',
  'portal.password.rule.same_as_email': 'Kies iets anders dan je e-mailadres.',
  'portal.password.rule.same_as_current': 'Het nieuwe wachtwoord is hetzelfde als het huidige.',
  'portal.error.generic': 'Er ging iets mis. Probeer het opnieuw.',
  'portal.error.loginFailed': 'E-mailadres of wachtwoord klopt niet.',
  'portal.error.locked':
    'Te vaak een verkeerde poging. Het account is 15 minuten geblokkeerd; daarna kun je het opnieuw proberen.',
  'portal.error.codeWrong':
    'Deze code klopt niet. Wacht op de volgende code in de app en probeer het opnieuw.',
  'portal.error.signInAgain': 'Dat duurde te lang. Begin opnieuw met je e-mailadres en wachtwoord.',
  'portal.error.linkInvalid':
    'Deze link is verlopen of al gebruikt. Vraag Van Hooft om een nieuwe uitnodiging.',
  'portal.error.passwordWrong': 'Het wachtwoord klopt niet.',
  'portal.error.unavailable': 'Inloggen op het portaal is op dit moment niet mogelijk.',
  'portal.error.network': 'Geen verbinding. Controleer je internet en probeer het opnieuw.',
  'portal.error.tooMany': 'Te veel pogingen achter elkaar. Wacht even en probeer het opnieuw.',
  'portal.activate.title': 'Account inrichten',
  'portal.activate.lede': 'Welkom {{name}}. Je richt je toegang tot het portaal in voor {{party}}.',
  'portal.activate.progress': 'Voortgang',
  'portal.activate.stepPassword': 'Wachtwoord',
  'portal.activate.stepApp': 'App koppelen',
  'portal.activate.stepCodes': 'Herstelcodes',
  'portal.activate.invalidTitle': 'Deze link werkt niet.',
  'portal.activate.passwordLede':
    'Kies een wachtwoord voor {{email}}. Lengte telt meer dan tekens: een zin werkt goed.',
  'portal.activate.next': 'Volgende',
  'portal.activate.firstCode': 'Code uit de app',
  'portal.activate.toPortal': 'Naar het portaal',
  'portal.phone.title': 'Nieuwe telefoon koppelen',
  'portal.phone.lede':
    'Zet het portaal over naar een andere telefoon. De oude telefoon werkt tot de nieuwe zijn eerste code heeft gegeven.',
  'portal.phone.ledeRelink':
    'Je bent binnen met een herstelcode. Koppel eerst een telefoon; daarna werkt het portaal weer.',
  'portal.phone.relinkNotice_one':
    'Je hebt nog {{count}} herstelcode over. Maak er na het koppelen nieuwe aan bij Mijn account.',
  'portal.phone.relinkNotice_other':
    'Je hebt nog {{count}} herstelcodes over. Maak er na het koppelen nieuwe aan bij Mijn account.',
  'portal.phone.start': 'Telefoon koppelen',
  'portal.phone.firstCode': 'Code uit de app op de nieuwe telefoon',
  'portal.account.title': 'Mijn account',
  'portal.account.passwordTitle': 'Wachtwoord',
  'portal.account.passwordSince': 'Gekozen op {{when}}',
  'portal.account.passwordChanged': 'Wachtwoord gewijzigd. Andere sessies zijn uitgelogd.',
  'portal.account.passwordSubmit': 'Wachtwoord wijzigen',
  'portal.account.phoneTitle': 'Authenticator-app',
  'portal.account.phoneBody': 'Nieuwe telefoon? Koppel hem hier, zolang je de oude nog hebt.',
  'portal.account.phoneAction': 'Andere telefoon koppelen',
  'portal.account.codesTitle': 'Herstelcodes',
  'portal.account.codesLeft_one': 'Nog {{count}} code over',
  'portal.account.codesLeft_other': 'Nog {{count}} codes over',
  'portal.account.codesBody': 'Maak acht nieuwe codes aan. De oude codes werken daarna niet meer.',
  'portal.account.codesAction': 'Nieuwe herstelcodes',
  'portal.account.codesDone': 'Klaar',

  // Grondwerk-fotorapport — het portaalscherm (docs/portal.md §6)
  'groundwork.title': 'Grondwerk vastleggen',
  'groundwork.lede':
    "Vul de opdracht in en voeg de foto's toe. Van Hooft maakt er een PDF van met ons logo, de gegevens en alle foto's, en mailt die naar Alfen Transport.",
  'groundwork.required': 'verplicht',
  'groundwork.optional': 'optioneel',
  'groundwork.side': 'Voorbeeld en verzenden',
  'groundwork.order.title': 'Opdracht',
  'groundwork.order.number': 'Opdrachtnummer VHT',
  'groundwork.order.numberPlaceholder': 'bijv. 26-04127',
  'groundwork.order.executedOn': 'Datum uitvoering',
  'groundwork.order.address': 'Adres',
  'groundwork.order.addressPlaceholder': 'Straat en huisnummer, postcode en plaats',
  'groundwork.order.remarks': 'Opmerkingen',
  'groundwork.order.remarksPlaceholder':
    'Bijv. bijzonderheden over de ondergrond, afwijkingen of afspraken ter plaatse',
  'groundwork.photos.title': "Foto's",
  'groundwork.photos.min': 'minimaal {{min}}',
  'groundwork.photos.count_one': '{{count}} foto',
  'groundwork.photos.count_other': "{{count}} foto's",
  'groundwork.photos.needed': 'nog {{count}} nodig',
  'groundwork.photos.drop': "Sleep foto's hierheen",
  'groundwork.photos.orChoose': 'of klik om ze te kiezen — plakken kan ook',
  'groundwork.photos.hint': 'JPG of PNG · worden verkleind voor de mail',
  'groundwork.photos.processing': "Foto's verwerken: {{at}} van {{of}}",
  'groundwork.photos.unreadable':
    "Niet gelukt: {{files}}. Gebruik JPG of PNG; iPhone-foto's (HEIC) eerst als JPG exporteren of via de telefoon zelf uploaden.",
  'groundwork.photos.tooMany': "maximaal {{max}} foto's",
  'groundwork.photos.added': "Toegevoegde foto's",
  'groundwork.photos.alt': 'Foto {{n}}: {{name}}',
  'groundwork.photos.remove': 'Foto {{n}} verwijderen',
  'groundwork.error.orderNumber': 'Vul het opdrachtnummer in.',
  'groundwork.error.executedOn': 'Kies de datum van uitvoering.',
  'groundwork.error.future': 'De datum van uitvoering kan niet in de toekomst liggen.',
  'groundwork.error.address': 'Vul het adres in.',
  'groundwork.error.photosNone': "Voeg minimaal {{min}} foto's toe.",
  'groundwork.error.photosShort_one': 'Voeg nog {{count}} foto toe; minimaal {{min}} is verplicht.',
  'groundwork.error.photosShort_other':
    "Voeg nog {{count}} foto's toe; minimaal {{min}} is verplicht.",
  'groundwork.error.tooLarge':
    "Het rapport is te groot om te versturen. Haal foto's weg of verstuur het in twee keer.",
  'groundwork.preview.label': 'Voorbeeld van de eerste pagina van de PDF',
  'groundwork.preview.titlePlaceholder': 'Grondwerk · opdrachtnummer · datum',
  'groundwork.preview.fillIn': 'nog invullen',
  'groundwork.preview.choose': 'nog kiezen',
  'groundwork.preview.photosHere': "Hier komen de foto's",
  'groundwork.preview.meta_one': 'Voorbeeld pagina 1 · A4 · {{count}} pagina · ca. {{size}}',
  'groundwork.preview.meta_other': "Voorbeeld pagina 1 · A4 · {{count}} pagina's · ca. {{size}}",
  'groundwork.send.title': 'Verzenden',
  'groundwork.send.to': 'Aan',
  'groundwork.send.subject': 'Onderwerp',
  'groundwork.send.attachment': 'Bijlage',
  'groundwork.send.replyTo': 'Antwoord naar',
  'groundwork.send.noRecipient': 'geen ontvanger ingesteld',
  'groundwork.send.subjectPlaceholder': '+ opdrachtnummer',
  'groundwork.send.fileNamePlaceholder': 'Grondwerk + opdrachtnummer + datum.pdf',
  'groundwork.send.tooBig':
    "Het rapport wordt ca. {{size}}. Veel mailservers weigeren bijlagen boven 15 MB; haal foto's weg of verstuur in twee keer.",
  'groundwork.send.notLive':
    'In deze omgeving wordt niet echt gemaild. Het rapport en de PDF worden wel gemaakt.',
  'groundwork.send.button': 'Versturen naar Alfen',
  'groundwork.send.uploading': "Foto's versturen… {{pct}}%",
  'groundwork.send.making': 'PDF maken…',
  'groundwork.status.QUEUED': 'Wordt verzonden',
  'groundwork.status.SENT': 'Verzonden',
  'groundwork.status.FAILED': 'Niet gelukt',
  'groundwork.status.NOT_SENT': 'Niet verstuurd',
  'groundwork.result.sent': '{{file}} is om {{time}} verstuurd aan {{to}}.',
  'groundwork.result.queued':
    'De PDF staat klaar en gaat binnen een paar seconden naar {{to}}. Je hoeft niets te doen.',
  'groundwork.result.failed':
    'De mail aan {{to}} is niet aangekomen. Van Hooft ziet dit ook. Open de PDF en mail hem zelf, of bel ons.',
  'groundwork.result.notSent.dry_run':
    'Proefstand: in deze omgeving gaat er geen mail de deur uit.',
  'groundwork.result.notSent.no_recipient': 'Er is in deze omgeving geen ontvanger ingesteld.',
  'groundwork.result.notSent.mail_not_configured': 'Mailen is in deze omgeving niet ingericht.',
  'groundwork.result.openPdf': 'PDF bekijken',
  'groundwork.result.new': 'Nieuw rapport',
  'groundwork.history.title': 'Eerder verstuurd',
  'groundwork.history.empty': 'Nog geen rapporten verstuurd',
  'groundwork.history.emptyHint':
    'Wat je verstuurt, staat hier — met de PDF en of de mail is aangekomen.',
  'groundwork.history.colSent': 'Ingediend',
  'groundwork.history.colOrder': 'Opdracht',
  'groundwork.history.colAddress': 'Adres',
  'groundwork.history.colExecuted': 'Uitgevoerd',
  'groundwork.history.colPhotos': "Foto's",
  'groundwork.history.colMail': 'Mail',

  // Vooraankondiging meerwerk (docs/additional-work.md) — het prototype van de werkvoorbereider
  'additionalWork.title': 'Vooraankondiging meerwerk',
  'additionalWork.subtitle':
    'Na een schouw: welk meerwerk Alfen en de netbeheerder kunnen verwachten, als brief',
  'additionalWork.reset': 'Leeg formulier',
  'additionalWork.required': 'verplicht',
  'additionalWork.optional': 'optioneel',
  'additionalWork.side': 'Voorbeeld en downloaden',
  'additionalWork.step.form': 'Schouwformulier en checklist',
  'additionalWork.step.details': 'Gegevens',
  'additionalWork.step.posts': 'Verwachte meerwerkposten',
  'additionalWork.step.finish': 'Afronden',
  'additionalWork.form.drop': 'Sleep het schouwformulier hierheen',
  'additionalWork.form.choose': 'PDF kiezen',
  'additionalWork.form.replace': 'Ander bestand',
  'additionalWork.form.hint':
    'Of kies een PDF. De gegevens worden overgenomen, en het formulier komt als bijlage achter de brief.',
  'additionalWork.form.reading': 'Bezig met lezen…',
  'additionalWork.form.pages_one': '{{count}} pagina · klik op een pagina om te vergroten',
  'additionalWork.form.pages_other': "{{count}} pagina's · klik op een pagina om te vergroten",
  'additionalWork.form.notInspectionForm_one':
    '{{count}} pagina · dit lijkt geen schouwformulier van Van Hooft; vul de gegevens zelf in',
  'additionalWork.form.notInspectionForm_other':
    "{{count}} pagina's · dit lijkt geen schouwformulier van Van Hooft; vul de gegevens zelf in",
  'additionalWork.form.found_one': '{{count}} veld overgenomen',
  'additionalWork.form.found_other': '{{count}} velden overgenomen',
  'additionalWork.form.foundNone': 'Geen gegevens gevonden',
  'additionalWork.form.notPdf': 'Dit is geen PDF. Kies het schouwformulier als PDF-bestand.',
  'additionalWork.form.tooLarge': 'Dit bestand is groter dan {{size}}. Kies een kleinere PDF.',
  'additionalWork.form.unreadable':
    'Dit bestand kon niet worden gelezen. Is het een beveiligde of beschadigde PDF? Kies een ander bestand.',
  'additionalWork.form.libFailed':
    'De PDF-onderdelen konden niet worden geladen. Herlaad de pagina en probeer het opnieuw.',
  'additionalWork.form.remove': 'Schouwformulier weghalen',
  'additionalWork.form.pagesLabel': 'Pagina’s van het schouwformulier',
  'additionalWork.form.enlarge': 'Pagina {{n}} vergroten',
  'additionalWork.form.viewer': 'Schouwformulier · pagina {{n}} van {{count}}',
  'additionalWork.form.prev': 'Vorige',
  'additionalWork.form.next': 'Volgende',
  'additionalWork.form.fromForm': 'uit schouw',
  'additionalWork.form.keptName': 'Schouwformulier bij opdracht {{order}}',
  'additionalWork.form.kept_one':
    '{{count}} pagina · uit versie {{version}} · klik om te vergroten',
  'additionalWork.form.kept_other':
    "{{count}} pagina's · uit versie {{version}} · klik op een pagina om te vergroten",
  'additionalWork.revision.title': 'Versie {{next}} van opdracht {{order}}',
  'additionalWork.revision.titleKept': 'Versie {{version}} van opdracht {{order}}',
  'additionalWork.revision.body':
    'Je past versie {{version}} van {{date}} aan. Wat je nu mailt of downloadt, wordt versie {{next}} en vervangt versie {{version}}. Wat er veranderde, is in de brief gearceerd.',
  'additionalWork.revision.kept.mailed':
    'Gemaild op {{date}}. Wijzig je iets, dan wordt wat je mailt of downloadt versie {{next}}.',
  'additionalWork.revision.kept.downloaded':
    'Gedownload op {{date}}. Wijzig je iets, dan wordt wat je mailt of downloadt versie {{next}}.',
  'additionalWork.revision.kept.notMailed':
    'Niet verstuurd ({{date}}). Mail je hem opnieuw, dan wordt het versie {{next}}.',
  'additionalWork.revision.mailAsIs': 'Mail je hem ongewijzigd, dan blijft het versie {{version}}.',
  'additionalWork.revision.new': 'Nieuwe brief',
  'additionalWork.revision.opening': 'De brief wordt geopend…',
  'additionalWork.revision.openFailed': 'De brief kon niet worden geopend. {{reason}}',
  'additionalWork.field.orderNumber': 'Opdrachtnummer',
  'additionalWork.field.vhtOrderNumber': 'Opdrachtnummer VHT',
  'additionalWork.field.vhtOrderNumberHelp':
    'Vijf cijfers, voor onszelf: het staat niet in de brief. Hierop verwijst BUKO in een offerte.',
  'additionalWork.field.documentDate': 'Datum brief',
  'additionalWork.field.address': 'Adres werkzaamheden',
  'additionalWork.field.projectName': 'Projectnaam',
  'additionalWork.field.inspectionDate': 'Schouwdatum',
  'additionalWork.field.organisation': 'Organisatie ontvanger',
  'additionalWork.field.attention': 'Ter attentie van',
  'additionalWork.field.attentionHelp': 'Ook de aanhef: “Beste …”',
  'additionalWork.field.extraExplanation': 'Aanvullende toelichting',
  'additionalWork.field.extraExplanationPlaceholder':
    'Bijvoorbeeld: de gemeente bepaalt pas bij de vergunning of een verkeersregelaar nodig is.',
  'additionalWork.field.author': 'Opgesteld door',
  'additionalWork.field.authorRole': 'Functie',
  'additionalWork.field.attach': 'Schouwformulier als bijlage achter de brief plaatsen',
  'additionalWork.field.contacts': 'Contactpersonen netbeheerder',
  'additionalWork.field.contactsHelp':
    'Uit de checklist stationsmap, of zelf invullen. Ze komen in de brief en worden bewaard. Het eerste contact krijgt de brief als hij gemaild wordt.',
  'additionalWork.field.contact1': '1e contact',
  'additionalWork.field.contact2': '2e contact',
  'additionalWork.field.contact1Name': 'Naam',
  'additionalWork.field.contact1Phone': 'Telefoon',
  'additionalWork.field.contact1Email': 'E-mail',
  'additionalWork.field.contact2Name': 'Naam',
  'additionalWork.field.contact2Phone': 'Telefoon',
  'additionalWork.field.contact2Email': 'E-mail',
  'additionalWork.posts.lede': 'Alleen aangevinkte posten komen in de brief.',
  'additionalWork.posts.none': 'Geen posten aangevinkt',
  'additionalWork.posts.summary_one': '{{count}} post · {{amount}}',
  'additionalWork.posts.summary_other': '{{count}} posten · {{amount}}',
  'additionalWork.posts.plusTariff': '{{amount}} + tarievenlijst',
  'additionalWork.posts.tariff': 'Volgens tarievenlijst Alfen/netbeheerder',
  'additionalWork.posts.remarks': 'Opmerkingen uit de schouw',
  'additionalWork.posts.other': 'Overige',
  'additionalWork.posts.otherSub': 'Nader te omschrijven',
  'additionalWork.posts.standard': 'Standaard {{amount}}',
  'additionalWork.posts.from': 'Van (euro)',
  'additionalWork.posts.to': 'Tot (euro)',
  'additionalWork.posts.range': 'Bandbreedte {{name}}',
  'additionalWork.posts.description': 'Omschrijving',
  'additionalWork.posts.descriptionPlaceholder':
    'Bijvoorbeeld: extra transportbeweging of wachturen',
  'additionalWork.posts.note': 'Toelichting',
  'additionalWork.posts.notePlaceholder': 'Komt onder de post in de brief',
  'additionalWork.posts.notePlaceholderChips': 'Aanvulling op de gekozen werkzaamheden',
  'additionalWork.posts.remove': 'Post verwijderen',
  'additionalWork.posts.addOther': 'Nog een overige post',
  'additionalWork.post.traffic.name': 'Verkeersmaatregelen',
  'additionalWork.post.traffic.variants': 'Soort verkeersmaatregel',
  'additionalWork.post.traffic.variantHelp':
    'Bandbreedtes op basis van 15 facturen van BUKO Infrasupport (sep 2026), plus 30%. Leges en parkeergelden van de gemeente kunnen daar nog bij komen.',
  'additionalWork.post.traffic.variant.simple': 'Eenvoudig',
  'additionalWork.post.traffic.variant.simple.sub': 'parkeerverbod of afzetting, één plaatsing',
  'additionalWork.post.traffic.variant.extended': 'Uitgebreid',
  'additionalWork.post.traffic.variant.extended.sub': 'TVM met bebordingsplan, meerdere dagen',
  'additionalWork.post.road_plates.name': 'Rijplaten',
  'additionalWork.post.fencing.name': 'Bouwhekken',
  'additionalWork.post.fencing.sub': 'hoogte hangt af van de huurperiode',
  'additionalWork.post.fencing.notePlaceholder':
    'Bijvoorbeeld: verwachte huurperiode circa 2 weken',
  'additionalWork.post.groundwork.name': 'Grondwerk',
  'additionalWork.post.clear_shrubs.name': 'Bosschage verwijderen',
  'additionalWork.post.heavier_crane.name': 'Inzet zwaardere kraan',
  'additionalWork.post.surveyor.name': 'Extra inzet landmeter',
  'additionalWork.post.pre_inspection.name': 'Voorschouw op verzoek netbeheerder',
  'additionalWork.post.pre_inspection.sub': 'als de netbeheerder om een extra schouw vraagt',
  'additionalWork.chip.traffic_controllers': 'Verkeersregelaars',
  'additionalWork.chip.road_closure': 'Wegafsluiting',
  'additionalWork.chip.crash_cushion': 'Botsabsorber',
  'additionalWork.chip.clear_site': 'Locatie vrijmaken',
  'additionalWork.chip.remove_soil': 'Grond afvoeren',
  'additionalWork.chip.clean_fill': 'Aanvullen met schone grond',
  'additionalWork.chip.level': 'Uitvlakken',
  'additionalWork.preview.label': 'Voorbeeld PDF',
  'additionalWork.preview.building': 'Bijwerken…',
  'additionalWork.preview.failed': 'Het voorbeeld kon niet worden opgebouwd',
  'additionalWork.preview.pages_one': '{{count}} pagina',
  'additionalWork.preview.pages_other': "{{count}} pagina's",
  'additionalWork.preview.page': 'Brief, pagina {{n}}',
  'additionalWork.preview.waiting': 'De brief verschijnt hier.',
  'additionalWork.preview.attachment_one': 'Plus {{count}} pagina schouwformulier als bijlage',
  'additionalWork.preview.attachment_other': "Plus {{count}} pagina's schouwformulier als bijlage",
  'additionalWork.issue.title': 'Nog nodig voor de download',
  'additionalWork.issue.orderNumber': 'Vul het opdrachtnummer in.',
  'additionalWork.issue.vhtOrderNumber': 'Het opdrachtnummer VHT is vijf cijfers, of leeg.',
  'additionalWork.issue.address': 'Vul het adres van de werkzaamheden in.',
  'additionalWork.issue.attention': 'Vul in ter attentie van wie de brief is.',
  'additionalWork.issue.contactEmail': 'Een e-mailadres bij de contactpersonen klopt niet.',
  'additionalWork.issue.author': 'Vul bij “Opgesteld door” een naam in.',
  'additionalWork.issue.noPosts': 'Vink minimaal één meerwerkpost aan.',
  'additionalWork.issue.tooMany': 'Hooguit {{max}} posten in één brief.',
  'additionalWork.issue.description': 'Geef een omschrijving.',
  'additionalWork.issue.amount': 'Vul een bedrag in.',
  'additionalWork.issue.reversed': 'Het tot-bedrag is lager dan het van-bedrag.',
  'additionalWork.issue.post': '{{name}}: {{message}}',
  'additionalWork.list.drop': 'Sleep de checklist stationsmap hierheen',
  'additionalWork.list.hint': 'Optioneel. De checklist stationsmap, als Excel-bestand.',
  'additionalWork.list.choose': 'Excel kiezen',
  'additionalWork.list.replace': 'Ander bestand',
  'additionalWork.list.reading': 'Bezig met lezen…',
  'additionalWork.list.notXlsx': 'Dit is geen Excel-bestand. Kies de checklist als .xlsx.',
  'additionalWork.list.tooLarge': 'Dit bestand is groter dan {{size}}.',
  'additionalWork.list.unreadable':
    'VHT leest alleen de checklist stationsmap van Liander. Vul de posten en contactpersonen zelf in.',
  'additionalWork.list.failed': 'De checklist kon niet worden gelezen. Probeer het nog eens.',
  'additionalWork.list.station': 'Case {{caseNumber}} · station {{stationNumber}} {{stationName}}',
  'additionalWork.list.status': 'Status van de checklist: {{status}}',
  'additionalWork.list.group.post': 'Meerwerk volgens de checklist',
  'additionalWork.list.group.attention': 'Lees de opmerking',
  'additionalWork.list.group.none': 'Geen meerwerk',
  'additionalWork.list.row': 'regel {{row}}',
  'additionalWork.list.empty': 'niet ingevuld',
  'additionalWork.list.quiet_one': '{{count}} vraag over de locatie zonder bijzonderheden.',
  'additionalWork.list.quiet_other': '{{count}} vragen over de locatie zonder bijzonderheden.',
  'additionalWork.list.contacts': 'Contactpersonen overgenomen: {{names}}.',
  'additionalWork.list.remove': 'Checklist weghalen',
  'additionalWork.list.fromList': 'uit checklist',
  'additionalWork.list.why': 'Checklist: {{reasons}}',
  'additionalWork.list.reason': 'regel {{row}}, “{{answer}}”',
  'additionalWork.list.topic.extra_inspection': 'Extra schouw',
  'additionalWork.list.topic.excavation_safety': 'Afzetting fundatiegat',
  'additionalWork.list.topic.excavated_soil': 'Afgegraven grond',
  'additionalWork.list.topic.after_placement': 'Na plaatsing',
  'additionalWork.list.topic.obstacles': 'Vrij van obstakels',
  'additionalWork.list.topic.boundary': 'Ruim van de erfgrens',
  'additionalWork.list.topic.access': 'Vrij toegankelijk',
  'additionalWork.list.topic.heavy_transport': 'Bereikbaar met zwaar transport',
  'additionalWork.list.topic.trees': 'Buiten de kwetsbare boomzone',
  'additionalWork.list.topic.traffic': 'Geen verkeersmaatregelen nodig',
  'additionalWork.complete': 'Compleet. De brief kan gedownload worden.',
  'additionalWork.download.button': 'Download PDF',
  'additionalWork.download.making': 'PDF wordt gemaakt…',
  'additionalWork.download.done': 'Gedownload: {{file}}. De brief staat in de lijst hieronder.',
  'additionalWork.download.failed': 'De PDF kon niet worden gemaakt. {{reason}}',
  'additionalWork.subject.label': 'Onderwerp voor de e-mail',
  'additionalWork.subject.copy': 'Kopieer',
  'additionalWork.subject.copied': 'Gekopieerd',
  'additionalWork.mail.button': 'Brief mailen',
  'additionalWork.mail.buttonVersion': 'Versie {{version}} mailen',
  'additionalWork.mail.version': 'Versie',
  'additionalWork.mail.versionValue': '{{version}}, vervangt versie {{replaces}}',
  'additionalWork.mail.versionAsIs': '{{version}}, zoals gedownload',
  'additionalWork.mail.stale':
    'Er is intussen een nieuwere versie van deze brief gemaild of gedownload. Open die in de lijst hieronder.',
  'additionalWork.mail.sentButton': 'Gemaild',
  'additionalWork.mail.confirmTitle': 'Brief mailen',
  'additionalWork.mail.send': 'Versturen',
  'additionalWork.mail.sending': 'Bezig met versturen…',
  'additionalWork.mail.to': 'Aan',
  'additionalWork.mail.subject': 'Onderwerp',
  'additionalWork.mail.attachment': 'Bijlage',
  'additionalWork.mail.pages_one': '{{count}} pagina',
  'additionalWork.mail.pages_other': "{{count}} pagina's",
  'additionalWork.mail.replyTo': 'Antwoord naar',
  'additionalWork.mail.noRecipient': 'geen ontvanger ingesteld',
  'additionalWork.mail.bcc': 'Bcc',
  'additionalWork.mail.final':
    'De brief gaat namens Van Hooft de deur uit en is daarna niet terug te halen. VHT bewaart hem, met de stand van de mail.',
  'additionalWork.mail.failed': 'Niet verstuurd. {{reason}}',
  'additionalWork.mail.noRecipientNote':
    'In deze omgeving is geen ontvanger ingesteld: de brief wordt bewaard, maar niet gemaild.',
  'additionalWork.mail.dryRun':
    'Proefstand: de brief zou naar {{to}} gaan, maar er wordt niet echt gemaild.',
  'additionalWork.mail.goesTo': 'Gaat naar {{to}}.',
  'additionalWork.mail.dryRunDirect':
    'Proefstand: de brief zou naar {{to}} gaan, met een kopie (bcc) aan {{bcc}}, maar er wordt niet echt gemaild.',
  'additionalWork.mail.goesToDirect': 'Gaat naar {{to}}, met een kopie (bcc) aan {{bcc}}.',
  'additionalWork.mail.repliesTo': 'Een antwoord komt binnen bij {{replyTo}}.',
  'additionalWork.mail.directHint':
    'Met een e-mailadres bij het eerste contact krijgt die hem zelf.',
  'additionalWork.mail.redirect':
    'In deze omgeving gaat elke mail naar {{to}}, met bovenaan voor wie hij bedoeld was.',
  'additionalWork.status.QUEUED': 'Wordt verzonden',
  'additionalWork.status.SENT': 'Verzonden',
  'additionalWork.status.FAILED': 'Niet gelukt',
  'additionalWork.status.NOT_SENT': 'Niet verstuurd',
  'additionalWork.status.DOWNLOADED': 'Gedownload',
  'additionalWork.result.sent': 'Om {{time}} gemaild aan {{to}}.',
  'additionalWork.result.sentOn': 'Op {{date}} gemaild aan {{to}}.',
  'additionalWork.result.queued': 'De brief gaat zo naar {{to}}.',
  'additionalWork.result.failed':
    'De mail aan {{to}} lukte ook na meerdere pogingen niet. De brief is bewaard; meld het bij beheer.',
  'additionalWork.result.notSent.dry_run': 'Mailen staat in deze omgeving in proefstand.',
  'additionalWork.result.notSent.no_recipient': 'Er is in deze omgeving geen ontvanger ingesteld.',
  'additionalWork.result.notSent.mail_not_configured': 'Mailen is in deze omgeving niet ingericht.',
  'additionalWork.result.downloaded':
    'Versie {{version}}, op {{date}}. Hij staat in de lijst hieronder.',
  'additionalWork.history.title': 'Verstuurd of gedownload',
  'additionalWork.history.empty': 'Nog niets verstuurd of gedownload',
  'additionalWork.history.emptyHint':
    'Een brief die je mailt of downloadt, staat hier, met de stand van de mail. Een klik op een regel opent de brief weer, om hem aan te passen.',
  'additionalWork.history.hint':
    'Klik op een brief om hem aan te passen en als nieuwe versie te mailen of te downloaden.',
  'additionalWork.history.search': 'Zoek op nummer of adres',
  'additionalWork.history.noMatch': 'Geen brief gevonden voor “{{q}}”',
  'additionalWork.history.colVersion': 'Versie',
  'additionalWork.history.earlier_one': '{{count}} eerdere',
  'additionalWork.history.earlier_other': '{{count}} eerdere',
  'additionalWork.history.pdf': 'PDF van versie {{version}}',
  'additionalWork.history.colSent': 'Datum',
  'additionalWork.history.colVht': 'VHT',
  'additionalWork.quote.open': 'Offerte verkeersmaatregelen',
  'additionalWork.quote.title': 'Offerte verkeersmaatregelen inlezen',
  'additionalWork.quote.drop': 'Sleep de offerte van BUKO hierheen, of kies het bestand',
  'additionalWork.quote.hint':
    'PDF van BUKO Infrasupport. VHT zoekt de brief op het opdrachtnummer in de offerte, en op het adres.',
  'additionalWork.quote.readyHint': 'Gelezen. Kijk de bedragen na en kies de brief.',
  'additionalWork.quote.choose': 'Kies bestand',
  'additionalWork.quote.replace': 'Andere offerte',
  'additionalWork.quote.reading': 'Bezig met lezen…',
  'additionalWork.quote.notPdf': 'Dit is geen PDF.',
  'additionalWork.quote.tooLarge': 'Dit bestand is te groot.',
  'additionalWork.quote.unreadable': 'Deze PDF is niet te lezen.',
  'additionalWork.quote.notBuko':
    'VHT leest alleen offertes van BUKO Infrasupport, met een totaal voor het werk.',
  'additionalWork.quote.number': 'Offerte',
  'additionalWork.quote.reference': 'Referentie',
  'additionalWork.quote.work': 'Werk',
  'additionalWork.quote.date': 'Datum',
  'additionalWork.quote.total': 'Totaal offerte BUKO',
  'additionalWork.quote.markup': '+ {{percent}}% {{name}}',
  'additionalWork.quote.markup.van_hooft': 'Van Hooft',
  'additionalWork.quote.markup.alfen': 'Alfen',
  'additionalWork.quote.amount': 'In de brief bij Verkeersmaatregelen',
  'additionalWork.quote.internal': 'De prijs van BUKO en de opslag staan niet in de brief.',
  'additionalWork.quote.letters': 'Bij welke brief hoort deze offerte?',
  'additionalWork.quote.lettersHint':
    'Een klik opent de brief met dit bedrag. Daarna mail of download je hem als nieuwe versie.',
  'additionalWork.quote.noMatch':
    'Geen brief gevonden op {{what}}. Zoek hierboven op nummer of adres.',
  'additionalWork.quote.colFound': 'Gevonden op',
  'additionalWork.quote.found.both': 'nummer en adres',
  'additionalWork.quote.found.number': 'nummer',
  'additionalWork.quote.found.address': 'adres',
  'additionalWork.quote.fromQuote': 'uit offerte',
  'additionalWork.quote.why': 'Offerte {{number}}: {{total}}, met de opslag erop.',
  'additionalWork.history.colOrder': 'Opdracht',
  'additionalWork.history.colAddress': 'Adres',
  'additionalWork.history.colAmount': 'Indicatie',
  'additionalWork.history.colMail': 'Stand',
  'additionalWork.history.colPdf': 'PDF',

  // Grondwerkrapporten — de backoffice (docs/portal.md §6.4)
  'groundworkAdmin.title': 'Grondwerkrapporten',
  'groundworkAdmin.mailLive': 'Rapporten gaan vanuit deze omgeving per mail naar {{to}}.',
  'groundworkAdmin.mailDry':
    'Proefstand: rapporten zouden naar {{to}} gaan, maar er wordt niet echt gemaild.',
  'groundworkAdmin.mailNone':
    'Geen ontvanger ingesteld (GROUNDWORK_MAIL_TO): rapporten worden bewaard, niet gemaild.',
  'groundworkAdmin.searchPlaceholder': 'Zoek op opdracht, adres, partij of persoon…',
  'groundworkAdmin.colParty': 'Partij',
  'groundworkAdmin.submittedBy': 'Ingediend door',
  'groundworkAdmin.pdf': 'PDF',
  'groundworkAdmin.pdfMeta': "{{photos}} foto's · {{pages}} p. · {{kb}} kB",
  'groundworkAdmin.note': 'Toelichting',
  'groundworkAdmin.lastError_one': 'Laatste fout (na {{count}} poging)',
  'groundworkAdmin.lastError_other': 'Laatste fout (na {{count}} pogingen)',
  'groundworkAdmin.resend': 'Opnieuw versturen',
  'groundworkAdmin.downloadPdf': 'PDF downloaden',
  'groundworkAdmin.empty': 'Nog geen grondwerkrapporten',
  'groundworkAdmin.emptyHint':
    'Zodra een partner er een verstuurt via het portaal, staat het hier.',

  // Partijen — soort en portaaltoegang (docs/portal.md §3–§4)
  'dataOwners.colKind': 'Soort',
  'dataOwners.colPortal': 'Portaal',
  'dataOwners.fieldKind': 'Soort',
  'dataOwners.fieldKindHint': 'Bepaalt wat de partij in het portaal van de opdrachten ziet.',
  'dataOwners.backToList': 'Partijen',
  'dataOwners.edit': 'Bewerken',
  'dataOwners.codes.title': 'Externe codes',
  'dataOwners.codes.add': 'Code toevoegen',
  'dataOwners.codes.colSystem': 'Systeem',
  'dataOwners.codes.colCode': 'Code',
  'dataOwners.codes.colOrders': 'Dossiers',
  'dataOwners.codes.empty': 'Nog geen externe codes',
  'dataOwners.codes.emptyHint':
    'Voeg de code toe waaronder Alfen deze partij kent; dan worden haar dossiers gekoppeld.',
  'dataOwners.codes.addTitle': 'Externe code toevoegen',
  'dataOwners.codes.fieldSystem': 'Systeem',
  'dataOwners.codes.fieldCode': 'Code',
  'dataOwners.codes.fieldCodeHint':
    'Dossiers die al met deze code binnenkwamen, worden meteen gekoppeld.',
  'dataOwners.codes.taken': 'Deze code hoort al bij een andere partij.',
  'dataOwners.codes.takenBy': '{{code}} {{name}} heeft deze code al.',
  'dataOwners.codes.linked_one': '{{name}} heeft via deze code {{count}} dossier.',
  'dataOwners.codes.linked_other': '{{name}} heeft via deze code {{count}} dossiers.',
  'dataOwners.codes.removeNote':
    'Verwijderen ontkoppelt die dossiers. Hun code en naam zoals Alfen ze stuurde, blijven staan.',
  'dataOwners.codes.remove': 'Code verwijderen',
  'externalSystem.ALFEN': 'Alfen',
  'externalSystemHint.ALFEN': 'De klantcode van Alfen (DM_CustId), zoals in een Alfen-order.',
  'dataOwners.portal.modulesTitle': 'Portaalonderdelen',
  'dataOwners.portal.modulesHint':
    'Wat de portaalgebruikers van deze partij mogen openen. Inloggen en het eigen account kan altijd.',
  'dataOwners.portal.usersTitle': 'Portaalgebruikers',
  'dataOwners.portal.invite': 'Uitnodigen',
  'dataOwners.portal.mailNotLive':
    'Uitnodigingen worden in deze omgeving niet gemaild. Je krijgt de link te zien om zelf door te sturen.',
  'dataOwners.portal.colName': 'Naam',
  'dataOwners.portal.colEmail': 'E-mailadres',
  'dataOwners.portal.colState': 'Toegang',
  'dataOwners.portal.colLastLogin': 'Laatst ingelogd',
  'dataOwners.portal.empty': 'Nog niemand van deze partij heeft toegang',
  'dataOwners.portal.emptyHint':
    'Nodig iemand uit: hij kiest zelf een wachtwoord en koppelt een authenticator-app.',
  'dataOwners.portal.inviteTitle': 'Portaalgebruiker uitnodigen',
  'dataOwners.portal.inviteLede':
    'De uitnodiging is zeven dagen geldig. Wachtwoord en app kiest de persoon zelf; je ziet of kent ze nooit.',
  'dataOwners.portal.inviteSubmit': 'Uitnodigen',
  'dataOwners.portal.invitedAt': 'Uitgenodigd',
  'dataOwners.portal.linkValidUntil': 'Link geldig tot',
  'dataOwners.portal.activatedAt': 'Ingericht',
  'dataOwners.portal.recoveryLeft': 'Herstelcodes over',
  'dataOwners.portal.lockedUntil': 'Geblokkeerd tot',
  'dataOwners.portal.reinvite': 'Nieuwe uitnodiging sturen',
  'dataOwners.portal.unlock': 'Deblokkeren',
  'dataOwners.portal.reset': 'Toegang resetten',
  'dataOwners.portal.resetConfirm':
    'Wachtwoord, app en herstelcodes vervallen, en alle sessies stoppen. De persoon krijgt een nieuwe uitnodiging. Voor een kwijtgeraakte telefoon zónder herstelcodes, of bij twijfel.',
  'dataOwners.portal.resetSubmit': 'Ja, toegang resetten',
  'dataOwners.portal.deactivate': 'Toegang intrekken',
  'dataOwners.portal.activate': 'Weer toegang geven',
  'dataOwners.portal.deliveryTitle': 'Uitnodiging',
  'dataOwners.portal.mailed': 'De uitnodiging is gemaild aan {{email}}.',
  'dataOwners.portal.notMailed.dry_run':
    'Proefstand: er is niet gemaild. Stuur deze link zelf door aan {{email}}.',
  'dataOwners.portal.notMailed.mail_not_configured':
    'Mailen is in deze omgeving niet ingericht. Stuur deze link zelf door aan {{email}}.',
  'dataOwners.portal.notMailed.mail_failed':
    'Mailen lukte niet. Stuur deze link zelf door aan {{email}}.',
  'dataOwners.portal.link': 'Uitnodigingslink',
  'dataOwners.portal.linkHint':
    'Eén keer te gebruiken, geldig tot {{date}}. Deze link wordt niet opnieuw getoond.',

  // Opslag — plattegronden (docs/storage.md)
  'nav.storage': 'Opslag',
  'nav.floorplans': 'Plattegronden',
  'storage.title': 'Plattegronden',
  'storage.subtitle': 'Waar alles op het terrein staat, per opslaglocatie.',
  'storage.summary': '{{plans}} plattegronden · {{count}} in opslag',
  'storage.stationCount_one': '{{count}} in opslag',
  'storage.stationCount_other': '{{count}} in opslag',
  'storage.nOfM': '{{n}} van {{m}}',
  // Het filter op eigenaar, overal in Opslag (eigenaren stap 7, handoff `eigenaren.md §4`)
  'storage.ownerFilter': 'Eigenaar',
  'storage.ownerAll': 'Alle',
  'storage.summaryOwner': '{{plans}} plattegronden · {{n}} van {{count}} in opslag',
  'storage.ownerCount': '{{count}} van {{owner}}',
  'storage.ownerNone': 'Niets van {{owner}}',
  'storage.listOwner': '{{n}} van {{m}} · {{owner}}',
  'storage.ownerEmptyTitle': 'Niets van {{owner}} op {{plan}}',
  'storage.ownerEmptyBody':
    'Wat hier staat, is van een andere eigenaar: op de kaart staat het gedimd.',
  'storage.ownerShowAll': 'Alle eigenaren tonen',
  'storage.updated': 'Gewijzigd {{at}}',
  'storage.notUpdated': 'Nog niet gewijzigd',
  'storage.noLoadingPlace': 'Geen laadplaats gekoppeld',
  'storage.noPlansTitle': 'Nog geen plattegronden',
  'storage.noPlansBody':
    'Een beheerder legt een plattegrond aan, met een tekening van het terrein.',
  'storage.loadErrorTitle': 'De plattegrond kon niet worden geladen',
  'storage.loadErrorBody': 'Controleer de verbinding op het terrein en probeer het opnieuw.',
  'storage.addStation': 'Toevoegen',
  'storage.view': 'Weergave',
  'storage.viewMap': 'Kaart',
  'storage.viewList': 'Lijst',
  'storage.search': 'Zoek op ordernummer, naam of klant',
  'storage.clearSearch': 'Zoekopdracht wissen',
  'storage.emptyTitle': 'Nog niets op {{plan}}',
  'storage.emptyBody':
    'Voeg toe wat er staat. Het komt op de startpositie; sleep het daarna naar zijn plek.',
  'storage.noMatchTitle': 'Niets gevonden',
  'storage.noMatchBody':
    'Niets op {{plan}} met “{{query}}” in het ordernummer, de naam of de klant.',
  'storage.noCustomer': 'geen klant',
  'storage.planLoading': 'Plattegrond laden…',
  'storage.noDrawingTitle': 'Geen tekening voor {{plan}}',
  'storage.noDrawingAdmin':
    'Zonder tekening kun je niets plaatsen. Upload een SVG van het terrein.',
  'storage.noDrawingBody':
    'Zonder tekening kun je niets plaatsen. Vraag een beheerder om er een te uploaden.',
  'storage.zoomIn': 'Inzoomen',
  'storage.zoomOut': 'Uitzoomen',
  'storage.zoomFit': 'Hele terrein',
  'storage.selected': 'Geselecteerd',
  'storage.portrait': 'Staand',
  'storage.landscape': 'Liggend',
  'storage.newHint': '{{code}} staat op de startpositie. Sleep het naar zijn plek op het terrein.',
  'storage.customer': 'Klant',
  'storage.owner': 'Eigenaar',
  'storage.adrLabels': 'ADR {{un}} · juiste etiketten?',
  'storage.adrOk': 'In orde',
  'storage.adrNotOk': 'Niet in orde',
  'storage.adrState.ok': 'Etiketten in orde',
  'storage.adrState.notOk': 'Etiketten niet in orde',
  'storage.adrState.unchecked': 'Etiketten nog niet nagekeken',
  'storage.adrFilter': 'Alleen ADR niet in orde ({{count}})',
  'storage.adrAllOk': 'Alle batterijen op {{plan}} hebben de juiste etiketten.',
  'storage.adrFailed': 'De ADR-stand van {{code}} is niet opgeslagen. Probeer het opnieuw.',
  'storage.legendAdr': 'ADR {{un}}',
  'storage.legendAdrAny': 'ADR',
  'storage.legendAdrNotOk': 'niet in orde {{count}}',
  'storage.legendAdrUnchecked': 'nog niet nagekeken {{count}}',
  'storage.legendAdrOk': '{{count}} in orde',
  'storage.legendAdrAllOk': 'alle {{count}} in orde',
  'storage.lastMoved': 'Laatst verplaatst',
  'storage.rotate': 'Draaien',
  'storage.edit': 'Wijzigen',
  'storage.history': 'Historie',
  'storage.moved': '{{code}} verplaatst',
  'storage.rotated': '{{code}} gedraaid',
  'storage.undo': 'Ongedaan maken',
  'storage.moveFailed': '{{code}} niet verplaatst — geen verbinding. Het staat terug op zijn plek.',
  'storage.moveRefused': '{{code}} niet verplaatst. Het staat terug op zijn plek.',
  'storage.rotateFailed': '{{code}} niet gedraaid. Probeer het opnieuw.',
  'storage.added': '{{code}} toegevoegd aan {{plan}}',
  'storage.deleted': '{{code}} verwijderd van {{plan}}',
  'storage.export': 'Exporteren naar Excel',
  'storage.exported': '{{file}} gedownload · {{count}} op {{plans}} plattegronden',
  'storage.exportedOwner': '{{file}} gedownload · {{count}} van {{owner}}',
  'storage.exportFor': 'Exporteren voor',
  'storage.exportOwnerHint': '{{count}} in opslag',
  'storage.exportAll': 'Alles',
  'storage.exportAllHint': 'Met een kolom eigenaar',
  'storage.exportFailed': 'Exporteren lukte niet. Probeer het opnieuw.',
  'storage.mapUnavailable':
    'Geen kaart in deze omgeving: de HERE-sleutel is niet ingesteld. De plattegronden staan hiernaast.',
  'storage.mapNoPoints': 'Nog geen plattegrond heeft een plek op de kaart.',
  'station.code': 'Ordernummer',
  'station.codeHelp': 'Minimaal 8 tekens. Hoofdletters, zonder spaties.',
  'station.codeName': 'Naam of batch',
  'station.codeHelpName':
    'Zoals op de batterij of in de WMS, bijv. Leticia_253 of 001. Zonder spaties.',
  'station.owner': 'Eigenaar',
  'station.ownerRequired': 'Kies een eigenaar.',
  'station.ownerFirst': 'Kies eerst de eigenaar: dan staan hier zijn typen.',
  'station.codeRequired': 'Verplicht.',
  'station.codeMin': 'Minimaal {{min}} tekens.',
  'station.type': 'Type',
  'station.typeRequired': 'Kies een type.',
  'station.customer': 'Klant',
  'station.customerSearch': 'Zoek op code of naam',
  'station.customerNone': 'Geen klant gevonden. Klanten komen uit de partijen van VHT.',
  'station.customerClear': 'Klant wissen',
  'station.editTitle': '{{code}} wijzigen',
  'station.addTitle': 'Toevoegen aan {{plan}}',
  'station.codeAny': 'Ordernummer of naam',
  'station.codeOwnerFirst': 'Kies eerst de eigenaar.',
  'station.ownerPick': 'Kies een eigenaar',
  'station.addHint': 'Het komt op de startpositie van {{plan}}; sleep het daarna naar zijn plek.',
  'station.deleteTitle': '{{code}} verwijderen',
  'station.deleteBodyBefore': 'Weet je zeker dat je',
  'station.deleteBodyAfter': 'van {{plan}} wilt verwijderen?',
  'station.deleteNote':
    '{{code}} verdwijnt van de plattegrond en uit de export. De historie blijft bewaard.',
  'common.optional': 'optioneel',
  'history.title': 'Historie van {{code}}',
  'history.created': 'Aangemaakt',
  'history.moved': 'Verplaatst',
  'history.rotated': 'Gedraaid',
  'history.updated': 'Gewijzigd',
  'history.deleted': 'Verwijderd',
  'history.migrated': 'Overgenomen uit Floorplanner',
  'history.migratedUpdate': 'Bijgewerkt uit Floorplanner',
  'history.removedInFloorplanner': 'niet meer in de floorplanner',
  'history.adr_checked': 'ADR-etiketten nagekeken',
  'history.adrOk': '{{un}}: etiketten in orde',
  'history.adrNotOk': '{{un}}: etiketten niet in orde',
  'history.inbound_dated': 'Inslag uit de WMS',
  'history.inboundOn': '{{date}} op {{location}}',
  'history.nowLandscape': 'Nu liggend',
  'history.nowPortrait': 'Nu staand',
  'history.field.code': 'Ordernummer',
  'history.field.stationType': 'Type',
  'history.field.party': 'Klant',
  'history.field.floorplan': 'Plattegrond',
  'history.field.position': 'Positie',
  'history.field.owner': 'Eigenaar',
  'history.migratedDetail': 'positie, type en klant uit v2.1.0',
  'history.system': 'Systeem',
  'history.booking_mailed': 'Boekingsmail verstuurd',
  'history.booking_not_mailed': 'Boekingsmail niet verstuurd',
  'history.booking_mail_failed': 'Boekingsmail mislukt',
  'history.bookingTo': '{{direction}} aan {{to}}',
  'history.bookingReason.dry_run': 'proefstand',
  'history.bookingReason.mail_not_configured': 'mail niet ingericht',
  'history.bookingAttempts_one': 'na {{count}} poging',
  'history.bookingAttempts_other': 'na {{count}} pogingen',
  'history.note':
    'Elke wijziging wordt vastgelegd met wie en wanneer. De historie blijft bewaard, ook na verwijderen.',

  // Opslag — beheer: plattegrond instellen, stationtypen, kleuren (docs/storage.md)
  'nav.stationTypes': 'Typen',
  'nav.storageOwners': 'Eigenaren',
  // Opslag — het dashboard (docs/storage.md §20)
  'nav.storageDashboard': 'Dashboard',
  'storageDashboard.subtitle': 'Voorraadverloop, verblijfsduur en datakwaliteit van de opslag.',
  'storageDashboard.title': 'Dashboard Opslag',
  'storageDashboard.asOf': 'Stand van {{date}}',
  'storageDashboard.week': 'wk {{week}} {{year}}',
  'storageDashboard.kpi.total': 'In opslag nu',
  'storageDashboard.kpi.adr': 'ADR niet in orde',
  'storageDashboard.kpi.adrUnchecked': 'waarvan {{count}} nog niet nagekeken',
  'storageDashboard.kpi.median': 'Mediaan in opslag',
  'storageDashboard.kpi.days': 'dagen',
  'storageDashboard.moves.title': 'In en uit',
  'storageDashboard.moves.view': 'Per type of per plattegrond',
  'storageDashboard.moves.byType': 'Per type',
  'storageDashboard.moves.byPlan': 'Per plattegrond',
  'storageDashboard.moves.day': 'Dag',
  'storageDashboard.moves.week': 'Week',
  'storageDashboard.moves.month': 'Maand',
  'storageDashboard.moves.weekTitle': 'Week {{week}} {{year}}',
  'storageDashboard.moves.prev.day': 'Vorige dag',
  'storageDashboard.moves.prev.week': 'Vorige week',
  'storageDashboard.moves.prev.month': 'Vorige maand',
  'storageDashboard.moves.next.day': 'Volgende dag',
  'storageDashboard.moves.next.week': 'Volgende week',
  'storageDashboard.moves.next.month': 'Volgende maand',
  'storageDashboard.moves.moved_one':
    '{{count}} station verhuisd naar een andere plattegrond; dat telt niet als in of uit.',
  'storageDashboard.moves.moved_other':
    '{{count}} stations verhuisd naar een andere plattegrond; dat telt niet als in of uit.',
  'storageDashboard.moves.empty.day': 'Niets in- of uitgeboekt op deze dag.',
  'storageDashboard.moves.empty.week': 'Niets in- of uitgeboekt in deze week.',
  'storageDashboard.moves.empty.month': 'Niets in- of uitgeboekt in deze maand.',
  'storageDashboard.moves.total': 'Totaal',
  'storageDashboard.cal.week': 'wk',
  'storageDashboard.cal.prevMonth': 'Vorige maand',
  'storageDashboard.cal.nextMonth': 'Volgende maand',
  'storageDashboard.cal.prevYear': 'Vorig jaar',
  'storageDashboard.cal.nextYear': 'Volgend jaar',
  'storageDashboard.cal.current.day': 'Vandaag',
  'storageDashboard.cal.current.week': 'Deze week',
  'storageDashboard.cal.current.month': 'Deze maand',
  'storageDashboard.kpi.withoutCustomer': 'Zonder klant',
  'storageDashboard.billing.title': 'Voor de factuur',
  'storageDashboard.billing.sub': 'gemiddeld in opslag per dag',
  'storageDashboard.billing.how': 'Hoe het telt',
  'storageDashboard.billing.howBody':
    'Elke dag telt wat er die dag stond, ook de dag van binnenkomst en de dag van vertrek. Opgeteld zijn dat de itemdagen; gedeeld door het aantal dagen is het het gemiddelde.',
  'storageDashboard.billing.howToday':
    'Deze maand telt tot en met vandaag. Een dag zonder voorraad telt mee als 0.',
  'storageDashboard.billing.howSince':
    'Telde VHT een eigenaar nog niet de hele maand, dan rekent de tegel over de dagen die VHT kent, en zegt hij sinds wanneer.',
  'storageDashboard.billing.thisMonth': '{{month}}, t/m vandaag',
  'storageDashboard.billing.lastMonth': '{{month}}',
  'storageDashboard.billing.sum_one': '{{itemDays}} itemdagen ÷ {{count}} dag',
  'storageDashboard.billing.sum_other': '{{itemDays}} itemdagen ÷ {{count}} dagen',
  'storageDashboard.billing.since': 'VHT telt {{owner}} sinds {{date}}',
  'storageDashboard.billing.none': 'VHT telde {{owner}} nog niet',
  'storageDashboard.flow.title': 'Voorraadverloop',
  'storageDashboard.flow.since': 'sinds {{date}}',
  'storageDashboard.flow.grain': 'Per week, maand of jaar',
  'storageDashboard.grain.week': 'Week',
  'storageDashboard.grain.month': 'Maand',
  'storageDashboard.grain.year': 'Jaar',
  'storageDashboard.flow.stock': 'In opslag',
  'storageDashboard.flow.inOut': 'In- en uitstroom',
  'storageDashboard.flow.in': 'Binnen',
  'storageDashboard.flow.out': 'Vertrokken',
  'storageDashboard.flow.net': 'Netto',
  'storageDashboard.flow.empty': 'Nog niets in de historie.',
  'storageDashboard.flow.stockBoth': 'In opslag',
  'storageDashboard.flow.wms': 'Posities in de WMS',
  'storageDashboard.flow.vht': 'In VHT',
  'storageDashboard.flow.transition': 'Overgang',
  'storageDashboard.flow.note':
    'Tot de overgang op 24 oktober 2026 komt het verloop uit de WMS van TALIS: de posities aan het eind van elke week op de vier locaties van de plattegronden en de stationsopslag van Alfen. De WMS telt posities en geen stations, ook ander materiaal, dus bij de overgang zit een sprong ({{positions}} posities tegen {{stations}} stations). Vanaf de overgang telt VHT zelf, met de in- en uitstroom; wat er toen al stond, telt als voorraad en niet als binnenkomst.',
  'storageDashboard.flow.noteNoWms':
    'VHT telt in- en uitboekingen sinds de overgang op 24 oktober 2026; wat er toen al stond, telt als voorraad en niet als binnenkomst. Het verloop daarvóór komt uit de WMS, zodra die is ingelezen.',
  'storageDashboard.flow.noteOwner':
    'VHT telt {{owner}} sinds {{date}}. Wat er eerder stond, komt binnen zodra het geboekt is.',
  'storageDashboard.forecast.title': 'Prognose',
  'storageDashboard.forecast.label': 'Prognose',
  'storageDashboard.forecast.headline':
    'Op {{date}} naar verwachting zo’n {{mid}} stations, tussen {{low}} en {{high}}.',
  'storageDashboard.forecast.note':
    'Zo liep de voorraad in {{first}}–{{last}} vanaf week {{week}}, de dertien weken erna, zonder de groei van die jaren: {{years}}. Het midden ({{mid}}) is de lijn, het laagste en hoogste jaar de band, toegepast op wat er nu staat. In de zomer en bij vorst kan er minder uitgeleverd worden, en dat zit in die jaren. Wat er al gepland staat, of een winter die anders uitvalt, ziet de prognose niet.',
  'storageDashboard.forecast.inbound':
    'De laatste dertien weken, tot en met {{to}}, kwamen er van Alfen gemiddeld {{mean}} per week binnen, tussen {{low}} en {{high}}. Tot de overgang telt de WMS, daarna VHT.',
  'storageDashboard.forecast.notForYear': 'De prognose staat bij week en maand.',
  'storageDashboard.forecast.otherOwner':
    'Geen prognose voor {{owner}}: die rekent met de inslag van {{wms}} uit de WMS, van vóór de overgang. Kies {{wms}} om hem te zien.',
  'storageDashboard.forecast.onlyOwner':
    'Alleen {{owner}}: de prognose rekent met de inslag uit de WMS, van vóór de overgang, en die is van {{owner}}.',
  'storageDashboard.forecast.asTable': 'Prognose als tabel',
  'storageDashboard.forecast.mid': 'Prognose',
  'storageDashboard.forecast.low': 'Laagste jaar',
  'storageDashboard.forecast.high': 'Hoogste jaar',
  'storageDashboard.asTable': 'Als tabel',
  'storageDashboard.col.period': 'Periode',
  'storageDashboard.col.from': 'Van',
  'storageDashboard.col.to': 'Tot en met',
  'storageDashboard.col.code': 'Ordernummer',
  'storageDashboard.col.plan': 'Plattegrond',
  'storageDashboard.col.customer': 'Klant',
  'storageDashboard.col.type': 'Type',
  'storageDashboard.col.owner': 'Eigenaar',
  'storageDashboard.col.wmsRelation': 'In de WMS bij',
  'storageDashboard.col.since': 'In opslag sinds',
  'storageDashboard.col.days': 'Dagen',
  'storageDashboard.byType': 'Per type',
  'storageDashboard.byPlan': 'Per plattegrond',
  'storageDashboard.byCustomer': 'Per klant',
  'storageDashboard.noCustomer': 'Zonder klant',
  'storageDashboard.stay.title': 'Verblijfsduur',
  'storageDashboard.stay.meta': 'gemiddeld {{mean}} · mediaan {{median}} dagen',
  'storageDashboard.stay.buckets': 'Hoe lang ze er staan',
  'storageDashboard.stay.longest': 'Het langst in opslag',
  'storageDashboard.stay.fromTransition_one':
    '{{count}} station telt vanaf de overgang op 24 oktober 2026, omdat de WMS er geen inslag van heeft.',
  'storageDashboard.stay.fromTransition_other':
    '{{count}} stations tellen vanaf de overgang op 24 oktober 2026, omdat de WMS er geen inslag van heeft.',
  'storageDashboard.bucket.0-30': '0–30 dagen',
  'storageDashboard.bucket.31-90': '31–90',
  'storageDashboard.bucket.91-180': '91–180',
  'storageDashboard.bucket.181-365': '181–365',
  'storageDashboard.bucket.366+': 'Meer dan een jaar',
  'storageDashboard.quality.title': 'Datakwaliteit',
  'storageDashboard.quality.withoutCustomer': 'Zonder klant',
  'storageDashboard.quality.withoutCustomerHint':
    'Geef ze een klant op de plattegrond, anders kan Alfen ze niet doorbelasten.',
  'storageDashboard.quality.notInWms': 'Niet in de WMS',
  'storageDashboard.quality.notInWmsHint':
    'Op een plattegrond, maar niet in de voorraad van de WMS van {{time}}. Staat het er nog, en is het ingeslagen?',
  'storageDashboard.quality.noSnapshot': 'Nog geen voorraadmomentopname van de WMS ontvangen.',
  'storageDashboard.quality.otherRelation': 'Bij een andere relatie in de WMS',
  'storageDashboard.quality.otherRelationHint':
    'In de voorraad van de WMS van {{time}}, maar niet onder de relatie van de eigenaar. Klopt het type in VHT, of de relatie in de WMS?',
  'storageDashboard.quality.withoutRelation_one':
    '{{names}} doet niet mee: geen relatie in de WMS onder Opslag › Eigenaren.',
  'storageDashboard.quality.withoutRelation_other':
    '{{names}} doen niet mee: geen relatie in de WMS onder Opslag › Eigenaren.',
  'storageDashboard.quality.noRelation_one':
    'Niet nagekeken: {{names}} heeft geen relatie in de WMS. Vul die in onder Opslag › Eigenaren.',
  'storageDashboard.quality.noRelation_other':
    'Niet nagekeken: {{names}} hebben geen relatie in de WMS. Vul die in onder Opslag › Eigenaren.',
  'storageDashboard.quality.fromTransition': 'Zonder echte inslagdatum',
  'storageDashboard.quality.fromTransitionHint':
    'Tellen vanaf 24 oktober 2026: de WMS kent geen inslag van ze.',
  'storageDashboard.quality.show': 'Toon welke',
  'storageDashboard.quality.showFirst': 'Toon de eerste {{count}}',
  'storage.newPlan': 'Nieuwe plattegrond',
  'storage.uploadDrawing': 'Tekening uploaden',
  'floorplan.settingsTitle': 'Plattegrond instellen',
  'floorplan.newTitle': 'Nieuwe plattegrond',
  'floorplan.newSub': 'Een terrein met een tekening, waarop logistiek plaatst wat er staat.',
  'floorplan.details': 'Gegevens',
  'floorplan.name': 'Naam',
  'floorplan.namePlaceholder': 'Bijv. Barneveld Nijverheidsweg',
  'floorplan.nameRequired': 'Minimaal 2 tekens.',
  'floorplan.loadingPlace': 'Laadplaats',
  'floorplan.noLoadingPlace': 'Geen laadplaats',
  'floorplan.loadingPlaceHelp':
    'Koppelt de plattegrond aan de laadplaats van de klaarzetlijst. Nodig voor de koppeling met TALIS later.',
  'floorplan.drawing': 'Tekening (SVG)',
  'floorplan.drop': 'SVG kiezen of hierheen slepen',
  'floorplan.replace': 'Vervangen',
  'floorplan.notSavedYet': 'nog niet opgeslagen',
  'floorplan.notSvg': 'Dit is geen SVG met een maat (viewBox of breedte en hoogte).',
  'floorplan.drawingHelp':
    'Een SVG uit Inkscape of AutoCAD. Bij vervangen blijven de stations op hun coördinaten staan.',
  'floorplan.stationSize': 'Blokmaat',
  'floorplan.width': 'Breedte',
  'floorplan.height': 'Hoogte',
  'floorplan.stationSizeHelp':
    'Breedte × hoogte in eenheden van de tekening. Geldt voor elk blokje hier.',
  'floorplan.sizeInvalid': 'Twee hele getallen tussen 5 en 500.',
  'floorplan.stationGap': 'Tussenruimte',
  'floorplan.stationGapHelp':
    'Wat een gesleept blokje vrijhoudt als het naast of onder een buur vastklikt, in eenheden van de tekening.',
  'floorplan.gapInvalid': 'Een heel getal van 0 tot 100.',
  'floorplan.start': 'Startpositie',
  'floorplan.startHelp': 'Waar iets nieuws verschijnt. Tik op de tekening om de plek te kiezen.',
  'floorplan.startInvalid': 'Twee hele getallen, 0 of meer.',
  'floorplan.lat': 'Breedtegraad',
  'floorplan.lon': 'Lengtegraad',
  'floorplan.positionHelp': 'Voor het overzicht op de kaart.',
  'floorplan.positionInvalid':
    'Breedtegraad tussen -90 en 90, lengtegraad tussen -180 en 180 (komma of punt).',
  'floorplan.deleteTitle': 'Plattegrond verwijderen',
  'floorplan.deleteBlocked_one': 'Kan pas als er niets meer op staat. Nu: {{count}}.',
  'floorplan.deleteBlocked_other': 'Kan pas als er niets meer op staat. Nu: {{count}}.',
  'floorplan.deleteConfirm':
    'Weet je zeker dat je {{name}} wilt verwijderen? De tekening gaat mee; de historie blijft bewaard.',
  'floorplan.previewTitle': 'Tekening',
  'floorplan.previewHint': 'tik om de startpositie te kiezen',
  'floorplan.startLabel': 'Start',
  'floorplan.noPreview': 'Kies een SVG om de tekening hier te zien.',
  'floorplan.saved': '{{name}} opgeslagen',
  'floorplan.deleted': '{{name}} verwijderd',
  'floorplan.drawingRefused': 'De plattegrond is aangemaakt. {{reason}}',
  'stationTypes.title': 'Typen',
  'stationTypes.subtitle': 'Het type bepaalt de kleur van een blokje op elke plattegrond.',
  'stationTypes.summary': '{{count}} typen · {{stations}} in opslag',
  'stationTypes.colorsInUse': '{{used}} van 12 kleuren in gebruik',
  'stationTypes.ownerColors': '{{used}} van 12 kleuren',
  'stationTypes.new': 'Nieuw type',
  'stationTypes.newTitle': 'Nieuw type',
  'stationTypes.editTitle': 'Type wijzigen',
  'stationTypes.colColor': 'Kleur',
  'stationTypes.colName': 'Omschrijving',
  'stationTypes.owner': 'Eigenaar',
  'stationTypes.ownerRequired': 'Kies een eigenaar.',
  'stationTypes.article': 'Artikel uit TALIS',
  'stationTypes.articleSearch': 'Zoek op code, omschrijving of WMS-klant',
  'stationTypes.articleNone': 'Geen actief artikel gevonden. Artikelen komen elk uur uit TALIS.',
  'stationTypes.articleClear': 'Artikel wissen',
  'stationTypes.articleHelp':
    'Het artikel geeft de maten en het gewicht, en stelt de omschrijving en het UN-nummer voor.',
  'stationTypes.articleInactive':
    'Dit artikel is in TALIS niet meer actief. Het type blijft staan; kies eventueel een ander.',
  'stationTypes.adr': 'ADR (UN-nummer)',
  'stationTypes.adrHelp': 'Leeg: geen gevaarlijke stof. Batterijen van Greener zijn UN3536.',
  'stationTypes.adrInvalid': 'Een UN-nummer is UN met vier cijfers, bijv. UN3536.',
  'stationTypes.colStations': 'In opslag',
  'stationTypes.name': 'Omschrijving',
  'stationTypes.namePlaceholder': 'Bijv. Compact 630 kVA',
  'stationTypes.nameRequired': 'Verplicht.',
  'stationTypes.color': 'Kleur',
  'stationTypes.colorFree': 'Vrij',
  'stationTypes.colorFreeAt': 'Vrij · {{type}} bij {{owner}}',
  'stationTypes.colorHelpHead':
    'Twaalf kleuren, één per type van {{owner}}; de kop scheidt ze van {{plain}}. Blauw, Petrol en Bes liever niet: dat zijn daar de grote drie.',
  'stationTypes.colorCurrent': 'Huidige kleur',
  'stationTypes.colorChosen': 'Gekozen',
  'stationTypes.colorHelp':
    'Twaalf kleuren, één per type. Een bezette kleur komt vrij als zijn type wordt verwijderd.',
  'stationTypes.paletteFull': 'Alle twaalf kleuren van {{owner}} zijn in gebruik',
  'stationTypes.paletteFullFree':
    'Verwijder eerst een type van {{owner}} waar niets van in opslag staat — nu {{types}} — dan komt zijn kleur vrij.',
  'stationTypes.paletteFullNone':
    'Van elk type van {{owner}} staat iets in opslag. Vraag een uitbreiding van het palet aan; verzin geen eigen kleur.',
  'stationTypes.inUse_one':
    '{{count}} in opslag met dit type. Verwijderen kan pas als er niets meer van dit type staat.',
  'stationTypes.inUse_other':
    '{{count}} in opslag met dit type. Verwijderen kan pas als er niets meer van dit type staat.',
  'stationTypes.saved': '{{name}} opgeslagen',
  'stationTypes.deleted': '{{name}} verwijderd',
  'storageOwners.title': 'Eigenaren',
  'storageOwners.summary': '{{count}} eigenaren · {{stations}} in opslag',
  'storageOwners.new': 'Nieuwe eigenaar',
  'storageOwners.newTitle': 'Nieuwe eigenaar',
  'storageOwners.editTitle': 'Eigenaar wijzigen',
  'storageOwners.colOwner': 'Eigenaar',
  'storageOwners.colShortName': 'Korte naam',
  'storageOwners.colCode': 'Debiteurcode',
  'storageOwners.colWmsRelation': 'Relatie in de WMS',
  'storageOwners.noWmsRelation': 'geen',
  'storageOwners.wmsPositions_one': '{{count}} positie',
  'storageOwners.wmsPositions_other': '{{count}} posities',
  'storageOwners.wmsRelation': 'Relatie in de WMS',
  'storageOwners.wmsRelationHelp':
    'Waaronder de WMS de voorraad van deze eigenaar bijhoudt, zoals 1000165 bij Greener: niet altijd de debiteurcode. Het dashboard laat onder Datakwaliteit zien wat de WMS bij een andere relatie heeft. Leeg doet niet mee.',
  'storageOwners.colCodeRule': 'Code',
  'storageOwners.colCustomers': 'Klanten',
  'storageOwners.colMark': 'Teken',
  'storageOwners.mark': 'kop · {{letter}}',
  'storageOwners.noMark': 'geen',
  'storageOwners.shortName': 'Korte naam',
  'storageOwners.shortNameAuto': 'Het eerste woord van de partij',
  'storageOwners.shortNameHelp': 'In knoppen, koppen en zinnen, zoals Greener. Hooguit 20 tekens.',
  'storageOwners.shortNameRequired': 'Verplicht.',
  'storageOwners.markLetter': 'Letter in de kop',
  'storageOwners.markAuto': 'Eerste vrije',
  'storageOwners.markHelpNew':
    'Op elk blokje van deze eigenaar, vanaf 160 %. Leeg: de eerste vrije letter van de korte naam.',
  'storageOwners.markHelp':
    'Op elk blokje, vanaf 160 %. Leeg is geen kop, zoals Alfen: dat kan bij één eigenaar.',
  'storageOwners.markInvalid': 'Eén letter, A tot Z.',
  'storageOwners.colTypes': 'Typen',
  'storageOwners.colStations': 'In opslag',
  'storageOwners.rule.ORDER_NUMBER': 'Ordernummer',
  'storageOwners.rule.NAME': 'Naam of batch',
  'storageOwners.ruleHelp.ORDER_NUMBER':
    '8 tot 30 tekens, in hoofdletters, zonder spaties: zoals bij Alfen.',
  'storageOwners.ruleHelp.NAME':
    'Hooguit 30 tekens, zoals getypt, zonder spaties: Leticia_253 of 001.',
  'storageOwners.ruleChanged':
    'Een andere regel geldt voor wat er vanaf nu getypt wordt. De codes die er staan, blijven zoals ze zijn.',
  'storageOwners.yes': 'Ja',
  'storageOwners.no': 'Nee',
  'storageOwners.party': 'Partij',
  'storageOwners.partySearch': 'Zoek op debiteurcode of naam',
  'storageOwners.partyNone':
    'Geen partij gevonden. Maak hem eerst aan onder Beheer › Partijen, met zijn debiteurcode.',
  'storageOwners.partyRequired': 'Kies een partij.',
  'storageOwners.codeRule': 'Code bij het boeken',
  'storageOwners.hasCustomers': 'Kan een klant hebben',
  'storageOwners.hasCustomersHelp':
    'Bij Alfen is de klant de netbeheerder. Greener heeft geen klanten: dan staat het veld er niet.',
  'storageOwners.inUse':
    'Deze eigenaar heeft {{count}} typen. Verwijder die eerst om hem weg te halen.',
  'storageOwners.saved': '{{name}} opgeslagen',
  'storageOwners.deleted': '{{name}} is geen eigenaar meer',
  'color.blue': 'Blauw',
  'color.petrol': 'Petrol',
  'color.berry': 'Bes',
  'color.violet': 'Violet',
  'color.sky': 'Lucht',
  'color.rose': 'Roze',
  'color.umber': 'Omber',
  'color.pine': 'Den',
  'color.moss': 'Mos',
  'color.sand': 'Zand',
  'color.slate': 'Lei',
  'color.graphite': 'Grafiet',

  // Offertelijsten (docs/quotations.md §2, bouwlijst #2).
  'nav.quotationLists': 'Offertelijsten',
  'quotationLists.title': 'Offertelijsten',
  'quotationLists.tab.craneTypes': 'Kraantypes',
  'quotationLists.tab.articles': 'Artikelen',
  'quotationLists.tab.standardTexts': 'Standaardteksten',
  'quotationLists.tab.addresses': 'Adressen',
  'quotationLists.searchPlaceholder.craneTypes': 'Zoek op naam',
  'quotationLists.searchPlaceholder.articles': 'Zoek op code, omschrijving of klant',
  'quotationLists.searchPlaceholder.standardTexts': 'Zoek op naam of tekst',
  'quotationLists.searchPlaceholder.addresses': 'Zoek op bedrijf, adres of plaats',
  'quotationLists.includeInactive': 'Ook uit de lijst gehaald',
  'quotationLists.allKinds': 'Alle soorten',
  'quotationLists.download': 'Excel downloaden',
  'quotationLists.downloadFailed': 'Downloaden lukte niet. Probeer het opnieuw.',
  'quotationLists.import': 'Excel inlezen',
  'quotationLists.new.craneTypes': 'Nieuw kraantype',
  'quotationLists.new.articles': 'Nieuw artikel',
  'quotationLists.new.standardTexts': 'Nieuwe standaardtekst',
  'quotationLists.new.addresses': 'Nieuw adres',
  'quotationLists.editTitle.craneTypes': 'Kraantype wijzigen',
  'quotationLists.editTitle.articles': 'Artikel wijzigen',
  'quotationLists.editTitle.standardTexts': 'Standaardtekst wijzigen',
  'quotationLists.editTitle.addresses': 'Adres wijzigen',
  'quotationLists.col.name': 'Naam',
  'quotationLists.col.code': 'Code',
  'quotationLists.col.description': 'Omschrijving',
  'quotationLists.col.sizes': 'l × b × h (m)',
  'quotationLists.col.weight': 'Gewicht (kg)',
  'quotationLists.col.kind': 'Soort',
  'quotationLists.col.text': 'Tekst',
  'quotationLists.col.updated': 'Gewijzigd',
  'quotationLists.col.company': 'Bedrijfsnaam',
  'quotationLists.col.street': 'Straat',
  'quotationLists.col.place': 'Postcode en plaats',
  'quotationLists.col.country': 'Land',
  'quotationLists.offList': 'uit de lijst',
  'quotationLists.defaultChip': 'standaard',
  'quotationLists.empty.craneTypes': 'Nog geen kraantypes',
  'quotationLists.empty.articles': 'Nog geen artikelen',
  'quotationLists.empty.standardTexts': 'Nog geen standaardteksten',
  'quotationLists.empty.addresses': 'Nog geen vaste adressen',
  'quotationLists.emptyHint':
    'Voeg er een toe, of lees een Excel-bestand in. Download het eerst: dat is het sjabloon.',
  'quotationLists.noMatch': 'Niets gevonden',
  'quotationLists.noMatchHint': 'Zoek op iets anders, of zet "Ook uit de lijst gehaald" aan.',
  'quotationLists.kind.INTRO': 'Intro',
  'quotationLists.kind.CRANE': 'Kraantekst',
  'quotationLists.kind.BODY': 'Offertetekst',
  'quotationLists.kind.OPTIONS': 'Toelichting opties',
  'quotationLists.kind.CLOSING': 'Staarttekst',
  'quotationLists.kind.EXCEPTIONAL': 'Exceptioneel transport',
  'quotationLists.kind.PRICE_REQUEST': 'Prijsaanvraag',
  'quotationLists.kindHint.INTRO': 'Boven de regels.',
  'quotationLists.kindHint.CRANE': 'Bij een kraan, onder het kraantype.',
  'quotationLists.kindHint.BODY': 'Onder de regels, boven de totalen.',
  'quotationLists.kindHint.OPTIONS': 'Alleen als er een optie in de offerte staat.',
  'quotationLists.kindHint.CLOSING': 'Onderaan: geldigheid en betalingstermijn.',
  'quotationLists.kindHint.EXCEPTIONAL': 'Bij exceptioneel transport: de route is een indicatie.',
  'quotationLists.kindHint.PRICE_REQUEST':
    'In de prijsaanvraag. Bij hijswerk begint hij met de tekst die "Hijswerk" in zijn naam heeft.',
  'quotationLists.field.name': 'Naam',
  'quotationLists.field.craneNamePlaceholder': 'Bijvoorbeeld Telekraan 300 ton',
  'quotationLists.field.code': 'Code',
  'quotationLists.field.description': 'Omschrijving',
  'quotationLists.field.length': 'Lengte (m)',
  'quotationLists.field.width': 'Breedte (m)',
  'quotationLists.field.height': 'Hoogte (m)',
  'quotationLists.field.weight': 'Gewicht (kg)',
  'quotationLists.field.sizesHint':
    'De standaardmaten. In een offerte zijn ze per artikel aan te passen. Leeg mag.',
  'quotationLists.field.kind': 'Soort',
  'quotationLists.field.body': 'Tekst',
  'quotationLists.field.textNamePlaceholder': 'Bijvoorbeeld Na een telefoongesprek',
  'quotationLists.field.textNameHint': 'Zo kies je hem in een offerte.',
  'quotationLists.field.isDefault': 'Standaard in een nieuwe offerte',
  'quotationLists.field.company': 'Bedrijfsnaam',
  'quotationLists.field.street': 'Straat en huisnummer',
  'quotationLists.field.postcode': 'Postcode',
  'quotationLists.field.city': 'Plaats',
  'quotationLists.field.country': 'Land',
  'quotationLists.addressHint':
    'Een vast adres voor laden of lossen. Een offerte neemt een kopie: wie het hier wijzigt, verandert geen offerte die het al heeft.',
  'quotationLists.requiredCompanyCity': 'Bedrijfsnaam en plaats zijn verplicht.',
  'quotationLists.field.isDefaultHint':
    'Hooguit één per soort. Was een andere tekst van deze soort de standaard, dan is hij dat niet meer.',
  'quotationLists.invalidSize': 'Geen maat. Typ een getal in meters, zoals 3,80.',
  'quotationLists.invalidWeight': 'Geen gewicht. Typ een getal in kilogram, zoals 21000.',
  'quotationLists.requiredCodeDescription': 'Code en omschrijving zijn verplicht.',
  'quotationLists.duplicateName': 'Deze naam staat al in de lijst.',
  'quotationLists.duplicateCode': 'Deze code staat al in de lijst.',
  'quotationLists.duplicateAddress': 'Dit bedrijf staat in deze plaats al in de lijst.',
  'quotationLists.takeOff': 'Uit de lijst halen',
  'quotationLists.putBack': 'Terugzetten',
  'quotationLists.offNote':
    'Uit de lijst gehaald: niet te kiezen in een nieuwe offerte. Een offerte die hem al heeft, houdt hem.',
  'quotationLists.saved': '{{name}} opgeslagen',
  'quotationLists.takenOff': '{{name}} uit de lijst gehaald',
  'quotationLists.putBackDone': '{{name}} staat weer in de lijst',
  'quotationLists.importTitle': 'Excel inlezen',
  'quotationLists.importIntro':
    'Kies een bestand zoals de download: tabbladen Kraantypes, Artikelen, Standaardteksten en Adressen. Eerst zie je wat er verandert; pas als je op Inlezen klikt, wordt het ingelezen. Wat niet in het bestand staat, blijft staan. Artikelen uit TALIS staan er niet in: die wijzig je in TALIS.',
  'quotationLists.importChoose': 'Bestand kiezen',
  'quotationLists.importOther': 'Ander bestand',
  'quotationLists.importReading': 'Bestand lezen…',
  'quotationLists.importNotXlsx': 'Dit is geen Excel-bestand (.xlsx).',
  'quotationLists.importLine': '{{created}} nieuw · {{updated}} gewijzigd · {{unchanged}} gelijk',
  'quotationLists.importNew': 'Nieuw',
  'quotationLists.importChanged': 'Gewijzigd',
  'quotationLists.importNotInFile': 'Niet in het bestand; blijft zoals het is.',
  'quotationLists.importProblems':
    'Problemen in het bestand: {{count}}. Er wordt niets ingelezen tot ze zijn opgelost.',
  'quotationLists.importMore': 'en nog {{count}}',
  'quotationLists.importNothing': 'Het bestand verandert niets.',
  'quotationLists.importReady': 'Klik op Inlezen om deze wijzigingen door te voeren.',
  'quotationLists.importApply': 'Inlezen',
  'quotationLists.importApplying': 'Inlezen…',
  'quotationLists.importDone': 'Ingelezen: {{created}} nieuw, {{updated}} gewijzigd',
  'quotationLists.importCol.list': 'Tabblad',
  'quotationLists.importCol.row': 'Rij',
  'quotationLists.importCol.column': 'Kolom',
  'quotationLists.importCol.problem': 'Probleem',
  'quotationLists.problem.not_a_lists_file':
    'Geen tabblad Kraantypes, Artikelen of Standaardteksten gevonden.',
  'quotationLists.problem.missing_column': 'Deze kolom ontbreekt.',
  'quotationLists.problem.required': 'Leeg, maar verplicht.',
  'quotationLists.problem.too_long': 'Te lang.',
  'quotationLists.problem.invalid_number': 'Geen getal: "{{value}}".',
  'quotationLists.problem.out_of_range': 'Te groot of te klein: "{{value}}".',
  'quotationLists.problem.invalid_yes_no': 'Geen ja of nee: "{{value}}".',
  'quotationLists.problem.unknown_kind': 'Onbekende soort: "{{value}}".',
  'quotationLists.problem.invalid_country': 'Geen landcode zoals NL, BE of DE: "{{value}}".',
  'quotationLists.problem.duplicate': 'Staat twee keer in het bestand.',
  'quotationLists.problem.two_defaults': 'Twee standaardteksten van dezelfde soort.',
  'quotationLists.problem.default_inactive': 'Een standaardtekst kan niet uit de lijst zijn.',

  // Offertes (docs/quotations.md, bouwlijst #3): het overzicht en de werkbank.
  'nav.quotations': 'Offertes',
  'relations.pickThis': 'Deze kiezen',
  'quotations.title': 'Offertes',
  'quotations.subtitle': 'Offertes voor transport en hijswerk, met versies',
  'quotations.titleOf': 'Offerte {{number}}',
  'quotations.searchPlaceholder': 'Zoek op nummer, relatie of referentie',
  'quotations.state.concept': 'Concept',
  'quotations.state.issued': 'Uitgebracht',
  'quotations.state.expired': 'Verlopen',
  'quotations.new': 'Nieuwe offerte',
  'quotations.createFailed': 'De offerte kon niet worden aangemaakt.',
  'quotations.col.number': 'Nummer',
  'quotations.col.relation': 'Relatie',
  'quotations.col.type': 'Type',
  'quotations.col.reference': 'Uw referentie',
  'quotations.col.amount': 'Offertebedrag',
  'quotations.col.options': 'Opties',
  'quotations.col.changed': 'Gewijzigd',
  'quotations.col.quantity': 'Aantal',
  'quotations.col.article': 'Artikel',
  'quotations.col.length': 'l (m)',
  'quotations.col.width': 'b (m)',
  'quotations.col.height': 'h (m)',
  'quotations.col.weight': 'kg',
  'quotations.col.articleAmount': 'Bedrag',
  'quotations.col.optional': 'Opt.',
  'quotations.type.TRANSPORT': 'Transport',
  'quotations.type.HOISTING': 'Hijswerk',
  'quotations.noRelation': 'Nog geen relatie',
  'quotations.attention': 't.a.v. {{name}}',
  'quotations.yourReference': 'uw referentie {{reference}}',
  'quotations.empty': 'Nog geen offertes',
  'quotations.emptyHint': 'Maak er een met "Nieuwe offerte". Hij krijgt het nummer van vandaag.',
  'quotations.noMatch': 'Geen offertes gevonden',
  'quotations.noMatchHint': 'Niets past bij deze zoekopdracht of status.',
  'quotations.clearFilter': 'Filter wissen',
  'quotations.neverIssued': 'nog niet uitgebracht',
  'quotations.versionValidUntil': 'versie {{version}} geldig tot {{date}}',
  'quotations.versionExpired': 'versie {{version}} verlopen',
  'quotations.validUntil': 'geldig tot {{date}}',
  'quotations.expiredSince': 'sinds {{date}}',
  'quotations.allQuotations': 'Alle offertes',
  'quotations.notFound': 'Deze offerte bestaat niet, of je mag hem niet zien.',
  'quotations.versions': 'Versies',
  'quotations.versionN': 'Versie {{n}}',
  'quotations.conflict':
    '{{name}} sloeg versie {{version}} om {{time}} op, terwijl jij hem open had.',
  'quotations.conflictSelf':
    'Versie {{version}} is om {{time}} door jou opgeslagen in een ander venster.',
  'quotations.conflictChanged': 'Veranderd: {{steps}}.',
  'quotations.conflictPaused': 'Je eigen wijzigingen worden pas weer opgeslagen als je kiest.',
  'quotations.takeTheirs': 'Versie van {{name}} laden',
  'quotations.takeSaved': 'Opgeslagen versie laden',
  'quotations.keepMine': 'Mijn versie houden',
  'quotations.lockedMeanwhile':
    'Deze versie is intussen uitgebracht en ligt vast. Je laatste wijzigingen zijn niet opgeslagen.',
  'quotations.reload': 'Opnieuw laden',
  'quotations.leaveTitle': 'Wiens versie blijft?',
  'quotations.leaveBody':
    '{{name}} sloeg versie {{version}} tegelijk met jou op. Jouw laatste wijzigingen zijn daarom nog niet opgeslagen. Sla je jouw versie op, dan verdwijnt wat {{name}} veranderde.',
  'quotations.stay': 'Blijven',
  'quotations.leaveTheirs': 'Versie van {{name}} houden',
  'quotations.leaveMine': 'Mijn versie opslaan',
  'quotations.step.customer': 'Klant',
  'quotations.step.customerSub': 'Aan wie de offerte gaat',
  'quotations.step.lines': 'Regels',
  'quotations.step.linesSub.TRANSPORT': 'Laden, lossen, kraan en artikelen',
  'quotations.step.linesSub.HOISTING': 'Lossen, kraan en artikelen',
  'quotations.step.texts': 'Tekst',
  'quotations.step.textsSub': 'Eén tekst onder de bedragen, aan te vullen met standaardteksten',
  'quotations.step.internal': 'Intern',
  'quotations.step.internalSub': 'Komt nooit in de offerte of in een mail',
  'quotations.relation': 'Relatie',
  'quotations.searchRelation': 'Zoek op naam, code, plaats of contactpersoon',
  'quotations.noRelationFound': 'Geen relatie gevonden.',
  'quotations.notThere': 'Staat hij er niet in?',
  'quotations.makeProspect': 'Prospect maken',
  'quotations.prospectMade':
    'Prospect {{name}} gemaakt. Wordt het een klant, dan komt de relatie via Exact en TALIS terug en koppel je hem.',
  'quotations.contact': 'Ter attentie van',
  'quotations.chooseRelationFirst': 'Kies eerst een relatie',
  'quotations.noContacts': 'Nog geen contactpersonen',
  'quotations.chooseContact': 'Kies een contactpersoon',
  'quotations.inVht': 'in VHT',
  'quotations.contactAdded': '{{name}} toegevoegd bij {{relation}}.',
  'quotations.reference': 'Uw referentie',
  'quotations.referencePlaceholder': 'Referentie van de klant, bijv. een inkoopnummer',
  'quotations.typeLabel': 'Type',
  'quotations.hoistingHint': 'Hijswerk heeft per regel alleen een losplaats.',
  'quotations.lineCount_one': '{{count}} regel',
  'quotations.lineCount_other': '{{count}} regels',
  'quotations.line': 'Regel {{n}}',
  'quotations.articleCount_one': '{{count}} artikel',
  'quotations.articleCount_other': '{{count}} artikelen',
  'quotations.lineOptional': 'Hele regel optioneel',
  'quotations.copyLine': 'Regel kopiëren',
  'quotations.copyLineN': 'Regel {{n}} kopiëren',
  'quotations.removeLine': 'Regel verwijderen',
  'quotations.removeLineN': 'Regel {{n}} verwijderen',
  'quotations.addLine': 'Regel toevoegen',
  'quotations.place.load': 'Laden',
  'quotations.place.unload': 'Lossen',
  'quotations.field.company': 'Bedrijfsnaam',
  'quotations.fixedAddress': 'Vast adres',
  'quotations.searchAddress': 'Kies een vast adres om de velden te vullen',
  'quotations.noAddress': 'Geen vast adres gevonden.',
  'quotations.craneAt.load': 'Kraan bij laden',
  'quotations.craneAt.unload': 'Kraan bij lossen',
  'quotations.craneType': 'Kraantype',
  'quotations.chooseCrane': 'Kies een kraan',
  'quotations.amount': 'Bedrag',
  'quotations.craneAmount.load': 'Bedrag kraan bij laden',
  'quotations.craneAmount.unload': 'Bedrag kraan bij lossen',
  'quotations.optional': 'Optioneel',
  'quotations.optionalHint': 'telt dan niet mee in het offertebedrag',
  'quotations.craneText': 'Tekst bij de kraan',
  'quotations.price': 'Prijs',
  'quotations.priceOfLine': 'Prijs van regel {{n}}',
  'quotations.pricing.ARTICLE': 'Per artikel',
  'quotations.pricing.LINE': 'Voor de hele regel',
  'quotations.articleN': 'artikel {{n}}',
  'quotations.searchArticle': 'Zoek op code, omschrijving of klant',
  'quotations.noArticle': 'Geen artikel gevonden.',
  'quotations.amountOfArticle': 'Bedrag artikel {{n}}',
  'quotations.articleOptional': 'Artikel {{n}} optioneel',
  'quotations.removeArticle': 'Artikel verwijderen',
  'quotations.removeArticleN': 'Artikel {{n}} verwijderen',
  'quotations.addArticle': 'Artikel',
  'quotations.articleTextPlaceholder':
    'Tekst onder het artikel, bijv. ongeladen/ongelost incl. 2 laad- en 2 losuren',
  'quotations.articleText': 'Tekst bij artikel {{n}}',
  'quotations.sizesAdjusted': 'maten aangepast',
  'quotations.sizesFromList': 'terug naar de lijst',
  'quotations.fromList': 'Uit de lijst: {{sizes}} m, {{kg}} kg',
  'quotations.inAmount': 'In het offertebedrag',
  'quotations.options': 'Opties',
  'quotations.standardText': 'Standaardtekst',
  'quotations.textInserted': 'Standaardtekst ingevoegd.',
  'quotations.undo': 'Ongedaan maken',
  'quotations.text': 'Tekst in de offerte',
  'quotations.textHint.body':
    'Komt onder de bedragen. Een standaardtekst komt onderaan erbij; een witregel begint een nieuwe alinea.',
  'quotations.calculation': 'Calculatie',
  'quotations.calculationPlaceholder': 'Reken hier: uren, kilometers, de inkoop van een kraan…',
  'quotations.calculationHint':
    'Alleen voor wie de offerte maakt. Staat niet in de PDF en gaat niet mee in een mail.',
  'quotations.side': 'De offerte',
  'quotations.amountMain': 'Offertebedrag',
  'quotations.exclOptions': 'excl. opties',
  'quotations.exclVat': 'Alle bedragen exclusief btw.',
  'quotations.issuesTitle': 'Nog nodig om uit te brengen',
  'quotations.complete': 'Alles staat erin wat de offerte nodig heeft.',
  'quotations.private': 'Calculatie, rijtijd en tol staan niet in de offerte.',
  'quotations.saving': 'Opslaan…',
  'quotations.saved': 'Concept opgeslagen {{when}}.',
  'quotations.savedBy': 'Concept opgeslagen {{when}} door {{who}}.',
  'quotations.savePaused': 'Opslaan staat stil tot je kiest wiens versie blijft.',
  'quotations.saveFailed': 'Opslaan lukte niet.',
  'quotations.saveLocked': 'Deze versie ligt vast.',
  'quotations.historyTitle': 'Wie eraan werkte',
  'quotations.historySub':
    'Uit de audit: wie de offerte maakte, bewerkte, uitbracht en downloadde.',
  'quotations.event.created': 'Offerte aangemaakt',
  'quotations.event.saved': 'Versie {{version}} bewerkt',
  'quotations.event.overwrote': 'Versie {{version}} opgeslagen, over die van {{name}} heen',
  'quotations.showAll': 'Alles tonen ({{count}})',
  'quotations.showLess': 'Minder tonen',
  'quotations.discard': 'Concept weggooien',
  'quotations.discardTitle': 'Concept {{number}} weggooien?',
  'quotations.discardBody':
    'Deze offerte is nooit uitgebracht. Hij verdwijnt uit het overzicht en het nummer komt niet terug. In de audit blijft staan wat het was en wie hem weggooide.',
  'quotations.discardConfirm': 'Weggooien',
  'quotations.discarded': 'Offerte {{number}} is weggegooid.',
  'quotations.discardFailed': 'Weggooien lukte niet.',
  'quotations.goneMeanwhile':
    'Deze offerte is intussen weggegooid. Wat je hier nog veranderde, is niet opgeslagen.',
  'quotations.saveGone': 'Deze offerte bestaat niet meer.',
  'quotations.issue.inLine': 'Regel {{n}}: {{text}}',
  'quotations.issue.noRelation': 'kies een relatie.',
  'quotations.issue.noContacts': 'voeg een contactpersoon toe bij {{relation}}.',
  'quotations.issue.noContact': 'kies ter attentie van wie.',
  'quotations.issue.loadCity': 'vul de plaats van de laadplaats in.',
  'quotations.issue.unloadCity': 'vul de plaats van de losplaats in.',
  'quotations.issue.loadCraneType': 'kies het kraantype bij laden.',
  'quotations.issue.unloadCraneType': 'kies het kraantype bij lossen.',
  'quotations.issue.loadCraneAmount': 'vul het bedrag van de kraan bij laden in.',
  'quotations.issue.unloadCraneAmount': 'vul het bedrag van de kraan bij lossen in.',
  'quotations.issue.noArticle': 'voeg een artikel toe.',
  'quotations.issue.articleNotChosen': 'kies artikel {{n}}.',
  'quotations.issue.articleQuantity': 'vul het aantal van {{name}} in.',
  'quotations.issue.articleAmount': 'vul het bedrag van {{name}} in.',
  'quotations.issue.lineAmount': 'vul de prijs van de regel in.',
  'quotations.issue.text': 'vul de tekst in (geldigheid en betaling).',
  'quotations.issue.noLine': 'voeg een regel toe.',
  'quotations.issue.conflict': 'kies eerst wiens versie blijft: {{name}} sloeg tegelijk op.',
  // Uitbrengen en de PDF (bouwlijst #4).
  'quotations.sheet': 'Zo krijgt de klant hem',
  'quotations.sheetBuilding': 'Bijwerken…',
  'quotations.sheetFailed': 'Het voorbeeld lukte niet.',
  'quotations.sheetPages_one': '{{count}} pagina',
  'quotations.sheetPages_other': '{{count}} pagina’s',
  'quotations.sheetPage': 'Pagina {{n}}',
  'quotations.sheetWaiting': 'De offerte wordt getekend.',
  'quotations.issueVersion': 'Versie {{n}} uitbrengen',
  'quotations.previewPdf': 'Voorbeeld-PDF',
  'quotations.previewMaking': 'Voorbeeld maken…',
  'quotations.previewFile': 'Concept offerte {{reference}}.pdf',
  'quotations.previewFailed': 'Het voorbeeld kon niet worden gemaakt.',
  'quotations.issueTitle': 'Versie {{n}} uitbrengen?',
  'quotations.issueTo': 'Aan',
  'quotations.issueReference': 'Offerte',
  'quotations.issueAmount': 'Bedrag',
  'quotations.issueAmountText': '{{main}} excl. opties',
  'quotations.issueAmountWithOptions': '{{main}} excl. opties · opties {{options}}',
  'quotations.issueValidUntil': 'Geldig tot',
  'quotations.issueBody':
    'Daarna ligt versie {{n}} vast. De PDF wordt bewaard met de voorwaarden erachter, en ook naam en adres van de relatie zoals ze nu zijn. Wijzigen kan dan alleen in een nieuwe versie.',
  'quotations.issueConfirm': 'Uitbrengen',
  'quotations.issuing': 'Uitbrengen…',
  'quotations.issuedToast':
    'Offerte {{reference}} is uitgebracht. Download de PDF en mail hem zelf.',
  'quotations.issueFailed': 'Uitbrengen lukte niet.',
  'quotations.issueIncomplete': 'Uitbrengen kan nog niet: er ontbreekt iets in de offerte.',
  'quotations.issuedAlert': 'Uitgebracht {{when}} door {{who}}. Geldig tot {{until}}.',
  'quotations.expiredAlert':
    'Verlopen op {{until}}. Wil de klant hem nog, breng dan een nieuwe versie uit; die is weer 30 dagen geldig.',
  'quotations.downloadPdf': 'Download PDF',
  'quotations.downloadFailed': 'Downloaden lukte niet.',
  'quotations.newVersion': 'Nieuwe versie',
  'quotations.newVersionMade': 'Versie {{n}} gemaakt, als kopie van versie {{from}}.',
  'quotations.newVersionFailed': 'Een nieuwe versie maken lukte niet.',
  'quotations.conceptIs': 'Versie {{n}} is het concept waar aan gewerkt wordt.',
  'quotations.lockedBanner': 'Versie {{n}} is uitgebracht {{when}} door {{who}} en ligt vast.',
  'quotations.lockedEditIn': 'Wijzigen doe je in versie {{n}}, het concept.',
  'quotations.lockedEditNew': 'Wijzigen kan in een nieuwe versie.',
  'quotations.toVersion': 'Naar versie {{n}}',
  'quotations.event.issued': 'Versie {{version}} uitgebracht',
  'quotations.event.downloaded': 'Versie {{version}} gedownload',
  'quotations.event.version': 'Versie {{version}} gemaakt, als kopie van versie {{from}}',
  'quotations.event.priceRequest': 'Prijsaanvraag aan {{relation}}, t.a.v. {{contact}} ({{lines}})',
  'quotations.event.priceRequestMailed': 'Prijsaanvraag aan {{relation}} gemaild naar {{to}}',
  'quotations.event.priceRequestAnswered': 'Antwoord van {{relation}} ingelezen',
  'quotations.event.priceChosen': 'Prijs van {{relation}} gekozen voor versie {{version}}',
  'quotations.event.priceChoiceCleared': 'Gekozen prijs weggehaald bij versie {{version}}',
  // De prijsaanvraag (#6): aan een collega-transporteur, vanuit een concept.
  'quotations.priceRequest.button': 'Prijsaanvraag',
  'quotations.priceRequest.title': 'Prijsaanvraag bij offerte {{reference}}',
  'quotations.priceRequest.intro':
    'Een PDF met de regels die je kiest, zonder prijzen en zonder klant: laden en lossen als bedrijf en plaats, de maten in centimeters.',
  'quotations.priceRequest.carrier': 'Transporteur',
  'quotations.priceRequest.askedBefore': 'eerder gevraagd',
  'quotations.priceRequest.notThere': 'Staat de collega er niet in?',
  'quotations.priceRequest.addCarrier': 'Relatie toevoegen',
  'quotations.priceRequest.newCarrier': 'Nieuwe relatie',
  'quotations.priceRequest.newCarrierHint':
    'Een collega-transporteur die nog niet in de relaties staat. Die komt erin als relatie van VHT; daarna vul je de contactpersoon in.',
  'quotations.priceRequest.chooseCarrierFirst': 'Kies eerst een transporteur',
  'quotations.priceRequest.addContact': 'Contactpersoon toevoegen',
  'quotations.priceRequest.lines': 'Regels',
  'quotations.priceRequest.pickLine': 'Kies minstens één regel.',
  'quotations.priceRequest.withCrane': 'met kraan bij {{where}}',
  'quotations.priceRequest.noCrane': 'zonder kraan',
  'quotations.priceRequest.optional': 'optioneel in de offerte',
  'quotations.priceRequest.text': 'Tekst',
  'quotations.priceRequest.sheet': 'Zo krijgt de collega hem',
  'quotations.priceRequest.download': 'Downloaden',
  'quotations.priceRequest.making': 'Maken…',
  'quotations.priceRequest.made':
    'Prijsaanvraag voor {{relation}} gedownload. Hij staat onder Intern.',
  'quotations.priceRequest.madeNoFile':
    'De prijsaanvraag is bewaard, maar het downloaden lukte niet. Hij staat onder Intern.',
  'quotations.priceRequest.failed': 'De prijsaanvraag kon niet gemaakt worden.',
  'quotations.priceRequest.mailTitle': 'Prijsaanvraag aan {{relation}} mailen?',
  'quotations.priceRequest.mailAgain': 'Opnieuw mailen',
  'quotations.priceRequest.mailForward':
    'Bovenaan staat voor wie hij is. Stuur hem van daar door aan de collega.',
  'quotations.priceRequest.mailQueued': 'De prijsaanvraag gaat zo naar {{to}}.',
  'quotations.priceRequest.madeNoMail':
    'De prijsaanvraag is bewaard, maar mailen lukte niet. Mail hem opnieuw onder Intern.',
  'quotations.priceRequest.downloadFailed': 'De prijsaanvraag kon niet gedownload worden.',
  'quotations.priceRequest.listTitle': 'Prijsaanvragen',
  'quotations.priceRequest.listHint':
    'Aan wie je een prijs vroeg. Intern: dit komt niet in de offerte en niet in de mail aan de klant.',
  'quotations.priceRequest.row': 't.a.v. {{contact}} · {{lines}} · gemaakt {{when}} door {{who}}',
  'quotations.priceRequest.rowOfVersion':
    't.a.v. {{contact}} · {{lines}} van versie {{version}} · gemaakt {{when}} door {{who}}',
  'quotations.priceRequest.notIn': 'Nog niet binnen.',
  'quotations.priceRequest.reply.paste': 'Antwoord plakken',
  'quotations.priceRequest.reply.change': 'Antwoord wijzigen',
  'quotations.priceRequest.reply.title': 'Antwoord van {{relation}}',
  'quotations.priceRequest.reply.intro':
    'Plak de mail van de collega, of de tekst uit zijn PDF. VHT zoekt de bedragen en telt ze op; jij bevestigt. Het antwoord blijft intern.',
  'quotations.priceRequest.reply.text': 'Antwoord',
  'quotations.priceRequest.reply.amounts': 'Bedragen in het antwoord',
  'quotations.priceRequest.reply.none':
    'Geen bedrag gevonden. Staat de prijs in een PDF? Plak dan de tekst uit de PDF, of vul de prijs zelf in.',
  'quotations.priceRequest.reply.kind.total': 'totaal',
  'quotations.priceRequest.reply.kind.rate': 'tarief, telt niet mee',
  'quotations.priceRequest.reply.kind.vat': 'inclusief btw, telt niet mee',
  'quotations.priceRequest.reply.amount': 'Prijs excl. btw',
  'quotations.priceRequest.reply.surcharge': 'Dieseltoeslag (%)',
  'quotations.priceRequest.reply.surchargeHint': 'Leeg als de toeslag in de prijs zit.',
  'quotations.priceRequest.reply.surchargeIncluded':
    'Volgens het antwoord zit de toeslag in de prijs.',
  'quotations.priceRequest.reply.surchargeNoPercent':
    'Het antwoord noemt een toeslag, maar geen percentage.',
  'quotations.priceRequest.reply.withSurcharge': 'Prijs met toeslag: {{total}}',
  'quotations.priceRequest.reply.confirm': 'Bevestigen',
  'quotations.priceRequest.reply.saved':
    'Het antwoord van {{relation}} staat bij de prijsaanvraag.',
  'quotations.priceRequest.reply.failed': 'Het antwoord kon niet bewaard worden.',
  'quotations.priceRequest.reply.row': 'Prijs {{amount}}, ingelezen {{when}} door {{who}}.',
  'quotations.priceRequest.reply.rowSurcharge':
    'Prijs {{amount}} + {{percent}}% toeslag = {{total}}, ingelezen {{when}} door {{who}}.',
  'quotations.priceRequest.choice.title': "Prijzen van collega's",
  'quotations.priceRequest.choice.none': 'Geen prijs gebruiken',
  'quotations.priceRequest.choice.price': 'Prijs',
  'quotations.priceRequest.choice.surcharge': 'Dieseltoeslag {{percent}}%',
  'quotations.priceRequest.choice.markup': 'Opslag {{percent}}%',
  'quotations.priceRequest.choice.final': 'Bedrag',
  'quotations.priceRequest.choice.hint':
    'Intern. Dit bedrag gaat niet vanzelf naar de prijs van een regel.',
  'quotations.priceRequest.choice.failed': 'De keuze kon niet bewaard worden.',
  'quotations.priceRequest.lineNumbers_one': 'regel {{list}}',
  'quotations.priceRequest.lineNumbers_other': 'regel {{list}}',
  'quotations.priceRequest.discard_one': 'De prijsaanvraag bij deze offerte gaat mee weg.',
  'quotations.priceRequest.discard_other':
    'De {{count}} prijsaanvragen bij deze offerte gaan mee weg.',
  // Mailen (§7): aan de contactpersoon met sales@ in bcc, of naar sales@, dat hem doorstuurt.
  'quotations.mail.button': 'Versie {{n}} mailen',
  'quotations.mail.again': 'Versie {{n}} opnieuw mailen',
  'quotations.mail.title': 'Versie {{n}} mailen?',
  'quotations.mail.to': 'Aan',
  'quotations.mail.for': 'Voor',
  'quotations.mail.attachment': 'Bijlage',
  'quotations.mail.replyTo': 'Antwoord naar',
  'quotations.mail.bcc': 'Bcc',
  'quotations.mail.bodyDirect':
    'De mail gaat naar {{to}}, met de offerte als bijlage, en {{bcc}} krijgt een kopie (bcc).',
  'quotations.mail.redirect':
    'In deze omgeving gaat elke mail naar {{to}}, met bovenaan voor wie hij bedoeld was.',
  'quotations.mail.body':
    'De mail gaat naar {{to}}, met de offerte als bijlage en bovenaan voor wie hij is. Stuur hem van daar door aan de klant.',
  'quotations.mail.dryRun': 'Proefstand: in deze omgeving wordt niet echt gemaild.',
  'quotations.mail.send': 'Mailen',
  'quotations.mail.sending': 'Bezig…',
  'quotations.mail.queuedToast': 'De offerte gaat zo naar {{to}}.',
  'quotations.mail.failedToast': 'Mailen lukte niet.',
  'quotations.mail.afterIssue': 'Na het uitbrengen mail je hem naar {{to}}, of download je de PDF.',
  'quotations.mail.afterIssueDirect':
    'Na het uitbrengen mail je hem aan de contactpersoon, met een kopie (bcc) aan {{bcc}}, of download je de PDF.',
  'quotations.mail.offAfterIssue':
    'Mailen is hier niet ingesteld: na het uitbrengen download je de PDF en mail je hem zelf.',
  'quotations.mail.off': 'Mailen is hier niet ingesteld: download de PDF en mail hem zelf.',
  'quotations.mail.dryRunNote':
    'Proefstand: de mail zou naar {{to}} gaan, maar er wordt niet echt gemaild.',
  'quotations.mail.goesTo': 'Gaat naar {{to}}; stuur hem van daar door aan {{name}}.',
  'quotations.mail.goesToDirect': 'Gaat naar {{to}}, met een kopie (bcc) aan {{bcc}}.',
  'quotations.mail.dryRunNoteDirect':
    'Proefstand: de mail zou naar {{to}} gaan, met een kopie (bcc) aan {{bcc}}, maar er wordt niet echt gemaild.',
  'quotations.mail.customer': 'de klant',
  'quotations.mail.status.QUEUED': 'Wordt verzonden',
  'quotations.mail.status.SENT': 'Verzonden',
  'quotations.mail.status.FAILED': 'Niet gelukt',
  'quotations.mail.status.NOT_SENT': 'Niet verstuurd',
  'quotations.mail.queued': 'De offerte gaat zo naar {{to}}.',
  'quotations.mail.sent': 'Om {{time}} gemaild aan {{to}}.',
  'quotations.mail.sentOn': 'Op {{date}} gemaild aan {{to}}.',
  'quotations.mail.failed':
    'De mail aan {{to}} lukte ook na meerdere pogingen niet. Download de PDF en mail hem zelf, en meld het bij beheer.',
  'quotations.mail.notSent.dry_run': 'Mailen staat in deze omgeving in proefstand.',
  'quotations.mail.notSent.mail_not_configured': 'Mailen is in deze omgeving niet ingericht.',
  'quotations.event.mailed': 'Versie {{version}} gemaild naar {{to}}',
  // Route en kaart (bouwlijst #5).
  'quotations.route.title': 'Route en CO₂',
  'quotations.route.hoisting': 'Hijswerk heeft geen route.',
  'quotations.route.off':
    'Calculeren staat in deze omgeving niet aan: HERE heeft hier geen sleutel.',
  'quotations.route.showCo2': 'CO₂-uitstoot in de offerte vermelden',
  'quotations.route.showCo2Hint':
    'Onder de kaart: “Geschatte CO₂-uitstoot van dit transport: … kg”. De berekening blijft intern.',
  'quotations.route.calculate': 'Calculeren',
  'quotations.route.again': 'Opnieuw calculeren',
  'quotations.route.calculating': 'Bezig…',
  'quotations.route.needPlaces': 'Vul eerst de plaats van laden en van lossen in.',
  'quotations.route.none': 'Nog niet gecalculeerd. Zonder route staat er geen kaart in de offerte.',
  'quotations.route.noneIssued': 'Zonder route uitgebracht: er staat geen kaart in de offerte.',
  'quotations.route.distance': 'Afstand',
  'quotations.route.km': '{{km}} km',
  'quotations.route.duration': 'Rijtijd',
  'quotations.route.hours': '{{time}} uur',
  'quotations.route.toll': 'Tol · hele rit',
  'quotations.route.tollIn': 'Tol {{country}} · hele rit',
  'quotations.route.noToll': 'geen',
  'quotations.route.kg': '{{kg}} kg',
  'quotations.route.found':
    'Laden: {{from}} ({{fromPrecision}}). Lossen: {{to}} ({{toPrecision}}).',
  'quotations.route.precision.houseNumber': 'adres',
  'quotations.route.precision.street': 'straat',
  'quotations.route.precision.postalCodePoint': 'postcode',
  'quotations.route.precision.locality': 'alleen de plaats',
  'quotations.route.precision.intersection': 'kruispunt',
  'quotations.route.precision.place': 'locatie',
  'quotations.route.precision.administrativeArea': 'alleen het gebied',
  'quotations.route.vehicle.trekker-oplegger-40t-5as-euro6':
    'trekker met oplegger, 40 t, 5 assen, Euro 6',
  'quotations.route.made':
    'Vrachtwagen: {{vehicle}}, heen en terug vanaf {{depot}}. Berekend {{when}} door {{who}}, in versie {{version}}. Een voorstel voor de calculatie, geen prijs. In de offerte komen alleen de kaart en de kilometers van de geladen rit.',
  'quotations.route.co2How':
    'CO₂: {{tons}} t × {{km}} km × {{factor}} kg per ton-km ({{name}}, well-to-wheel, emissiefactoren.nl {{year}}). Alleen de geladen rit; het gewicht komt uit de artikelen die geen optie zijn.',
  'quotations.route.co2NoFactor':
    'Geen CO₂: Brandstof › Emissiefactoren heeft geen factor voor deze vrachtwagen.',
  'quotations.route.co2NoWeight': 'Geen CO₂: er staat nog geen gewicht in de artikelen.',
  'quotations.route.stale':
    'Laden, lossen of de vrachtwagen is gewijzigd na het calculeren. Calculeer opnieuw, anders kloppen de kaart en de tol niet.',
  'quotations.route.remove': 'Route weghalen (dan geen kaart in de offerte)',
  'quotations.route.exceptional': 'Exceptioneel transport',
  'quotations.route.exceptionalHint':
    'HERE rekent met de gekozen vrachtwagen, niet met de vergunde route. De offerte krijgt de tekst dat de route een indicatie is (stap 3).',
  'quotations.route.exceptionalChip': 'exceptioneel',
  'quotations.route.error.LOAD_NOT_FOUND':
    'HERE vindt de laadplaats niet. Kijk straat, postcode, plaats en land na.',
  'quotations.route.error.UNLOAD_NOT_FOUND':
    'HERE vindt de losplaats niet. Kijk straat, postcode, plaats en land na.',
  'quotations.route.error.LOAD_INCOMPLETE': 'Vul eerst de plaats van laden in.',
  'quotations.route.error.UNLOAD_INCOMPLETE': 'Vul eerst de plaats van lossen in.',
  'quotations.route.error.NO_ROUTE':
    'HERE vindt geen route voor een vrachtwagen tussen deze plaatsen.',
  'quotations.route.error.ROUTE_OFF': 'Calculeren staat in deze omgeving niet aan.',
  'quotations.route.error.other':
    'Calculeren lukte niet: HERE is nu niet bereikbaar. Probeer het straks opnieuw.',
  'quotations.textHint.exceptional': 'Komt in de offerte omdat een regel exceptioneel is (stap 4).',
  'quotations.issue.routeStale':
    'calculeer de route opnieuw: laden, lossen of de vrachtwagen is gewijzigd.',
  'quotations.issue.exceptionalText': 'vul de tekst bij exceptioneel transport in.',
  'quotations.event.route':
    'Route berekend in versie {{version}}, regel {{line}}: {{from}} → {{to}}, {{km}} km',
  'quotations.route.co2Loaded': 'CO₂ · geladen rit',
  'quotations.route.leg': 'Deel van de rit',
  'quotations.route.legs.approach': 'Aanrijden',
  'quotations.route.legs.loaded': 'Geladen rit (in de offerte)',
  'quotations.route.legs.return': 'Terug',
  'quotations.route.total': 'Hele rit',
  'quotations.route.home': 'Hoevelaken',
  'quotations.route.adjust': 'Aanpassen',
  'quotations.route.adjustOf.approach': 'Aanrijden aanpassen',
  'quotations.route.adjustOf.return': 'Terug aanpassen',
  'quotations.route.byHere': 'HERE: {{value}}',
  'quotations.route.adjustHint':
    'Aanpassen, voor aanrijden en terug: met 50% rekent die rit met de helft van de kilometers en de rijtijd (bijvoorbeeld als de wagen halverwege leeg komt van een andere rit); met een tijd als 3:00 rekent hij met die rijtijd, en blijven de kilometers die van HERE. De tol verandert niet mee.',
  'quotations.route.tollWhere': 'Tol',
  'quotations.route.tollLeg.approach': 'Aanrijden',
  'quotations.route.tollLeg.loaded': 'Geladen rit',
  'quotations.route.tollLeg.return': 'Terug',
  'quotations.route.tollTotal': 'Totaal tol',
  'quotations.route.tollOld':
    'Deze route is berekend voordat VHT de tol per deel van de rit bewaarde. Calculeer opnieuw om te zien waar de tol betaald wordt.',
  'quotations.route.tollHow':
    'Zo rekent HERE de tol: voor {{truck}}, per tolweg de goedkoopste manier van betalen, met de tarieven van {{when}}. Aanrijden en terug tellen mee, dus een tolweg op de heen- en de terugweg staat er twee keer in. De tol komt niet in de offerte.',
  // Vrachtwagens, laad- en lostijd (bouwlijst #5).
  'quotationLists.tab.truckTypes': 'Vrachtwagens',
  'quotationLists.searchPlaceholder.truckTypes': 'Zoek op naam',
  'quotationLists.new.truckTypes': 'Nieuwe vrachtwagen',
  'quotationLists.editTitle.truckTypes': 'Vrachtwagen wijzigen',
  'quotationLists.empty.truckTypes': 'Nog geen vrachtwagens',
  'quotationLists.col.truckKind': 'Soort',
  'quotationLists.col.grossWeight': 'Gewicht',
  'quotationLists.col.axles': 'Assen',
  'quotationLists.col.euro': 'Euro',
  'quotationLists.col.co2Factor': 'CO₂-factor',
  'quotationLists.truckKind.TRACTOR': 'trekker',
  'quotationLists.truckKind.STRAIGHT_TRUCK': 'bakwagen',
  'quotationLists.truckKindName.TRACTOR': 'Trekker (met oplegger)',
  'quotationLists.truckKindName.STRAIGHT_TRUCK': 'Bakwagen',
  'quotationLists.field.truck.kind': 'Soort',
  'quotationLists.field.truck.weight': 'Totaalgewicht (kg)',
  'quotationLists.field.truck.axles': 'Assen',
  'quotationLists.field.truck.trailers': 'Aanhangers',
  'quotationLists.field.truck.euro': 'Euroklasse',
  'quotationLists.field.truck.height': 'Hoogte (m)',
  'quotationLists.field.truck.width': 'Breedte (m)',
  'quotationLists.field.truck.length': 'Lengte (m)',
  'quotationLists.field.truck.weightHint':
    'Het gewicht met oplegger en lading, en de assen van de hele combinatie: daar hangen route en tol van af. Een oplegger telt als aanhanger.',
  'quotationLists.field.truck.sizesHint':
    'Mag leeg. Ingevuld rijdt HERE niet onder een brug of door een tunnel waar de vrachtwagen niet past.',
  'quotationLists.field.truck.co2Factor': 'CO₂-factor',
  'quotationLists.field.truck.co2FactorHint':
    'Uit Brandstof › Emissiefactoren, per ton-km. Hiermee rekent de offerte de CO₂ van de geladen rit.',
  'quotationLists.field.truck.isDefault':
    'Standaard: hiermee rekent een regel die nog geen vrachtwagen koos',
  'quotationLists.factorOption': '{{name}} — {{factor}} kg per ton-km ({{year}})',
  'quotationLists.duplicateTruck': 'Er staat al een vrachtwagen met deze naam in de lijst.',
  'quotationLists.invalidTruck':
    'Vul een naam in, een gewicht van 1.000 tot 300.000 kg, 2 tot 20 assen en 0 tot 5 aanhangers. Een hoogte of breedte is 1 tot 6 m, een lengte 3 tot 60 m, of leeg.',
  'quotationLists.filterSource': 'Herkomst',
  'quotationLists.source.TALIS': 'TALIS',
  'quotationLists.source.VHT': 'VHT',
  'quotationLists.col.source': 'Herkomst',
  'quotationLists.talis.none':
    'Er zijn nog geen artikelen uit TALIS ontvangen. Zodra de koppeling via DataBridge aan staat, komen ze elk uur binnen; tot dan staan hier alleen de artikelen van VHT.',
  'quotationLists.talis.last_one': 'Laatst bijgewerkt uit TALIS: {{when}} · {{count}} artikel',
  'quotationLists.talis.last_other': 'Laatst bijgewerkt uit TALIS: {{when}} · {{count}} artikelen',
  'quotationLists.talis.vht_one': '{{count}} van VHT',
  'quotationLists.talis.vht_other': '{{count}} van VHT',
  'quotationLists.talis.rejected':
    'De laatste levering uit TALIS ({{when}}) is geweigerd. De artikelen staan zoals ze daarvoor waren.',
  'quotationLists.codeInTalis':
    'Er staat ook een artikel met deze code uit TALIS. Dat mag, maar dan staat de code twee keer in de kiezer.',
  'quotationLists.talisArticleTitle': 'Artikel uit TALIS',
  'quotationLists.talisReadOnly':
    'Dit artikel komt uit TALIS en is hier alleen te lezen. Wijzigen doe je in TALIS; de koppeling neemt het binnen het uur over. In een offerte pas je de maten per regel aan.',
  'quotationLists.talisInactive':
    'Dit artikel staat niet meer in TALIS, of is daar historisch, en is daarom niet te kiezen in een nieuwe offerte. Een offerte die het al heeft, houdt het.',
  'quotationLists.field.wmsClient': 'Klant (WMS)',
  'quotationLists.field.articleGroup': 'Artikelgroep',
  'quotationLists.field.lastReceived': 'Laatst ontvangen',
  'quotationLists.importAlsoInTalis': 'Ook in TALIS',
  'quotationLists.importAlsoInTalisNote_one':
    '{{count}} nieuw artikel heeft de code van een artikel uit TALIS. Dat mag, maar dan staat die code twee keer in de kiezer.',
  'quotationLists.importAlsoInTalisNote_other':
    '{{count}} nieuwe artikelen hebben de code van een artikel uit TALIS. Dat mag, maar dan staan die codes twee keer in de kiezer.',
  'quotations.moreArticles_one': 'Nog {{count}} artikel: typ verder om te zoeken.',
  'quotations.moreArticles_other': 'Nog {{count}} artikelen: typ verder om te zoeken.',
  'quotations.event.createdFromRequest': 'Offerte aangemaakt uit een aanvraag',
  'quotations.read.title': 'Nieuwe offerte',
  'quotations.read.sub':
    'Plak de aanvraag van de klant. VHT vult in wat het herkent; jij kijkt het na en maakt dan het concept.',
  'quotations.read.requestTitle': 'Aanvraag van de klant',
  'quotations.read.requestSub': 'Gelezen in VHT; er gaat niets naar buiten',
  'quotations.read.pasteLabel': 'Plak de mail van de klant',
  'quotations.read.pastePlaceholder': 'Graag ontvang ik een prijs voor transport vanaf …',
  'quotations.read.read': 'Lezen',
  'quotations.read.reading': 'Lezen…',
  'quotations.read.readFailed': 'Lezen lukte niet. Probeer het opnieuw.',
  'quotations.read.otherRequest': 'Andere aanvraag',
  'quotations.read.rereadHint': 'Opnieuw lezen vervangt wat je hiernaast aanpaste.',
  'quotations.read.markedWord': 'gemarkeerd',
  'quotations.read.struckWord': 'doorgestreept',
  'quotations.read.legendTaken': 'overgenomen',
  'quotations.read.legendSkipped': 'herkend, niet overgenomen',
  'quotations.read.kept':
    'Wordt bewaard bij de offerte, onder Intern. Komt niet in de offerte en niet in een mail.',
  'quotations.read.emptyTitle': 'Nog niets gelezen',
  'quotations.read.emptyText':
    'Plak de aanvraag in het veld Aanvraag van de klant en klik Lezen. Wat VHT herkent, staat dan hier om na te kijken.',
  'quotations.read.withoutRequest': 'Zonder aanvraag beginnen',
  'quotations.read.card.customer': 'Klant',
  'quotations.read.card.places.TRANSPORT': 'Laden en lossen',
  'quotations.read.card.places.HOISTING': 'Lossen',
  'quotations.read.card.placesSub.TRANSPORT': 'Waar het vandaan komt en waar het heen gaat',
  'quotations.read.card.placesSub.HOISTING': 'Waar gehesen wordt',
  'quotations.read.card.cargo': 'Lading',
  'quotations.read.card.cargoSub': 'Het artikel, met de maten en het gewicht van deze offerte',
  'quotations.read.card.lines': 'Regels',
  'quotations.read.card.linesSub': 'Wat de werkbank krijgt',
  'quotations.read.card.skipped': 'Niet overgenomen',
  'quotations.read.card.skippedSub': 'Herkend in de aanvraag, maar bewust niet in de offerte',
  'quotations.read.skip.date': 'De datum is aan de planning.',
  'quotations.read.source.REQUEST': 'Uit de aanvraag.',
  'quotations.read.source.VHT': 'Uit VHT.',
  'quotations.read.source.ASSUMED': 'Aangenomen.',
  'quotations.read.source.MISSING': 'Niet gevonden.',
  'quotations.read.source.USER': 'Aangepast.',
  'quotations.read.note.user': 'Door jou, na het lezen.',
  'quotations.read.note.quoted': '“{{text}}”.',
  'quotations.read.note.relationNotFound': 'Kies de relatie, of maak een prospect.',
  'quotations.read.note.relationByContact': '{{email}} is contactpersoon bij {{relation}}.',
  'quotations.read.note.relationByDomain': 'Het e-maildomein {{domain}} hoort bij {{relation}}.',
  'quotations.read.note.relationByName': 'De naam “{{name}}” staat in de aanvraag.',
  'quotations.read.note.contactNoSender': 'Geen afzender gevonden.',
  'quotations.read.note.contactSender': 'De afzender, {{email}}.',
  'quotations.read.note.contactSameName': '{{name}} staat al bij {{relation}}.',
  'quotations.read.note.contactNew':
    '{{name}} staat nog niet bij {{relation}}. Naam, telefoon en e-mail uit de handtekening.',
  'quotations.read.note.contactNewNoRelation':
    '{{name}}, uit de handtekening. Kies eerst de relatie.',
  'quotations.read.note.typeWord': 'Er staat “{{word}}” in de aanvraag.',
  'quotations.read.note.typeAssumed': 'Niets over het soort werk; transport aangenomen.',
  'quotations.read.note.referenceNone': 'Geen referentie in de aanvraag.',
  'quotations.read.note.quantityAssumed': 'Geen aantal genoemd; één aangenomen.',
  'quotations.read.note.sizesReadAsMm': '{{max}} {{unit}} kan niet, dus millimeters.',
  'quotations.read.note.sizesReadAsCm': '{{max}} {{unit}} kan niet, dus centimeters.',
  'quotations.read.note.sizesSameAsArticle': 'Gelijk aan het artikel.',
  'quotations.read.note.sizesDifferFromArticle': 'Wijkt af van het artikel ({{sizes}}).',
  'quotations.read.note.sizesNotFound': 'Geen maten gevonden.',
  'quotations.read.note.weightNotFound': 'Geen gewicht gevonden.',
  'quotations.read.note.fromArticle': 'Van het artikel {{code}}.',
  'quotations.read.note.fromArticlePerPiece': 'Van het artikel {{code}}, per stuk.',
  'quotations.read.note.articleNotFound': 'Kies het artikel.',
  'quotations.read.note.articleCode': 'De code {{code}} staat in de aanvraag.',
  'quotations.read.note.articleCodeTwice':
    'De code {{code}} staat {{count}} keer in de lijst; kijk of dit de goede is.',
  'quotations.read.note.articleClientWeight':
    '{{client}} heeft {{count}} artikelen; alleen dit weegt {{kg}} kg.',
  'quotations.read.note.articleClientNearest':
    '{{client}} heeft {{count}} artikelen; dit weegt het dichtst bij {{kg}} kg.',
  'quotations.read.note.articleWords': 'Gekozen op de omschrijving; kijk of dit het goede is.',
  'quotations.read.note.placeNotFound': 'Niet gevonden in de aanvraag.',
  'quotations.read.note.placeAddressIsFixed': 'Vast adres: zelfde straat en plaats als “{{text}}”.',
  'quotations.read.note.placeAddress': 'Het adres staat in de aanvraag.',
  'quotations.read.note.placeFixed': 'Vast adres; in de aanvraag staat “{{text}}”.',
  'quotations.read.note.placeClientsOnly':
    'Het enige vaste adres van {{client}}; in de aanvraag staat “{{text}}”.',
  'quotations.read.note.placeCentre':
    'Alleen een plaats, dus het centrum van {{city}} ({{country}}).',
  'quotations.read.note.placeUnknown': 'Onbekende plaats “{{text}}”; kijk plaats en land na.',
  'quotations.read.note.craneBoth': '“{{text}}”: twee regels, de tweede met kraan en optioneel.',
  'quotations.read.note.craneNone': 'Geen kraan genoemd.',
  'quotations.read.note.craneAtAssumed': 'Niet gezegd waar; bij lossen aangenomen.',
  'quotations.read.mark.relation': 'relatie',
  'quotations.read.mark.contact': 'contactpersoon',
  'quotations.read.mark.type': 'type',
  'quotations.read.mark.reference': 'referentie',
  'quotations.read.mark.article': 'artikel',
  'quotations.read.mark.quantity': 'aantal',
  'quotations.read.mark.sizes': 'maten',
  'quotations.read.mark.weight': 'gewicht',
  'quotations.read.mark.load': 'laden',
  'quotations.read.mark.unload': 'lossen',
  'quotations.read.mark.crane': 'kraan',
  'quotations.read.mark.date': 'niet overgenomen',
  'quotations.read.field.relationId': 'Relatie',
  'quotations.read.field.contact': 'Contactpersoon',
  'quotations.read.field.type': 'Type',
  'quotations.read.field.reference': 'Referentie',
  'quotations.read.field.articleId': 'Artikel',
  'quotations.read.field.quantity': 'Aantal',
  'quotations.read.field.sizes': 'Maten',
  'quotations.read.field.weightKg': 'Gewicht',
  'quotations.read.field.load': 'Laden',
  'quotations.read.field.unload': 'Lossen',
  'quotations.read.field.crane': 'Kraan',
  'quotations.read.field.craneAt': 'Kraan bij',
  'quotations.read.newContact': 'Nieuw: {{name}}',
  'quotations.read.newContactHint':
    'Komt bij {{relation}} als contactpersoon van VHT. Staat hij in TALIS, dan liever daar.',
  'quotations.read.theRelation': 'de relatie',
  'quotations.read.craneLabel': 'Kraan',
  'quotations.read.crane.NONE': 'Geen kraan',
  'quotations.read.crane.WITH': 'Met kraan',
  'quotations.read.crane.BOTH': 'Met en zonder',
  'quotations.read.craneAtLabel': 'Kraan bij',
  'quotations.read.craneAt.LOAD': 'Laden',
  'quotations.read.craneAt.UNLOAD': 'Lossen',
  'quotations.read.at.LOAD': 'laden',
  'quotations.read.at.UNLOAD': 'lossen',
  'quotations.read.craneType': 'Kraantype',
  'quotations.read.craneTypeLater': 'Later kiezen, in de werkbank',
  'quotations.read.craneTypeHint': 'De aanvraag zegt niet welke kraan; dat bepaal jij.',
  'quotations.read.lineWithout': 'zonder kraan',
  'quotations.read.lineWith': 'met kraan bij {{at}}',
  'quotations.read.ownPrice': 'eigen prijs',
  'quotations.read.noArticle': 'artikel nog kiezen',
  'quotations.read.bothHint':
    'Met en zonder kraan zijn twee regels: de eerste zonder kraan, de tweede met kraan en optioneel, elk met een eigen prijs. Zo ziet de klant het verschil.',
  'quotations.read.assumedCount_one': 'Eén veld is aangenomen. Kijk het na; het staat geel.',
  'quotations.read.assumedCount_other':
    '{{count}} velden zijn aangenomen. Kijk ze na; ze staan geel.',
  'quotations.read.create': 'Concept maken',
  'quotations.read.creating': 'Concept maken…',
  'quotations.read.noPrices': 'VHT stelt geen prijzen voor en brengt niets uit.',
  'quotations.read.created': 'Concept {{number}} gemaakt uit de aanvraag. Vul de prijzen in.',
  'quotations.read.createFailed': 'Het concept maken lukte niet. Probeer het opnieuw.',
  'quotations.read.intake': 'Ingevuld uit de aanvraag.',
  'quotations.read.intakeOf': 'Ingevuld uit de aanvraag van {{relation}}.',
  'quotations.read.intakeContact': '{{name}} is als contactpersoon toegevoegd.',
  'quotations.read.intakeIntern': 'De aanvraag zelf staat onder Intern.',
  'quotations.read.intakeCheck': 'Kijk na wat aangenomen is:',
  'quotations.read.intakeOk': 'Begrepen',
  'quotations.read.internTitle': 'Aanvraag van de klant',
  'quotations.read.internHint':
    'Geplakt door {{who}}, {{when}}. Bewaard bij de offerte, in plaats van alleen in de mail. Komt niet in de offerte en niet in een mail.',
  'quotations.guide.title': 'Hulp bij deze offerte',
  'quotations.guide.progress': '{{done}} van {{count}} klaar',
  'quotations.guide.now': 'nu: {{step}}',
  'quotations.guide.doneRow': 'Klaar: {{steps}}',
  'quotations.guide.showAll': 'alles tonen',
  'quotations.guide.showLess': 'Minder tonen',
  'quotations.guide.more_one': 'en nog {{count}}',
  'quotations.guide.more_other': 'en nog {{count}}',
  'quotations.guide.goTo': 'Ga naar {{step}}',
  'quotations.guide.stillToDo_one': 'Nog één ding te doen; de hulp zegt wat.',
  'quotations.guide.stillToDo_other': 'Nog {{count}} dingen te doen; de hulp zegt welke.',
  'quotations.guide.step.request': 'Aanvraag',
  'quotations.guide.step.customer': 'Klant',
  'quotations.guide.step.places.TRANSPORT': 'Laden en lossen',
  'quotations.guide.step.places.HOISTING': 'Lossen',
  'quotations.guide.step.cargo': 'Lading',
  'quotations.guide.step.crane': 'Kraan',
  'quotations.guide.step.ask': 'Prijs opvragen bij een collega',
  'quotations.guide.step.route': 'Calculeren',
  'quotations.guide.step.prices': 'Prijzen',
  'quotations.guide.step.texts': 'Tekst',
  'quotations.guide.step.issue': 'Controleren en uitbrengen',
  'quotations.guide.note.request': 'Gelezen, en bewaard onder Intern.',
  'quotations.guide.note.noRequest': 'Zonder aanvraag begonnen.',
  'quotations.guide.note.requestNow': 'Kijk het voorstel na, en maak het concept.',
  'quotations.guide.note.customer': '{{relation}}, t.a.v. {{contact}}.',
  'quotations.guide.note.customerShort': '{{relation}}',
  'quotations.guide.note.places': '{{trips}}.',
  'quotations.guide.note.cargo': '{{articles}}.',
  'quotations.guide.note.cargoLines': '{{articles}}, op {{lines}} regels.',
  'quotations.guide.note.noCrane': 'Geen kraan in deze offerte.',
  'quotations.guide.note.crane': '{{cranes}}.',
  'quotations.guide.note.askNone': 'Rijdt een collega het, vraag dan eerst zijn prijs.',
  'quotations.guide.note.askOpen':
    'Nog niet binnen: {{relations}}. Plak het antwoord onder Intern.',
  'quotations.guide.note.askChoose': 'De prijzen zijn binnen. Kies er één onder Calculatie.',
  'quotations.guide.note.askChosen': 'Gerekend met de prijs van {{relation}}.',
  'quotations.guide.note.noRoute': 'Hijswerk heeft geen route.',
  'quotations.guide.note.routeOff': 'Calculeren kan hier niet: HERE staat uit.',
  'quotations.guide.note.calculate': 'Calculeer de route: kilometers, rijtijd en tol.',
  'quotations.guide.note.calculateLines':
    'Calculeer regel {{lines, list}}: kilometers, rijtijd en tol.',
  'quotations.guide.note.route': 'Route en tol berekend.',
  'quotations.guide.note.prices': 'Ingevuld.',
  'quotations.guide.note.pricesLines': 'Elke regel heeft een eigen prijs.',
  'quotations.guide.note.pricesLinesLater': 'In de werkbank: een eigen prijs voor elke regel.',
  'quotations.guide.note.texts': 'De standaardteksten staan erin; pas ze aan als het moet.',
  'quotations.guide.note.textsDefault': 'De standaardteksten staan er al in.',
  'quotations.guide.note.issue': 'Kijk het vel na. Daarna ligt de versie vast.',
  'quotations.guide.note.later': 'In de werkbank.',
  'quotations.route.truck': 'Vrachtwagen',
  'quotations.route.noTrucks': 'Geen vrachtwagens in Offertelijsten',
  'quotations.route.truckSpec': '{{kind}}, {{weight}} t, {{axles}} assen, Euro {{euro}}',
  'quotations.route.loadTime': 'Laadtijd (uur)',
  'quotations.route.unloadTime': 'Lostijd (uur)',
  'quotations.route.timesHint':
    'Laad- en lostijd tellen mee in de tijd van de hele rit; opnieuw calculeren hoeft daarvoor niet. Typ 2, 1,5 of 1:30. Een andere vrachtwagen vraagt wel opnieuw calculeren: route en tol hangen ervan af.',
  'quotations.route.legs.load': 'Laden',
  'quotations.route.legs.unload': 'Lossen',
  'quotations.route.error.NO_TRUCK':
    'Er staat geen vrachtwagen in Offertelijsten om mee te rekenen.',
} as const;
